{
  "accessibility": {
    "closeModal": "Cerrar el modal",
    "useSetting": "Utilizar configuración",
    "srOnly": {
      "close": "Cerrar",
      "loading": "Cargando…"
    }
  },
  "account": {
    "salesResources": {
      "title": "Recursos de Ventas",
      "searchDocuments": "Buscar documentos",
      "minimalRating": "Valoración mínima",
      "maxRating": "Valoración máxima"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Habilite la refacturación para este cliente para obtener hasta 10 veces más beneficios en el uso de teléfono, correos electrónicos, automatizaciones, etc.",
      "enableRebilling": "Habilitar la refacturación",
      "servicesActivateAfterPayment": "Los servicios de refacturación estarán activos después de que el cliente añada un método de pago. Hasta entonces, el acceso a la cuenta del cliente estará restringido.",
      "cannotModifyOnHold": "No se pueden modificar las configuraciones de refacturación, ya que esta cuenta ya tiene un plan SaaS en espera. Los márgenes de refacturación se configurarán según el plan cuando el cliente añada un método de pago.",
      "rebillingSettings": "Configuración de refacturación"
    }
  },
  "affiliates": {
    "aboutMe": "Acerca de mí",
    "error": {
      "unableToSend": "No se puede enviar el correo electrónico"
    },
    "industriesServed": "Industrias servidas",
    "sendAMessage": "Enviar un mensaje",
    "sendMessageIntro": "Envíe un mensaje para presentarse a este asesor. Incluya detalles sobre usted y los servicios que busca.",
    "socialSites": "Redes sociales",
    "success": {
      "emailSent": "Correo electrónico enviado correctamente"
    },
    "validationErrors": {
      "validEmail": "Proporcione un correo electrónico válido.",
      "validMessage": "Proporcione un mensaje válido.",
      "validName": "Proporciones un nombre válido."
    },
    "yearsInBusiness": "Años en el negocio",
    "yourEmail": "Su correo electrónico",
    "yourName": "Su nombre",
    "paymentDetailsAccessMessage": " Esta sección de detalles de pago solo es accesible y editable por el <strong>propietario de la agencia</strong>. Si necesita asistencia, contacte con el <strong>propietario de su agencia ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Insignia de socio",
    "photoAlt": "Foto de socio",
    "defaultCompany": "Ninguna empresa",
    "moreServices": "+ {count} más servicios"
  },
  "agency": {
    "saas": {
      "saasMode": "Modo SaaS",
      "pendingPaymentInformation": "Información sobre pagos pendientes",
      "customerId": "ID de cliente",
      "noPaymentMethods": "Parece que no se han añadido métodos de pago. Por favor, agregue un método de pago para activar el modo SaaS",
      "enableSaasDescription": "Habilite SaaS en esta ubicación para crear suscripciones, refacturar el uso del teléfono y el correo electrónico",
      "missingEmailAddress": "Falta la dirección de correo electrónico de la cuenta, añada los detalles primero.",
      "toConvertToSaaS": "Para convertir esta cuenta a SaaS, primero debe añadir un administrador de ubicación y volver a intentarlo",
      "newUser": "Crear Nuevo Usuario",
      "stripeCustomerConnected": "¡Cliente de Stripe conectado con éxito!",
      "requestClientPaymentDetails": "Solicitar la información de pago del cliente",
      "saasLocationDescription": "Las ubicaciones en modo SaaS necesitan la tarjeta de crédito de su cliente para funcionar. Puede solicitarlas enviando un correo electrónico, un mensaje de texto o compartiendo una URL",
      "selectSpace": "Seleccione un espacio para continuar",
      "spaceDescription": "El espacio que seleccione aquí se utilizará para almacenar la información de este cliente, procesar sus pagos y gestionar sus suscripciones.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Cuando un usuario se registra, puede ofrecerle créditos gratuitos para usar los servicios de correo electrónico y telefonía.",
      "thatAboutMinsInCalls": "Eso equivale a aproximadamente {count} mensajes de texto o {count1} minutos en llamadas",
      "subscriptionSettings": "Ajustes de la suscripción",
      "toUpgradeOrCancelPlan": "Para actualizar o cancelar el plan",
      "allowClientUpgrade": "Permitir que el cliente (subcuenta) actualice a un plan superior.",
      "addNewPlanFeatures": "Añade las funciones del nuevo plan al actualizarlo",
      "upgradeFeatureDescription": "Al actualizar a un plan superior, las subcuentas tendrán acceso a las funciones adicionales del nuevo plan. acceso a las funciones adicionales del nuevo plan.",
      "allowClientCancel": "Permitir que el cliente (subcuenta) cancele su suscripción.",
      "snapshotDescription": "La instantánea seleccionada se añadirá automáticamente a la nueva ubicación de SaaS",
      "ownSnapshots": "Instantáneas propias",
      "selectAndContinue": "Seleccionar y continuar"
    },
    "advancedSettings": {
      "controlLocationSettings": "Controlar los ajustes de localización",
      "disableAddSmtp": "Desactivar el botón «Añadir servicio de correo electrónico» en la configuración del servicio de correo electrónico de la subcuenta",
      "disableAddSmtpDescription": "Restringir a los usuarios de subcuentas la posibilidad de añadir su propio proveedor de servicio de correo electrónico",
      "enableReVerification": "Habilitar la reverificación durante 90 días",
      "lcEmailNotEnabled": "La ubicación no tiene LeadConnector como proveedor de correo electrónico predeterminado",
      "onlyVisibleForAgency": "Solo usted puede ver esta configuración habilitada para la agencia",
      "reVerificationDescription": "Cada estado de verificación de correo electrónico se revocará transcurridos 90 días (proteja su reputación de remitente y garantice la máxima entregabilidad en la bandeja de entrada)",
      "account": {
        "accountDetails": "Detalles de la cuenta",
        "advancedEmailSettings": "Configuración avanzada de correo electrónico",
        "hipaa": "HIPAA",
        "hipaaCompliant": "Conformidad con HIPAA",
        "smsEmailLimits": "Límites de SMS y correo electrónico",
        "socialProfiles": "Perfiles de redes sociales",
        "subscribed": "Suscrito"
      },
      "activityTracking": {
        "history": "Historial"
      },
      "addAccount": {
        "accountInfo": "Información de la cuenta",
        "accountSnapshots": "Instantáneas de la cuenta",
        "businessNiche": "Nicho de negocio",
        "chooseBusinessNiche": "Seleccionar un nicho de negocio…",
        "pickSnapshot": "Seleccione una instantánea",
        "selectSnapshot": "Seleccionar instantánea",
        "title": "Añadir subcuenta",
        "accountInfo1": "Información de la cuenta"
      },
      "addBalance": {
        "addBalanceToWallet": "Añadir saldo al monedero",
        "addMoneyToWallet": "Añadir dinero al monedero",
        "balanceAddedSuccessfully": "Saldo añadido correctamente",
        "cardWillBeCharged": "Se cargará a la tarjeta que termina en {cardNumber}",
        "complimentaryCredits": "Créditos de cortesía ({credits})",
        "creditsRemovedByAgency": "Créditos eliminados por la agencia",
        "currentBalance": "Saldo actual",
        "customerCCWillNotBeCharged": "No se cargará en la tarjeta de crédito del cliente",
        "moneyWillBeAddedToWallet": "Se añadirá dinero al monedero",
        "pleaseProvideAmountBetween": "Por favor, proporcione una cantidad entre {min} y {max}",
        "processing": "Procesando",
        "removeBalance": "Borrar saldo",
        "transactionSuccessful": "Transacción correcta",
        "walletBalance": "Saldo del monedero ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Añadiendo...",
        "cardDetails": "Información de la tarjeta",
        "cardSuccessfullyAdded": "Tarjeta añadida correctamente",
        "errorWhileAddingCard": "No se ha podido añadir la tarjeta nueva",
        "maximumCardUpdateLimitReached": "Se ha alcanzado el límite máximo de actualización de tarjeta",
        "rateLimitMessage": "Parece que ha alcanzado el número máximo de intentos permitidos para añadir tarjetas hoy. Vuelva a intentarlo pasadas 24 horas."
      },
      "aiProductRebilling": {
        "funnel": " embudo",
        "images": " Imágenes,",
        "per1000Words": " /1000 palabras, ",
        "perFunnel": " /embudo",
        "perImage": " /imagen,",
        "pleaseCheckSupport": "consulte nuestro",
        "ratesMayDiffer": "Las tarifas pueden diferir según la región. Los cálculos mostrados son por las tarifas para el Reino Unido,",
        "ratesMayDifferUS": "Las tarifas pueden diferir según la región. Los cálculos se muestran según las tarifas de Twilio para EE. UU; consulte Twilio para obtener más detalles.",
        "pleaseCheckTwilioRates": "Los SMS salientes para EE. UU. y Canadá se cobrarán a 0,0079 $ por segmento. SMS entrantes a 0,0075 $/segmento",
        "words": " palabras, "
      },
      "api": {
        "advancedFunctionalityNote": "Nota de funcionalidad avanzada",
        "agencyApiKeys": "Claves API de agencia",
        "apiAccess": {
          "partOfAdvancedApi": "Esto forma parte de la API avanzada que está disponible en el plan Pro.",
          "toUpgrade": "para mejorar."
        },
        "createNew": "Crear nuevo",
        "developerCouncilInfo": "Información del Consejo de desarrolladores",
        "noAccess": "No tiene acceso a esta sección.",
        "securityAlert": "Mensaje de alerta de seguridad",
        "table": {
          "fetchingKeys": "Obteniendo claves de la empresa...",
          "noKeysYet": "Todavía no tiene ninguna clave API.",
          "toCreateFirstKeys": "para generar sus primeras claves API."
        },
        "zapierNote": "Nota de Zapier"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Posibilidad de seleccionar calendarios de Google para «Añadir a» y calendarios de «Conflicto» para verificar y calcular la disponibilidad de cada usuario",
        "abilityToAllocateRoundRobin": "Capacidad para asignar citas en rotación",
        "abilityToChooseSpecificUser": "Capacidad para elegir a un usuario específico con el que se va a reservar la cita",
        "adminAbilitySeeEveryUser": "Administrador - Capacidad para ver las citas del calendario de cada usuario",
        "adminAbilityViewAllCalendar": "Administrador - Capacidad para ver las citas del calendario de todos los usuarios",
        "adminsCanDeleteIntegrations": "Los administradores pueden borrar cualquier integración que deseen, pero los usuarios solo pueden borrar las suyas propias",
        "adminsCanSeeAllIntegrations": "Los administradores pueden ver todas las integraciones independientemente de quién las haya creado, pero los usuarios pueden ver las integraciones que ellos mismos crearon",
        "contactDetailAppointments": "Detalle de contacto > Citas (nuevo)",
        "conversationsScheduleAppointment": "Conversaciones > Programar cita (nuevo)",
        "essentialConsiderations": "Consideraciones clave",
        "funnelsWebsitesCalendar": "Embudos/sitios web > Calendario (nuevo)",
        "helpReorientTriggers": "Durante la llamada, le ayudaremos a reorientar los activadores para adaptarlos a la nueva configuración del calendario",
        "iAgreeMessage": "Si está conforme con los cambios mencionados, pulse «Acepto» y empiece a utilizar el calendario (beta) en esta ubicación",
        "integrationNew": "Integración (nuevo)",
        "loseAbilityToViewEdit": "Los usuarios en la nueva versión perderán la capacidad de «ver/editar» citas (creadas en la versión anterior) a través del modal «Detalles de oportunidad», pero podrán seguir realizando todas esas acciones en la página de citas",
        "newOldTriggersCoexist": "Los activadores nuevos y antiguos coexistirán",
        "nonAdminAbilityViewPersonal": "No administradores - Capacidad de ver solo sus citas personales (datos asignados/asignación de calendario bajo GESTIÓN DE EQUIPO no tiene impacto)",
        "nonAdminViewPersonalOnly": "No administradores - Capacidad para ver únicamente sus citas personales",
        "notAtMoment": "No por ahora. Pero estamos esforzándonos mucho para llevarlo a móvil lo antes posible.",
        "oldAppointmentsCanBeViewed": "Las citas antiguas pueden consultarse fácilmente en la página de citas mediante un interruptor de palanca.",
        "oldAppointmentsDisplayed": "Las citas antiguas se mostrarán junto a las citas nuevas en la misma lista de citas",
        "oldCalendarVersionAppointments": "Versión antigua del calendario + citas antiguas",
        "onlyNewCalendarWidget": "Solo se puede añadir el nuevo widget de calendario",
        "opportunityAddAppointment": "Oportunidad > Añadir cita (nuevo)",
        "profilePageAdmin": "Página de perfil para el administrador (nuevo)",
        "profilePageAllUsers": "Página de perfil (todos los Usuarios)",
        "providesAllOptions": "Proporciona todas las opciones (grupos + servicios) necesarias para configurar el nuevo calendario",
        "reintegratingConnectionsRequired": "Es obligatorio reintegrar todas las conexiones una vez que la versión beta del calendario esté habilitada para una ubicación",
        "roundRobinHighlight": "La posibilidad de hacer citas en rotación entre diferentes grupos de agentes es el principal punto fuerte de esta actualización.",
        "schedulingCalendarAppointments": "Programación > CalendariocCitas (nuevos filtros + alternar para cambiar entre citas nuevas y viejas)",
        "settingsCalendarBeta": "Configuración > Calendario (beta)",
        "surfacingFirstTime": "Mostrándolo por primera vez",
        "teamManagementAdminOnly": "Gestión de equipo (disponible solo para administradores)",
        "toggleOffNewVersion": "Deshabilitar (nueva versión)",
        "toggleOnOldVersion": "Alternar activado (versión antigua)",
        "whatChangesWithNewVersion": "¿Qué cambios trae la nueva versión del calendario?",
        "whatDoesCalendarEntail": "¿Qué implica el calendario (beta privada)?",
        "whatHappensToOldAppointments": "¿Qué ocurre con nuestras antiguas citas después de la transición?",
        "whatWillWeSeeMobile": "¿Qué veremos en móvil durante la beta?",
        "willOldAppointmentsBeFactored": "¿Se tendrán en cuenta las citas antiguas al calcular la disponibilidad para las nuevas citas?",
        "willOldCalendarUrlsWork": "¿Seguirán funcionando nuestras antiguas URL del calendario después de la transición?",
        "willWeGetNewVersionMobile": "¿Podremos usar la nueva versión en móvil durante la beta?",
        "yesOldSettingsPageContinues": "Sí. De hecho, la página de configuración antigua seguirá existiendo, al igual que su capacidad para realizar cambios allí. El widget de calendario antiguo y el de nuevo calendario funcionarán de forma independiente pero estarán en constante sincronía para asegurar un cálculo preciso de su disponibilidad en ambos sistemas. Para evitar confusiones, le recomendamos encarecidamente que utilice las nuevas URL siempre que sea posible, de modo que no tenga que gestionar dos URL distintas para los mismos grupos de usuarios.",
        "yesSyncOnGoogleCalendar": "Sí, como la sincronización unidireccional está activada, el calendario de Google se asegurará de que los espacios no disponibles estén bloqueados."
      },
      "companyPlansModal": {
        "billedAnnually": "Facturación anual",
        "billedMonthly": "Facturación mensual",
        "changePlanFor": "Cambiar plan para {locationName}",
        "notAuthorized": "No tiene autorización para realizar esta acción. Solo los usuarios/administradores de la agencia y el administrador de la ubicación pueden realizarla.",
        "payAnnually": "Pagar anualmente",
        "payMonthly": "Pagar mensualmente"
      },
      "locationBillingHistory": {
        "billingHistory": "Historial de facturación",
        "cardNo": "N.º de tarjeta",
        "errorWhileFetchingInvoices": "Error al obtener las facturas, haga clic para reintentarlo",
        "invoiceDescription": "Descripción de la factura",
        "invoiceNo": "N.º de factura",
        "noInvoices": "No hay facturas",
        "refunded": "Reembolsado",
        "succeeded": "conseguido",
        "view": "VISTA"
      },
      "locationWallet": {
        "autoRechargeWith": "Recarga automática con",
        "balance": "Saldo:",
        "credits": "Créditos",
        "seeTransactions": "Ver transacciones",
        "whenBalanceLowerThan": "cuando el saldo sea inferior a"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Compruebe su correo electrónico ({emails}).",
        "csvSentMessage": "Le enviaremos un archivo CSV a su correo electrónico. Esta acción suele tardar entre 7 y 10 minutos.",
        "enterEmailAddress": "Introducir dirección de correo electrónico",
        "exportAndSendCsv": "Exportar y enviar CSV",
        "exportTransactions": "Exportar transacciones",
        "itUsuallyArrives": "Suele llegar en 10 minutos.",
        "useCommasToSeparate": "Utilice comas para separar los correos electrónicos."
      },
      "modifySubscription": {
        "cancelClientDescription": "Cancele la suscripción de su cliente y cierre la cuenta",
        "cancelDescription": "Cancele su suscripción y cierre la cuenta",
        "cancelImmediately": "Cancelar inmediatamente",
        "cancelNow": "Cancelar ahora",
        "cancelSubscription": "Cancelar la suscripción",
        "changedYourMind": "¿Ha cambiado de opinión?",
        "changedYourMindClient": "Puede reanudar la suscripción de su cliente",
        "changedYourMindYou": "Puede reanudar su suscripción",
        "confirmByTyping": "Confirme escribiendo {text} a continuación",
        "confirmCancellation": "Confirmar la cancelación",
        "modifySubscription": "Modificar suscripción",
        "modifyYourSubscription": "Modifique su suscripción",
        "resumeSubscription": "Reanudar suscripción",
        "subscriptionWillBeCancelledOn": "Esto programará su suscripción para que se cancele el {date}. Puede reanudar la suscripción anulando la cancelación programada en cualquier momento.",
        "subscriptionWillBeCancelledOnClient": "Esto programará la suscripción de su cliente para que se cancele el {date}. Usted y sus clientes pueden reanudar la suscripción cancelando la anulación programada en cualquier momento.",
        "subscriptionWillBeCancelledOnDate": "Su suscripción se cancelará el {date}.",
        "subscriptionWillBeCancelledOnDateClient": "La suscripción de su cliente se cancelará el {date}.",
        "subscriptionWillBeResumed": "Su suscripción se reanudará y se le empezará a facturar con normalidad.",
        "subscriptionWillBeResumedClient": "La suscripción de su cliente se reanudará y se le comenzará a facturar con normalidad.",
        "upgradeDescription": "Cambie a un plan de suscripción superior",
        "weAreGladYouStaying": "¡Nos alegra saber que se queda con nosotros!",
        "nextBillingDate": "Siguiente fecha de facturación: {date}",
        "cancelImmediatelyTitle": "¿Realmente desea cancelar la suscripción de inmediato?",
        "cancelNowDescription": "Su suscripción está programada para ser cancelada el {date}. Si decide cancelar ahora, su cuenta, incluida toda la actividad saliente, como los mensajes programados y los correos electrónicos, se detendrá de inmediato.",
        "cancelNowDescriptionClient": "La suscripción de su cliente está programada para ser cancelada el {date}. Si decide cancelar ahora, la cuenta de su cliente, incluida toda la actividad saliente como los mensajes programados y los correos electrónicos, se detendrá de inmediato.",
        "modifyDescription": "Puede {action} su suscripción",
        "modifyDescriptionClient": "Puede {action} la suscripción de su cliente"
      },
      "noPaymentMethodWarning": {
        "addNow": "Añadir ahora",
        "youNeedToEnterCardInfo": "Debe introducir la información de su tarjeta.",
        "youNeedToEnterClientCardInfo": "Debe introducir la información de la tarjeta de su cliente."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Los cargos se basan en tokens. Los recuentos de palabras que se muestran a continuación son estimaciones para ayudarle a comprender el uso. La facturación real puede variar.",
        "examplePricingGpt4oMini": "Ejemplo de precios: GPT-4o Mini",
        "for750kWords": "(para 750 000 palabras) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Entrada",
        "or": "o ",
        "output": "Salida",
        "perImage": " /imagen",
        "perResultSelection": " /selección de resultados",
        "ratesMayDifferUK": "Las tarifas pueden diferir según la región. Los cálculos mostrados se corresponden con las tasas para el Reino Unido, consulte nuestro",
        "ratesMayDifferUS": "Las tarifas pueden diferir según la región y el tipo de número. Cálculos según las tarifas de Twilio para EE. UU.,",
        "pleaseCheckSupport": "consulte nuestro",
        "resultSelection": " Selección de resultados",
        "supportDoc": "documento de apoyo",
        "forMoreDetails": "Para obtener más detalles",
        "words": " palabras"
      },
      "removePaymentMethod": {
        "endingIn": "Terminada en *{cardNo}",
        "no": "No",
        "removeCard": "¿Eliminar tarjeta?",
        "removing": "Eliminando..",
        "yesRemove": "Sí, eliminar"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Solicitar la información de pago del cliente",
        "saasLocationDescription": "Configure una suscripción SaaS para esta ubicación",
        "selectSpace": "Seleccionar espacio",
        "spaceDescription": "Elija dónde quiere configurar la facturación de esta ubicación"
      },
      "saasEnableProducts": {
        "disable": "Deshabilitar",
        "enableDisableProducts": "Habilitar/deshabilitar productos",
        "feature": "Función",
        "unsavedChanges": "Cambios no guardados"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "La siguiente facturación para este cliente parece ser una fecha pasada. Esto ocurre cuando la cuenta de Stripe de su agencia no funciona correctamente. Inicie sesión en la cuenta de Stripe de la agencia para solucionarlo.",
        "copiedText": "texto copiado:",
        "couldNotCopy": "Asincrónico: no se ha podido copiar el texto: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Siguiente fecha de facturación: ",
        "plan": "Plan",
        "pleaseContactAgency": "Póngase en contacto con la agencia para habilitar su suscripción.",
        "stripeSubscriptionId": "ID de suscripción de Stripe:",
        "subscriptionPlans": "Planes de suscripción",
        "subscriptionWillBeCancelledOn": "Su suscripción se cancelará el {date}",
        "subscriptionWillBeCancelledOnClient": "La suscripción de su cliente se cancelará el {date}",
        "toModifyClientSubscription": "modificar la suscripción de su cliente",
        "toModifyYourSubscription": "para modificar su suscripción",
        "whatsappNumberSubscription": "Suscripción al número de WhatsApp",
        "yourBillingDatePast": "Su siguiente facturación parece ser una fecha pasada. Póngase en contacto con {email} para solucionarlo. Mientras tanto, todo seguirá como de costumbre."
      },
      "salesResources": {
        "certifiedUser": "Usuario certificado",
        "clearFilter": "Borrar filtro",
        "dateRange": "Intervalo de fechas"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Usted pagará {amount} $ al mes facturado {interval}",
        "planUpgradeFailed": "¡Su plan no se ha podido mejorar!",
        "planUpgraded": "¡Su plan se ha mejorado!",
        "retryUpgrade": "Reintentar mejora",
        "upgradeFailed": "No se ha podido mejorar su plan; inténtelo de nuevo",
        "upgradedSuccessfully": "Ha mejorado correctamente su plan de {oldPlan} a {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "facturado como cargo mensual de {amount}/mes",
        "billedAsYearlyCharge": "facturado como cargo anual de {amount}/año",
        "upgradeFrom": "Mejorar de",
        "whatYouWillGet": "Lo que obtendrá:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo después de la transacción:",
        "callDuration": "Duración de la llamada:",
        "callSid": "SID de llamada:",
        "charge": "Cargo:",
        "contact": "Contacto:",
        "contactName": "Nombre del contacto:",
        "contactPhone": "Teléfono de contacto:",
        "credit": "Crédito:",
        "creditsAfterTransaction": "Créditos después de la transacción:",
        "dateSent": "Fecha de envío",
        "deleted": "<Deleted>.",
        "discount": "Descuento:",
        "eventId": "ID del evento:",
        "from": "De:",
        "noContactFound": "No se ha encontrado ningún contacto",
        "noOfSegments": "N.º de segmentos:",
        "openContactPage": "Abrir la página de contacto",
        "openConversation": "Abrir conversación",
        "openEvent": "Abrir evento",
        "originalCharge": "Cargo original:",
        "received": "Recibido",
        "smsSid": "SID de SMS:",
        "timeBilled": "Tiempo facturado:",
        "timeOfCall": "Hora de la llamada",
        "transactionDetails": "Detalles de la transacción:",
        "transactionId": "ID de la transacción:",
        "type": "Tipo:",
        "segments": "Segmentos"
      },
      "calendarSettings": {
        "meetings": "Reuniones",
        "services": "Servicios",
        "hideCalendarWarning": "Si desea ocultar por completo el módulo del calendario, hágalo desde la configuración de la subcuenta > Mi personal > Funciones y permisos",
        "calendarSettingsUpdated": "Configuración del calendario actualizada",
        "meetingDescription": "Habilite esta opción para permitir que las subcuentas utilicen la función Reuniones, diseñada para gestionar calendarios de ventas, llamadas de incorporación, programación por turnos, colaboraciones en equipo, reservas de clases, entrevistas y mucho más. Ideal para empresas que necesitan herramientas de programación flexibles y colaborativas.",
        "serviceDescription": "Active los servicios para que las subcuentas tengan acceso a una solución que completa las reservas para empresas de servicios. Esto incluye crear páginas de reserva con múltiples servicios, gestionar recursos, gestionar múltiples ubicaciones, la configuración de precios específicos para cada empleado, añadir variaciones o complementos a los servicios y mucho más."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "¡Copiado!",
      "copyApiKey": "Copiar clave API",
      "createApiKey": "Crear clave API",
      "deleteAllKeys": "Borrar todas las claves",
      "nameRequired": "El campo del nombre es obligatorio.",
      "somethingWentWrong": "¡Vaya! Algo ha ido mal. Vuelva a intentarlo.",
      "updatedSuccessfully": "Actualizado correctamente"
    },
    "billing": {
      "accountPaused": "Su cuenta {name} se ha puesto en pausa.",
      "accountProvisioned": "Su cuenta se está configurando.",
      "activateSubAccount": "Activar subcuenta",
      "activeServices": "Servicios activos",
      "addNewCard": "Añadir una nueva tarjeta",
      "addNewService": "Añadir nuevo servicio",
      "addPaymentMethod": "un método de pago",
      "alertIcon": "Icono de alerta",
      "approve": "Aprobar",
      "authenticateCardMessage": "Para mayor seguridad, deberá autenticar nuevamente los detalles de su tarjeta.",
      "badActorWarning": "Si cree que esta subcuenta fue creada por un actor malintencionado, le recomendamos que la elimine y cancele la suscripción correspondiente.",
      "callUs": "Llámenos",
      "cancelAndDelete": "Cancelar suscripción y eliminar subcuenta",
      "completeFormNextStep": "Complete el formulario en el siguiente paso",
      "congratulations": "🎉 ¡Felicidades! 🎉",
      "contactAgency": "Póngase en contacto con su agencia para resolver este problema",
      "contactThroughEmailOrPhone": "Puede ponerse en contacto con nosotros por correo electrónico o por teléfono para resolver este problema",
      "dataSafe": "Todos sus datos están seguros y todas las automatizaciones, páginas web, etc., reanudarán su funcionamiento después del pago exitoso.",
      "declineSubAccount": "Rechazar la subcuenta",
      "deleteRecommendation": "Se recomienda eliminar esta subcuenta. O bien, puede hacerlo más tarde desde la página Subcuentas > Gestionar cliente.",
      "emailUsAt": "Envíenos un correo electrónico a",
      "moveToDashboard": "Mover al tablero",
      "noPaymentMethods": "Parece que no se han añadido métodos de pago. Por favor,",
      "paymentMethod": "Método de pago",
      "paymentMethodUpdated": "Se ha actualizado su método de pago",
      "paymentNotCompleted": "Está viendo este mensaje porque el pago no se ha completado.",
      "proceedToNextStep": "Continuar al siguiente paso",
      "questionMark": "¿?",
      "reachOutMessage": "no dude en ponerse en contacto con nosotros si tiene alguna pregunta.",
      "reactivateBillingFor": "Reactivar la facturación para {location}",
      "retryPayment": "Reintentar el pago",
      "secureSystemMessage": "Hemos adoptado un sistema de facturación más seguro.",
      "setupMessage": "Alguien se pondrá en contacto con usted para configurar la cuenta. Normalmente tarda entre 12-24 horas,",
      "signout": "Cerrar sesión",
      "subAccountId": "Id. de la subcuenta:",
      "successfullyInitiated": "{product} se ha iniciado con éxito",
      "systemError": "Hay un error en el sistema",
      "toReactivate": "para reactivar la cuenta",
      "userImage": "Imagen de usuario",
      "verificationSkipped": "Se omitirá la verificación del correo electrónico y el teléfono de esta subcuenta y el cliente podrá acceder a ella.",
      "verifyAccount": "Verificar cuenta",
      "verifyAfterAttempt": "Puede verificar esta cuenta tras al menos un intento de verificación por parte del administrador de la subcuenta",
      "verifySubAccount": "Verificar la subcuenta",
      "recommendedPlans": "Planes recomendados",
      "buildYourOwnPlan": "CREE SU PROPIO PLAN",
      "resetToDefaults": "Restablecer a los valores predeterminados",
      "paymentMethodChange": "Si necesita cambiar el método de pago",
      "approveSubAccount": "Aprobar la subcuenta",
      "approveSubAccountDescription": "La subcuenta se reanudará y sus administradores podrán acceder a ella y utilizarla.",
      "productInitiated": "Producto iniciado"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Esta acción no se puede deshacer.",
      "cancelKeep": "Cancelar, mantener",
      "confirmDeletionInstructions": "Guarde la eliminación escribiendo {word} debajo:",
      "enterConfirm": "Introduzca {word} para regenerar",
      "message": "Se eliminará la clave API de esta ubicación.",
      "title": "¿Eliminar la clave API de la ubicación?",
      "yesDelete": "Sí, eliminar"
    },
    "generalDetails": {
      "noPermission": "No tiene autorización para subir el archivo. Compruebe sus permisos con el administrador de su agencia.",
      "relatedContacts": "Contactos relacionados ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "¿Seguro que desea eliminar todas las claves API de las ubicaciones?",
      "deleteAllConfirmTitle": "¿Eliminar todas las claves API de la ubicación?",
      "deleteConfirmMessage": "Esto borrará la clave API para la ubicación: {location}. ¿Desea continuar?",
      "deleteAgencyApiKeyConfirmMessage": "Esto eliminará la clave API. ¿Desea continuar?",
      "fetchingLocations": "Obteniendo ubicaciones...",
      "maxApiKeysMessage": "Puede tener un máximo de 5 claves de API.",
      "noLocationsFound": "No se han encontrado ubicaciones",
      "old": "Antiguo",
      "proPlanRequiredMessage": "Esto forma parte de la API avanzada que está disponible en el plan Pro.",
      "searchLocation": "Buscar ubicación",
      "title": "Clave API de ubicación"
    },
    "locationCard": {
      "deletionScheduledMessage": "Esta subcuenta se eliminará el {date}, si ha cambiado de opinión -",
      "emailUsageNotRebilled": "El uso del correo electrónico no está siendo refacturado",
      "emailUsageRebilled": "El uso del correo electrónico se está refacturando a su cliente",
      "listings": "Listados",
      "manageClient": "Gestionar cliente",
      "paymentPending": "El pago está pendiente",
      "remainingWalletBalance": "Saldo restante del monedero de esta ubicación SaaS",
      "requestPaymentAgain": "Solicite el pago de nuevo",
      "saasModeActivated": "El modo SaaS está activado",
      "saasModeNotActivated": "El modo SaaS no está activado",
      "saasSubscriptionNotEnabled": "El plan de suscripción SaaS no está habilitado",
      "saasSubscriptionRunning": "El plan de suscripción SaaS está activo",
      "social": "Redes sociales",
      "switchToSaaS": "Cambiar a SaaS",
      "switchToSubAccount": "Cambiar a subcuenta",
      "telephoneUsageNotBilled": "El uso del teléfono no está siendo facturado",
      "telephoneUsageRebilled": "El uso del teléfono se está refacturando a su cliente",
      "wordpressActive": "Wordpress activo",
      "wordpressInactive": "WordPress inactivo",
      "wordpressNotSoldYet": "WordPress aún no se ha vendido",
      "wordpressSaleSuccessful": "Venta de WordPress completada correctamente",
      "yextActive": "Yext activo",
      "yextInactive": "Yext inactivo",
      "yextNotSoldYet": "Yext aún no se ha vendido",
      "yextSaleSuccessful": "Venta de Yext completada correctamente",
      "reviews": "Reseñas"
    },
    "messageUsage": {
      "acceptTnc": "Por favor, acepte los T&C",
      "cannotPerformAction": "No se puede realizar esta acción. Póngase en contacto con el servicio de asistencia.",
      "currentLimit": "Límite actual",
      "days": "día(s)",
      "failedToUpdate": "Error al actualizar el uso del mensaje",
      "helpCentre": "Centro de ayuda",
      "increaseLimitFurther": "Incrementar el límite aún más",
      "increaseLimitNow": "Incrementar el límite ahora",
      "lessThanUsage": "El uso actual es {usage} y el uso seleccionado es menor al uso actual.",
      "lessThanUsageModal": "El uso actual es {usage}, el límite no puede ser inferior al uso actual",
      "limitAlreadyUnlocked": "El límite ya está desbloqueado",
      "limitReached": "Límite alcanzado",
      "limitUpdatedFrom": "El límite de {type} se ha actualizado de {old} a {new}",
      "lookingForSmsLimit": "¿Busca el límite de SMS?",
      "minLimitShould": "El límite mínimo debería ser {limit}",
      "newLimit": "Nuevo límite de {type}",
      "perDay": "/ Día",
      "sameLimit": "¡El límite seleccionado es igual al límite actual!",
      "smsLimitLocation": "El límite de SMS puede encontrarse ahora a nivel de ubicación",
      "smsLimitSettingsInfo": "Ahora puede encontrar este ajuste en «Límite de mensajes» en «Configuración avanzada»",
      "timesInLast30Days": "veces en los últimos 30 días",
      "todaysUsage": "Uso de hoy",
      "typePerDay": "{type} / día",
      "updateLimit": "Actualizar el límite",
      "updateLimitFor": "Actualizar el límite de {type} para {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "{type} activo",
      "contactSource": "Fuente del contacto",
      "customer": "Cliente",
      "noPastCampaignsWorkflows": "No hay {type} pasado",
      "pastCampaignsWorkflows": "Pasado {type}"
    },
    "settings": {
      "affiliateSettings": "Configuración de afiliados",
      "agencyBilling": "Facturación de la agencia",
      "agencyTeamManagement": "Gestión del equipo de la agencia",
      "apiKeys": "Claves API",
      "compliance": "Conformidad",
      "customMenuLink": "Enlace al menú personalizado",
      "launchpadSettings": "Configuración de Launchpad",
      "phoneSystemTwilio": "Sistema telefónico - Twilio",
      "smtpService": "Servicio SMTP",
      "userSettings": "Configuración del usuario",
      "agencySettings": "Configuración de la agencia",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Error al crear la instantánea",
      "pickAnAccount": "Debe seleccionar una cuenta.",
      "snapshotName": "Nombre de la instantánea",
      "snapshotNameRequired": "Debe darle un nombre a la instantánea."
    },
    "socialDetails": {
      "blogRss": "RSS del Blog",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare URL",
      "googlePlacesId": "Id. de Google Places",
      "googlePlus": "Google+",
      "googlePlusUrl": "Google+ URL",
      "instagramUrl": "URL de Instagram",
      "linkedInUrl": "URL de LinkedIn",
      "pinterest": "Pinterest",
      "pinterestUrl": "URL de Pinterest",
      "yelp": "Yelp",
      "yelpUrl": "URL de Yelp",
      "youTube": "YouTube"
    },
    "requestSms": "Solicitar mediante SMS",
    "iAlreadyHaveACustomer": "Ya tengo un cliente",
    "noAccountFound": "No se ha encontrado ninguna cuenta.",
    "thisIs": "Esto es",
    "pleaseEnterValueBetween0To30Days": "Introduzca un valor entre 0 y 30 días",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Más información sobre cómo añadir una cuota de alta única a estos planes",
    "doNotDeleteStripeProductsWarning": "<span style=\"font-weight: bold;\">No elimine</span> estos productos dentro de su cuenta de Stripe",
    "opportunityStats": "Estadísticas de Oportunidades",
    "createNewSnapshot": "Crear una nueva instantánea",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Tablero de la agencia visible para",
      "onlyMe": "Solo yo",
      "allAgencyAdmins": "Todos los administradores de la agencia",
      "stripeConnect": "Quedará obsoleto en breve. Cambiar a Stripe Connect",
      "recommendStripe": "Recomendamos utilizar Stripe Connect para una mejor seguridad",
      "switchToStripeConnect": "Cambiar a Stripe Connect",
      "highLevelAccess": "HighLevel tendrá acceso a sus datos y podrá crear pagos y clientes en su nombre",
      "stripeAccountWarning": "Una vez conectada, la cuenta de Stripe no podrá modificarse posteriormente. Se recomienda utilizar una nueva cuenta de Stripe dedicada exclusivamente a las ganancias de Highlevel.",
      "connectToStripeAccount": "Conéctese a su cuenta de Stripe",
      "unverified": "La cuenta de Stripe conectada a esta agencia no está verificada y no puede cobrar pagos. Complete la verificación iniciando sesión en su cuenta de Stripe.",
      "loginToStripe": "Inicie sesión en Stripe",
      "connectedAccount": "Cuenta conectada",
      "verified": "VERIFICADO",
      "totalPendingBalance": "Saldo total pendiente",
      "disconnectStripe": "Desconectar Stripe",
      "removeSaasPlanConfigurations": "¿Eliminar todas las configuraciones de planes SaaS?",
      "haveSaasPlans": "¡Tiene planes SaaS creados en la cuenta de Stripe!",
      "disconnectWarning": "Si desconecta, todos los planes SaaS se perderán y deberá crearlos nuevamente.",
      "acknowledgeDisconnect": "Entiendo que todos mis planes SaaS se perderán y tendré que volver a crearlos",
      "disconnect": "Desconectar"
    },
    "zoomSuccess": {
      "title": "¡Espero que haya tenido una gran experiencia!",
      "message": "Gracias por participar en la llamada. ¡Tenemos ganas de volver a recibirle!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Su especialista en la experiencia del periodo de prueba",
      "successSpecialist": "Su especialista en éxito",
      "supportSpecialist": "Su especialista en asistencia",
      "jumpOnZoomCall": "Únase a una llamada de Zoom conmigo para su llamada de inicio",
      "jumpOnChat": "Únase a una conversación conmigo para obtener ayuda",
      "joinVideoCallNow": "Únase ahora a la videollamada",
      "whatToExpect": "¿Qué puede esperar?",
      "helpArticles": "Artículos de ayuda",
      "changelog": "Registro de cambios",
      "ideasBoard": "Tablero de Ideas"
    },
    "saasDashboard": {
      "title": "Panel de control de SaaS",
      "plansAndPricing": "Planes y precios"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Ahora está disponible una interfaz más limpia y rápida para esta página. ¡Pruébela!",
      "enableInLabs": "Habilitar en Labs",
      "pendingTransferRequests": "Tiene solicitudes de transferencia de subcuenta pendientes.",
      "otherAgenciesRequested": "Otras agencias han solicitado transferirle subcuentas.",
      "reviewRequests": "Solicitudes de reseñas",
      "clientList": "Lista de clientes (subcuentas)",
      "subAccountTransfers": "Transferencias de subcuentas"
    },
    "implementationModal": {
      "title": "¡Su experiencia de videollamada con HighLevel está a punto de comenzar!",
      "videoCall": "Videollamada",
      "whatsNext": "¿Y ahora qué?",
      "enteringLobby": "¡Entrará en nuestro vestíbulo junto a otros Highlevelers como usted!",
      "successConcierge": "Nuestro recepcionista de éxito le recibirá y le pondrá en contacto con el próximo asesor disponible para una sesión individual.",
      "haveReady": "Por favor, tenga lo siguiente listo",
      "stableInternet": "Conexión a internet estable.",
      "videoNameMatches": "El nombre de su vídeo coincide con su nombre de usuario de HighLevel.",
      "estimatedDuration": "Duración estimada de la sesión",
      "firstVisit": "Primera visita: sesión de incorporación de HighLevel: (45-60 minutos).",
      "returning": "Visitas sucesivas: asistencia en la configuración de implementación continua (15-25 minutos).",
      "meetingBegins": "Su reunión comenzará automáticamente en <span class=\"text-[#155EEF]\">{ countdown } segundos.</span>  O puede unirse inmediatamente haciendo clic en el botón a continuación:",
      "joinNow": "Únase ahora"
    },
    "gdpr": {
      "logo": "Logotipo del RGPD",
      "dataProtection": "Protección de datos y RGPD",
      "introduction": "Introducción",
      "intro1": "HighLevel se compromete a proteger la privacidad de nuestros usuarios y de sus clientes. Nos mantenemos informados sobre los avances en las leyes de protección de datos para asegurarnos de que pueda confiar en su seguridad al utilizar nuestra plataforma.",
      "intro2": "Esta página pretende explicar cuáles son las normas, cómo se aplican a su uso de la plataforma HighLevel y los pasos que hemos seguido para cumplirlas.",
      "intro3": " Debe revisar este documento junto con nuestra Política de privacidad y contactar con un profesional legal especializado si necesita más información o asesoramiento.",
      "gdprRegulation": "Reglamento General de Protección de Datos (RGPD)",
      "regulation1": "El Reglamento (UE) 2016/679, más conocido como Reglamento General de Protección de Datos (RGPD), es un reglamento de la UE destinado a armonizar las leyes de protección de datos y privacidad en toda la UE. Las disposiciones del RGPD se aplican siempre que estén implicados datos personales de un sujeto de datos de la UE.",
      "regulation2": "El RGPD se centra en dar a las personas más control sobre cómo utilizan sus datos por parte de las empresas y en hacer que la recopilación y el procesamiento de datos sean más transparentes.",
      "regulation3": "El RGPD se incorporó directamente a la legislación del Reino Unido tras el final del período de transición para el Brexit, lo que significa que las empresas del Reino Unido aún tienen que cumplir sus disposiciones a través del \"RGPD del Reino Unido\".",
      "basicConcepts": "Conceptos básicos del RGPD",
      "controllerAndProcessor": "Responsable y procesador",
      "controllerProcessorObligation": "El RGPD impone diversas obligaciones a una persona dependiendo de si es responsable o procesador de datos personales.",
      "controllerDefinition": " Un responsable es una entidad que decide procesar datos personales y toma decisiones sobre la base del tratamiento y los métodos que se utilizarán. Los responsables de los responsables tienen ciertas obligaciones respecto a los datos personales, con las que debería familiarizarse antes de recopilar datos personales de sus clientes.",
      "processorDefinition": "Un procesador es una entidad que procesa datos para y en nombre de un responsable. No toman decisiones independientes respecto a los datos ni su tratamiento, ya que solo los procesan en nombre del responsable y deben cumplir con todas las instrucciones dadas por este.",
      "youAreController": "Cuando utiliza el servicio HighLevel, usted es responsable. Controla los datos que sube al sistema HighLevel, qué hace con esos datos y por qué. Como resultado, usted es responsable de asegurarse de que dispone de una base legal para secuenciar las estadísticas y de que no las retiene durante más tiempo del necesario.",
      "highlevelIsProcessor": "Debe asegurarse de entender sus obligaciones como responsable del tratamiento y actualizar sus propios sistemas y políticas para permitir la transferencia legal de datos personales a HighLevel. HighLevel es un procesador de datos. Nosotros, a través de la plataforma HighLevel, almacenamos y gestionamos los datos que ha recopilado bajo sus instrucciones. Nunca utilizaremos ningún dato personal que haya subido al sistema de HighLevel para nuestros propios fines o sin que nos lo ordene.",
      "legalBasisForProcessing": "Base jurídica del procesamiento",
      "legalBasisRequirement": "Los datos personales solo podrán ser recopilados y procesados si existe una base jurídica para ello. Las bases jurídicas permitidas se establecen en el RGPD.",
      "processorReliesOnCustomers": "Como procesador, HighLevel confía en que nuestros clientes seleccionen la base correcta bajo la cual recopilarán y procesarán datos personales, y que establezcan los avisos y consentimientos adecuados. Antes de utilizar el servicio HighLevel, debería tomarse el tiempo para identificar qué base legal puede estar disponible para usted y solo recopilar y conservar datos personales en la medida necesaria para llevar a cabo esa base. No debe cambiar la base bajo la cual ha recopilado datos personales sin una razón muy válida, por lo que es importante entender los requisitos de las diferentes bases y asegurarse de elegir la correcta desde el principio.",
      "dataSubjectAccessRights": "Derechos de acceso a los sujetos de datos",
      "dataSubjectRights": "El RGPD concede a los sujetos de datos (es decir, sus clientes) ciertos derechos relacionados con sus datos personales, incluido el derecho a acceder, corregir y/o eliminar cualquier dato relacionado con ellos.",
      "highlevelEasySystems": "HighLevel ha puesto en marcha sistemas sencillos para que nos informe si recibe una solicitud de este tipo de un sujeto de datos, y para que nosotros le informemos si recibimos dicha solicitud. Nos aseguraremos de que, siguiendo sus instrucciones, estas solicitudes se cumplan con prontitud. Debería familiarizarse con las obligaciones que se le impondrá, incluidos los datos personales que posea en sus propios sistemas o servicios distintos a HighLevel.",
      "transfersToUSA": "Transferencias de datos a Estados Unidos",
      "transfersRestrictions": "Los datos personales no pueden transferirse fuera del EEE salvo en circunstancias específicas. Utilizamos las Cláusulas contractuales tipo como parte de nuestro Acuerdo de procesamiento de datos, que firmamos con todos nuestros clientes.",
      "dataSecurity": "Seguridad de los datos",
      "securitySafeguards": "Hemos implementado fuertes medidas de seguridad y salvaguardas para garantizar que cualquier dato personal que poseamos se almacene de forma segura. Probamos regularmente nuestros productos en busca de errores y vulnerabilidades.",
      "backupSystems": "Nos aseguramos de contar con sistemas de respaldo regulares y sistemas y procesos de recuperación e integridad de datos para minimizar el riesgo de corrupción o pérdida de datos personales.",
      "stepsForCompliance": "Medidas que hemos tomado para garantizar el cumplimiento del RGPD",
      "dutyAsProcessor": "Nos tomamos muy en serio nuestras obligaciones como procesador. Hemos implementado varios procedimientos y tomado varias medidas para garantizar que seguimos cumpliendo con el RGPD y que pueda enviarnos legalmente los datos personales recogidos por usted, a saber:",
      "standardContractualClauses": "Nuestro acuerdo de procesamiento de datos utiliza las Cláusulas contractuales tipo para garantizar que pueda enviarnos legalmente datos personales en Estados Unidos.",
      "detectBreaches": "Podemos detectar brechas personales e informar a nuestros clientes lo antes posible.",
      "dealWithAccessRequests": "Podemos gestionar solicitudes de acceso al sujeto y solicitudes de derechos de borrado, y nos aseguramos de informarle cuando un sujeto de datos nos ha hecho dicha solicitud.",
      "assessedDocumented": "Hemos evaluado y documentado los datos personales que tratemos en su nombre.",
      "assessedSecurity": "Hemos evaluado nuestra seguridad y la hemos mejorado cuando ha sido necesario para asegurarnos de que sea adecuada al nivel de riesgo al que nos enfrentamos en relación con una brecha de datos.",
      "dataProcessingAgreement": "Acuerdo de procesamiento de datos",
      "dateUpdated": "Fecha de actualización: 1 de abril de 2023",
      "downloadAgreement": "Descargar acuerdo",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "¿Alguna pregunta?"
    },
    "sendGridSettings": {
      "title": "Configuración de SendGrid",
      "settingsForLocations": "Configuración de SendGrid para ubicaciones",
      "sendGrid": "SendGrid",
      "last12Months": "Últimos 12 meses",
      "totalSent": "Total enviado",
      "opens": "Abre",
      "clicks": "Clics",
      "bounces": "Rebotes"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Deshabilitar Launchpad para todas mis ubicaciones.",
      "description1": "Launchpad es una página de destino bien pensada que ha demostrado aumentar la satisfacción y retención del cliente al incrementar el uso del producto. ",
      "description2": "Conectar GMB, FB, el plugin de chat web, usar aplicaciones móviles, etc., han demostrado ser excelentes funciones que retienen a los clientes durante más tiempo.",
      "confirmDisable": "¿Seguro que desea deshabilitar Launchpad?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Este es su enlace de afiliado, úselo para permitir que personas que conoce se registren en una cuenta y recibirá el 40 % de sus ingresos mensuales recurrentes de por vida.",
      "appendToUrls": "Añada esto al final de sus URLs:",
      "needToSignUp": "¿Necesita registrarse?",
      "goToUrl": "Vaya a la URL:",
      "andSignUpUsing": "y regístrese usando la dirección de correo electrónico",
      "asYourEmailAddress": "como su dirección de correo electrónico para FirstPromoter.",
      "pageSettings": "Configuración de la página",
      "facebookPixelId": "ID de píxel de Facebook",
      "pixelId": "ID de píxel"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "A partir del 17 de junio de 2024, la seguridad mejorada de la cuenta se habilitará automáticamente en su cuenta por defecto. Las mejoras de seguridad mejoradas incluyen:",
      "discontinuationOfAutoGeneration": "Interrupción de la autogeneración de claves de API de ubicación",
      "exclusionOfApiKeysInLocationCrudApis": "Exclusión de claves de API en las API CRUD de ubicación",
      "optOutLink": "Para deshabilitar este cambio, desactive Seguridad mejorada de la cuenta en <a href=\"/settings/company\">Configuración &gt; Empresa</a>",
      "advancedFunctionalityNote": "Esta API está destinada a funcionalidades avanzadas. Nuestro equipo de soporte no está en condiciones de proporcionar asistencia directa en relación con la configuración de la API.",
      "developerCouncilInfo": "Ofrecemos un Consejo de Desarrolladores que se reúne una vez al mes durante el horario de oficina (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) y un canal de Slack de la Comunidad de Desarrolladores donde puede encontrar asistencia de la comunidad y de nuestro equipo de API. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "Para usar Zapier, necesita usar la clave API de ubicación para la ubicación específica. Puede obtenerla de la lista a continuación o cambiando a la cuenta usando el conmutador en el menú de la izquierda.",
      "partOfAdvancedApi": "Esto forma parte de la API avanzada que está disponible en el plan Pro.",
      "upgradeMessage": "Esto forma parte de la API avanzada que está disponible en el plan Pro. <a>Haga clic aquí</a> para actualizar."
    },
    "accountMap": {
      "addAccountManually": "Añadir cuenta manualmente"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Configuración como grupos."
    },
    "accountDetails": {
      "basicDetails": "Detalles básicos",
      "saas": "SaaS",
      "rebilling": "Refacturación",
      "marketplaceApps": "Aplicaciones del mercado",
      "advancedEmailSettings": "Configuración avanzada",
      "calendarSettings": "Configuración del calendario"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Controlar los ajustes de localización",
      "disableAddEmailService": "Desactivar el botón \"Añadir servicio de correo electrónico\" en la configuración del servicio de correo electrónico de la subcuenta",
      "disableAddSmtp": "Desactivar el botón \"Añadir servicio de correo electrónico\" en la configuración del servicio de correo electrónico de la subcuenta",
      "restrictSubAccountEmailProvider": "Restringir a los usuarios de subcuentas la posibilidad de añadir su propio proveedor de servicio de correo electrónico",
      "disableAddSmtpDescription": "Restringir a los usuarios de subcuentas la posibilidad de añadir su propio proveedor de servicio de correo electrónico",
      "enableReVerification": "Habilitar la reverificación durante 90 días",
      "locationNoLeadConnector": "La ubicación no tiene LeadConnector como proveedor de correo electrónico predeterminado",
      "lcEmailNotEnabled": "La ubicación no tiene LeadConnector como proveedor de correo electrónico predeterminado",
      "onlyForAgency": "Solo usted puede ver esta configuración habilitada para la agencia",
      "onlyVisibleForAgency": "Solo usted puede ver esta configuración habilitada para la agencia",
      "reVerificationDescription": "Cada estado de verificación de correo electrónico se revocará transcurridos 90 días (proteja su reputación de remitente y garantice la máxima entregabilidad en la bandeja de entrada)"
    }
  },
  "attributes": {
    "addAttribute": "Añadir atributo",
    "attributeName": "Nombre del atributo",
    "enterAttributeName": "Introducir el nombre del atributo",
    "number": "Número",
    "selectAttributeType": "Seleccionar tipo de atributo"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Metadatos adicionales",
      "title": "Campos añadidos/actualizados"
    }
  },
  "bulkActions": {
    "additionalDetails": "Detalles adicionales",
    "allOnGivenDate": "Todo en la fecha indicada",
    "attempted": "Intentado",
    "batchQuantity": "Tamaño del lote",
    "bulkActionProcessing": "Procesamiento de acciones en bloque",
    "bulkActionTitle": "Acción masiva",
    "campaignRequired": "La campaña es obligatoria",
    "currentStatus": "Estado actual",
    "delayBetweenBatches": "Retraso entre lotes",
    "dispatchMode": "Modo de envío: {mode}",
    "editBatchQuantity": "Editar la cantidad del lote",
    "emailStats": "Estadísticas de correo electrónico",
    "enterBatchSprintLimit": "Indique un límite de sprint por lote",
    "hideStats": "Ocultar estadísticas",
    "mode": "Modo",
    "nextProcessingOn": "Próximo procesamiento el",
    "noStatsFound": "No se han encontrado estadísticas",
    "parentBulkActionID": "Id. de acción masiva principal",
    "pleaseEnterQuantity": "Introduzca una cantidad",
    "processAllAsSoonAsPossible": "Procesar todo lo antes posible",
    "processAllOnGivenDate": "Procesar todo en el día indicado",
    "processDuring": "Secuencia durante",
    "processGraduallyDrip": "Procesar gradualmente (goteo)",
    "processingAllowedOn": "Procesamiento permitido el",
    "restoredBulkActionId": "id de acción masiva recuperada:",
    "revert": "Revertir",
    "revertedBulkActionId": "Id. de acción masiva revertida:",
    "saveChanges": "Guardar cambios",
    "scheduledStart": "Inicio programado",
    "showErrorLog": "Mostrar el registro de errores",
    "showImported": "Mostrar importado",
    "showStats": "Mostrar estadísticas",
    "skipped": "Omitido",
    "statistics": "Estadísticas",
    "statuses": {
      "complete": "Completar",
      "next-drip": "Siguiente goteo",
      "notStarted": "No iniciado",
      "processing": "Procesando",
      "queueing": "En cola",
      "reading": "Leyendo",
      "resumed": "Reanudado",
      "reverted": "revertido",
      "waiting": "Esperando"
    },
    "successful": "Correcto",
    "tagsAdded": "Etiquetas añadidas",
    "tagsRemoved": "Etiquetas eliminadas",
    "tagsRestored": "Etiquetas restauradas",
    "timeElapsed": "Tiempo transcurrido",
    "totalExported": "Total exportado",
    "totalMerge": "Total fusionado",
    "unknownError": "Error desconocido",
    "updateBatchQuantity": "Actualizar el tamaño del lote",
    "updated": "Actualizado",
    "usesDynamicList": "** Utiliza lista dinámica",
    "workflowRequired": "El flujo de trabajo es obligatorio"
  },
  "business": {
    "addedToCompany": "Contacto(s) añadido(s) a la empresa correctamente",
    "cantAddMoreContacts": "No se pueden Incluir más de 50 contactos a la vez",
    "cleanerUi": "Interfaz de usuario más limpia",
    "common": {
      "addContact": "Añadir contacto",
      "internalServerError": "Error Interno del Servidor",
      "to": "a"
    },
    "companiesNowHave": "Las empresas ahora tienen",
    "companyNoteLabsText": "Notas de la empresa es una función de Labs",
    "contactRemoveCompany": "¿Seguro que desea borrar este contacto de la empresa?",
    "moreFunctionalUx": "UX más funcional",
    "newCompanyUpdate": "¡Nueva actualización de la empresa!",
    "tabs": "Pestañas",
    "tasks": {
      "assignTask": "Asignar tarea",
      "assignee": "Responsable",
      "deleteTask": "Eliminar tarea",
      "editTask": "Editar tarea",
      "markAsComplete": "Marcar como completado",
      "markAsPending": "Marcar como pendiente",
      "nameAndDescription": "Nombre y descripción",
      "noTasksAvailable": "No hay tareas disponibles"
    },
    "visitLabs": "Visitar Labs"
  },
  "calendar": {
    "googleCalendar": "Calendario de Google",
    "noSync": "Sin Sincronización",
    "outlookCalendar": "Calendario de Outlook"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Alternar el depurador de front-end"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Se ha producido un error; inténtelo de nuevo",
    "tabs": "Pestañas",
    "showPassword": "Mostrar contraseña",
    "hidePassword": "Ocultar contraseña",
    "goToHomepage": "Ir a la página de inicio",
    "leadConnectorHqLogo": "Logotipo de Lead Connector HQ",
    "companyLogo": "Logotipo de la empresa",
    "countries": {
      "australia": "Australia",
      "austria": "Austria",
      "czechRepublic": "Chequia",
      "belgium": "Bélgica",
      "brazil": "Brasil",
      "canada": "Canadá",
      "chile": "Chile",
      "denmark": "Dinamarca",
      "switzerland": "Suiza",
      "germany": "Alemania",
      "estonia": "Estonia",
      "spain": "España",
      "finland": "Finlandia",
      "france": "Francia",
      "uk": "Reino Unido",
      "hongKong": "Hong Kong",
      "hungary": "Hungría",
      "ireland": "Irlanda",
      "italy": "Italia",
      "japan": "Japón",
      "kenya": "Kenia",
      "lithuania": "Lituania",
      "mexico": "México",
      "netherlands": "Países Bajos",
      "newZealand": "Nueva Zelanda",
      "norway": "Noruega",
      "philippines": "Filipinas",
      "puertoRico": "Puerto Rico",
      "poland": "Polonia",
      "portugal": "Portugal",
      "sweden": "Suecia",
      "singapore": "Singapur",
      "unitedStates": "Estados Unidos",
      "vietnam": "Vietnam",
      "southAfrica": "Sudáfrica"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "UE",
      "in": "IN",
      "na": "N. a.",
      "us": "EE. UU."
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "IVA",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Editar grupo de números - <strong>{name}</strong>",
      "displayphonenumber": "mostrarNúmeroDeTeléfono",
      "js_heap_memory": "Memoria Heap de JS",
      "vuex_store_modules": "Módulos Vuex Store",
      "vuex_store_size": "Tamaño de Vuex Store",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "modelo-imagen",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "archivo de imagen",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://ejemplo.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com o campaña_utm=xyz",
      "websitecom": "páginaweb.com",
      "strongshakenstirstrongVerifica": "La verificación <strong>SHAKEN/STIR</strong> está completa para su subcuenta. Gánese la confianza de sus clientes a través de llamadas verificadas.",
      "mp3wavfile": "archivo mp3/wav",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Paso {currentStep} de {totalSteps}",
    "loadMore": "Cargar más",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "Un segmento equivale a un SMS de 160 caracteres. Haga clic en el icono para obtener más información sobre los precios.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "Un segmento equivale a un SMS de 160 caracteres Haga clic en el icono para obtener más información sobre los precios.",
    "_email": "/ correo electrónico",
    "_ip": "/ IP",
    "_min": " /min",
    "_of_total": "% del total",
    "_please_add_a_payment_method_for": "Añada un método de pago para ",
    "_segment": " / segmento",
    "_used": "% utilizado",
    "a_new_twilio_account_needs_to_be_created_before_we": "Es necesario crear una nueva cuenta de Twilio antes de que podamos empezar a refacturar",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Una subcuenta puede tener hasta 10 objetos personalizados. Si se excede el límite, no se crearán objetos personalizados a partir de esta instantánea.",
    "a_twilio_account_is_already_setup_for_this_location": "Ya hay una cuenta de Twilio configurada para esta ubicación",
    "accountName": "Nombre de la cuenta",
    "account_sid": "SID de la cuenta:",
    "action": "Acción",
    "actions": "Acciones",
    "activate": "Activar",
    "active": "Activo",
    "active_listeners": "Oyentes activos",
    "active_subscriptions": "Suscripciones activas",
    "ad_manager": " Administrador de anuncios",
    "add": "Añadir",
    "addAction": "Añadir acción",
    "add_eliza": "Añadir Eliza",
    "add_image": "Añadir imagen",
    "add_payment_method": "Añadir método de pago",
    "add_to_account": "Añadir a la cuenta",
    "add_user_icon": "Añadir icono de usuario",
    "add_your_first_email": "Añada su primer correo electrónico.",
    "address": "Dirección",
    "adwords_reporting": "Informes de Adwords",
    "affiliate_manager": "Gestor de afiliados",
    "agency": "Agencia",
    "agency_logo": "logotipo de la agencia",
    "agency_settings": "Configuración de la agencia",
    "agent_reporting": "Informes de los agentes",
    "ai_employee": " AI Employee ",
    "all": "Todo",
    "allow_subaccounts_to_cancel_their_subscription": "Permita que las subcuentas cancelen su suscripción",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Permita que las subcuentas se actualicen a un plan superior",
    "allowed_format": "Formato permitido:",
    "am": "a. m.",
    "announcements_click_to_open_in_new_tab": "Anuncios - haga clic para abrir en una nueva pestaña",
    "answers": "Respuestas",
    "app_name": "Nombre de la aplicación",
    "appointments": "Citas",
    "apps": " aplicaciones",
    "ask_ai": "Preguntar a la IA",
    "ask_anything": "Pregunte lo que quiera...",
    "assigned_to_another_user": "(Asignado a otro usuario)",
    "at_least_one_location_is_required": "Se requiere al menos una ubicación",
    "attach_snapshot": "Adjuntar instantánea",
    "attribution_reporting": "Informes de atribución",
    "authorized_representative": "Representante autorizado",
    "automation_type": "Tipo de automatización",
    "available_hours": "Horas disponibles",
    "avg_memoryinstance": "Memoria media/instancia",
    "back": "Atrás",
    "base_url": "URL base",
    "between_10_kb_and_5_mb": " Entre 10 KB y 5 MB",
    "birthday_sms": "SMS de cumpleaños",
    "birthday_sms_with_image": "SMS de cumpleaños con imagen",
    "blogging": "Bloguear",
    "bounced": "Rebotado",
    "bulk_requests": "Solicitudes masivas",
    "business_email": "Correo electrónico de la empresa",
    "business_hours_configurations": "Configuraciones de Horario Comercial",
    "business_industry": "Sector de la empresa",
    "business_information": "Información de la empresa",
    "business_logo": "Logotipo de la empresa",
    "business_niche": "Nicho de negocio",
    "business_phone": "Teléfono de empresa",
    "business_physical_address": "Dirección física de la empresa",
    "business_regions_of_operations": "Regiones de operación de la empresa",
    "business_registration_id_type": "Tipo de ID de registro de la empresa",
    "business_registration_number": "Número de registro de la empresa",
    "business_type": "Tipo de empresa",
    "business_website": "Sitio web de la empresa",
    "busy": "Ocupado",
    "buttons": {
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "deleteAll": "Borrar todo",
      "view": "Visualizar",
      "close": "Cerrar",
      "previous": "Anterior",
      "next": "Siguiente",
      "clear": "Borrar",
      "save": "Guardar",
      "edit": "Editar",
      "delete": "Eliminar",
      "reset": "Restablecer",
      "refresh": "Actualizar",
      "nextLoading": "Siguiente...",
      "copied": "Copiado",
      "notNow": "Ahora no",
      "send": "Enviar",
      "send1": "Enviar",
      "download": "Descargar",
      "sendNow": "Enviar ahora",
      "saved": "Guardado",
      "back": "Atrás",
      "update": "Actualizar",
      "add": "Añadir",
      "submit": "Enviar",
      "submitting": "Enviando",
      "done": "Hecho",
      "manageUsers": "Gestionar usuarios",
      "no": "No",
      "yes": "Sí"
    },
    "calendar": "Calendario",
    "calendar_groups": "Grupos de calendarios",
    "call": "Llamar",
    "call_reporting": "Informes de llamadas",
    "call_tracking_is_disabled": "El seguimiento de llamadas está desactivado",
    "call_voicemail_settings": "Configuración de llamadas y del buzón de voz",
    "calls": " llamadas",
    "campaign": "Campaña",
    "campaigns": "Campañas",
    "cancel": " Cancelar ",
    "cancel_subscription": "Cancelar la suscripción",
    "cancelled": "Cancelado",
    "certificates": "Certificados",
    "change": "Cambio",
    "changed_data": "Datos cambiados",
    "charge": " Cargo",
    "charged_to_customer": "Cobrado al cliente",
    "chat": "Chatear",
    "chat_user": "Usuario de Chat",
    "chat_widget_icon": "Icono de Widget de Chat",
    "chats_will_be_saved_for_2_days": "Los chats se guardarán por dos días",
    "check": "comprobar",
    "check_number_validity_before_first_sms_block_incom": "Compruebe la validez del número antes del primer SMS, bloquee las llamadas entrantes de correo no deseado y busque los nombres de los desconocidos antes de contestar al teléfono. Se aplican cargos adicionales",
    "cinque_terre": "Cinque Terre",
    "city": "Ciudad",
    "clear_history": "Borrar historial",
    "click_here": "Haga clic aquí",
    "click_on_create_new_snapshot_to_add_one": " Haga clic en Crear nueva instantánea para añadir una.",
    "click_to_access_the_highlevel_welcome_course": "Haga clic para acceder al Curso de Bienvenida de HighLevel",
    "click_to_upgrade": "Hacer clic para mejorar",
    "clicked": "Clicado",
    "clio": "Clio",
    "cloning": "Clonando",
    "close_debugger": "Cerrar el depurador",
    "close_whatsapp_template_creator": "Cerrar Creador de Plantillas de WhatsApp",
    "collection": "Colección",
    "columns": "Columnas",
    "coming_soon": "Próximamente",
    "company_email_": "Correo electrónico de la empresa (",
    "complete_component_data": "Datos completos del componente",
    "complete_event_data": "Datos completos del evento",
    "complete_query_data": "Datos completos de consulta",
    "completed": "Completada",
    "complimentary_credits": "Créditos gratuitos",
    "component": "Componente",
    "component_name": "Nombre del Componente",
    "component_type": "Tipo de componente",
    "components": " Componentes",
    "condition": "Condición",
    "confirm": "CONFIRMAR",
    "confirmation_message": "Mensaje de confirmación",
    "confirmed": "Confirmado",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Conéctese con un administrador certificado, haga clic para abrir en una nueva pestaña",
    "connect_with_us_start_live_chat": "Conéctese con nosotros: abra un chat en tiempo real",
    "connect_your_stripe_account": "conecte su cuenta de Stripe ",
    "connect_zoom": "Conectar a Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Considere dejarlo en blanco si decide utilizar la ubicación de reunión preconfigurada",
    "contact": "Contacto",
    "contact_support": "contactar con el servicio de asistencia",
    "contact_us_call_highlevel_at_18887324197": "Contáctenos - llame a HighLevel al +1(888)732-4197",
    "contacts": "Contactos",
    "content_ai": "Content AI",
    "controls": "Controles",
    "conversations": "Conversaciones",
    "copied": "Copiado",
    "cost_borne_by_you": " coste asumido por usted",
    "count": "Recuento",
    "country": "País",
    "createNewFolder": "Crear nueva carpeta",
    "credit_balance": "SALDO DE CRÉDITO",
    "current_location_id": "ID de ubicación actual",
    "custom": "Personalizado",
    "custom_email": "Correo electrónico personalizado",
    "custom_niche": "Nicho personalizado",
    "customer_notifications": "Notificaciones al cliente",
    "customize": "Personalizar",
    "customize_chat_widget": "Personalizar Widget de Chat",
    "dashboard_stats": "Estadísticas del tablero",
    "data_keys": "Claves de datos",
    "date": "Fecha",
    "days": "Días",
    "dedicated_ip": "IP dedicada ",
    "default": "Por defecto",
    "default_snapshots": "Instantáneas predeterminadas",
    "delete": "Borrar",
    "deleted": "eliminado",
    "delivered": "Entregado",
    "description": "Descripción",
    "details": "Detalles",
    "disable_gbp_messaging_not_recommended": "deshabilitar la mensajería GBP (no recomendado)",
    "disable_tracking": "Deshabilitar el seguimiento",
    "disabled": "Deshabilitado",
    "dismiss": "Descartar",
    "display_name": "Nombre para mostrar",
    "do_not_delete": "no borrar",
    "do_something": "HAGA ALGO",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "¿Desea mantener el mismo o crear uno nuevo?",
    "download_application_icon": "Descargar icono de la aplicación",
    "draft": "Borrador",
    "dropdown_icon": "icono de menú desplegable",
    "duplicate": "Duplicar",
    "duration": "Duración",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Etiqueta Derivación de Eliza (opcional)",
    "eliza_is_required": "Se requiere Eliza.",
    "eliza_service": "Servicio Eliza",
    "email": "Correo electrónico",
    "email_resell_settings": "Configuración de reventa de correo electrónico",
    "email_sending": "Envíos de correos electrónicos",
    "email_signature": "Firma de Correo Electrónico",
    "enable": "Habilitar",
    "enable_beta": " Habilitar beta",
    "enable_company_automation": "Habilite la automatización de la empresa",
    "enable_disable_deprecated_features": "Habilitar/deshabilitar funciones obsoletas",
    "enable_gbp_call_tracking": " Habilitar el seguimiento de llamadas GBP ",
    "enable_gbp_messaging": "habilitar la mensajería de GBP",
    "enable_signature_on_all_outgoing_messages": "Habilitar la firma en todos los mensajes salientes",
    "enabled": "Habilitado",
    "notEnabled": "No está habilitado",
    "enter_a_logical_name": "Introduzca un nombre lógico",
    "enter_the_exact_business_address_as_it_appears_in_": "Introduzca la dirección exacta de la empresa tal como aparece en el EIN.",
    "enter_the_exact_legal_business_name_as_registered_": "Introduzca el nombre legal exacto de la empresa, tal como está registrado en el EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Introduzca la dirección completa tal como aparece en el listado del EIN.",
    "enter_user_email": "Introduzca el correo electrónico del usuario",
    "enter_user_phone_number": "Introduzca el número de teléfono del usuario",
    "enter_your_business_registration_id_type": "Introduzca el tipo de ID de registro de su empresa",
    "enter_your_business_vertical_eg_travel": "Introduzca su sector de actividad (p. ej.: viajes)",
    "error_code": "Código de error",
    "error_code_chart": "Gráfico de códigos de error",
    "error_while_copying_api_key": "¡Error al copiar la clave de API!",
    "event": "Evento",
    "event_bus_listeners": "Oyentes de Event Bus",
    "events": " eventos",
    "everything_in": "Todo en ",
    "exact": "Exacto",
    "execute_this_action_if_the_current_time_falls_in_t": "Ejecute esta acción si la hora actual está dentro de esta ventana; de lo contrario, espere hasta la siguiente ventana para ejecutar esta acción.",
    "extension": "Extensión",
    "facebook": "Facebook",
    "facebook_ads": "Anuncios de Facebook",
    "facebook_ads_reporting": "Informe de Facebook Ads",
    "facebook_adsets": "Conjuntos de anuncios de Facebook",
    "facebook_campaigns": "Campañas de Facebook",
    "facebook_icon": "Icono de Facebook",
    "facebook_page": "Página de Facebook",
    "feature_image": "imagen destacada",
    "features": "Características:",
    "feedback": "Comentarios: ",
    "file_path": "Ruta de archivo",
    "firestore_listeners": "Oyentes de Firestore",
    "forms": "Formularios",
    "free": "Gratis",
    "fri": "Vier.",
    "friendly_business_name": "Nombre comercial claro",
    "from": " de ",
    "funnels": "Embudos",
    "gbp_call_tracking": "Seguimiento de llamadas GBP",
    "gbp_configuration": "Configuración de GBP",
    "general": "General",
    "general_information": "Información general",
    "generating_link_please_wait": "Generando el enlace, espere...",
    "google_ads_adgroups": "Grupos de anuncios de Google Ads",
    "google_ads_ads": "Anuncios de Google Ads",
    "google_ads_campaigns": "Campañas de Google Ads",
    "google_ads_keywords": "Palabras clave de Google Ads",
    "google_business_messaging": "Mensajería empresarial de Google",
    "google_business_profile": "Perfil de Google Business",
    "google_my_business_icon": "Icono de Google My Business",
    "hello": "Hola ",
    "here": "aquí",
    "hhmm_a": "hh:mm A",
    "hi": "Hola ",
    "hide": "Ocultar",
    "highlevel_events_click_to_open_in_new_tab": "Eventos de alto nivel - haga clic para abrir en una nueva pestaña",
    "how_can_i_help_you_today": "¿En qué puedo ayudarle hoy?",
    "how_did_the_call_go": "¿Cómo fue la llamada?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "¿Cómo calculo el coste de mi correo electrónico? Haga clic en el icono para saber más",
    "how_does_it_work": "¿Cómo funciona?",
    "htmlElement": "Elemento HTML (TODO):",
    "html_element_todo": "Elemento HTML (TODO): ",
    "id": "ID: ",
    "if": "Si",
    "if_activated_the_sender_information_will_be_automa": "Si está activado, la información del remitente se añadirá automáticamente al primer mensaje SMS de cualquier mensaje masivo para garantizar el cumplimiento y aumentar las tasas de entrega.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Si está activado, insertaremos enlaces para cancelar la suscripción en los pies de página de su correo electrónico para que los destinatarios puedan cancelar la suscripción sin marcar el correo electrónico como queja o correo no deseado.",
    "ignore_this_update": "Ignore esta actualización",
    "image": "imagen",
    "image_turned_on": "Imagen activada",
    "imported_date": "Fecha de importación",
    "imported_snapshots": "Instantáneas importadas",
    "inbound": "Entrante",
    "inbound_number": "Número entrante",
    "incoming_call_timeout": "Tiempo de espera de llamadas entrantes",
    "instance_id": "ID de Instancia",
    "instances": "Instancias: ",
    "instructions_mentioned_in_this_page": "instrucciones mencionadas en esta página",
    "internal": "Interno",
    "intro_message": "Mensaje de Introducción",
    "intro_question": "Pregunta de Introducción",
    "invalid": "No válido",
    "invoicing": "Facturación",
    "is_scheduled_for_deletion_on": " Está programado para ser eliminado el ",
    "job_position": "Puesto de trabajo",
    "job_title": "Cargo",
    "join_our_facebook_group_click_to_open_in_new_tab": "Únase a nuestro grupo de Facebook - haga clic para abrir en una nueva pestaña",
    "jpg_or_png": " JPG o PNG ",
    "just_one_sec": "Un momento...",
    "key_sizes": "Tamaños de clave",
    "label": "etiqueta",
    "labels": {
      "sortDirection": "Dirección de la ordenación",
      "tableStyling": "Estilo de tabla",
      "loadingMore": "Cargando más…",
      "loading": "Cargando…",
      "filter": "Filtrar",
      "search": "Buscar...",
      "sortBy": "Filtrar por",
      "perPage": "Por página",
      "date": "Fecha",
      "time": "Hora",
      "readMore": "Leer más",
      "day": "Día",
      "slot": "Franja horaria",
      "template": "Plantilla",
      "city": "Ciudad",
      "country": "País",
      "state": "Región/provincia/estado",
      "customerName": "Nombre del cliente",
      "friendlyName": "Nombre descriptivo",
      "required": "* obligatorio",
      "addressLine1": "Línea de dirección 1",
      "addressLine2": "Línea de dirección 2",
      "postalCode": "Código postal",
      "searchUsers": "Buscar usuarios",
      "unknown": "Desconocido",
      "businessName": "Nombre de la empresa"
    },
    "last_updated": "Última actualización",
    "launchpad_icon": "icono de Launchpad",
    "lead": "Cliente potencial",
    "leadconnector": "LeadConnector",
    "learn_how": "(Descubra cómo)",
    "legal_business_name": "Nombre legal de la empresa",
    "limit_updated_from": " Límite actualizado desde ",
    "listeners": " oyentes",
    "loading_your_conversation_history": "Cargando su historial de conversaciones...",
    "location": "Ubicación",
    "locations": " ubicaciones",
    "logical_name": "Nombre lógico",
    "logical_name_is_required": "El nombre lógico es obligatorio.",
    "logo": "Logotipo",
    "mailgun": "MailGun",
    "making_calls": "Haciendo llamadas",
    "manage_custom_email": "Administrar correo electrónico personalizado",
    "marketing": "Marketing",
    "maximize": "Maximizar",
    "me_": "Yo (",
    "member_since": "Miembro desde",
    "membership": "Suscripción",
    "memory_analysis": "Análisis de Memoria",
    "memory_api_not_available": "API de memoria no disponible",
    "message": "Mensaje",
    "minimize": "Minimizar",
    "minimum_must_be": " El mínimo debe ser ",
    "miscellaneous_charges": "Cargos diversos",
    "missed_call_text_back": "Mensaje de respuesta para las llamadas perdidas",
    "missed_text_back_call_message": "Texto del mensaje de respuesta para las llamadas perdidas",
    "model": "Modelo",
    "module": "Módulo",
    "modules": " módulos",
    "mon": "Lun.",
    "month": "/mes",
    "monthly": "mensualmente",
    "more_emails_in_thread": " más correos electrónicos en el hilo",
    "mount_count": "Recuento de montajes",
    "mount_time": "Tiempo de montaje",
    "moved_to_calendar_settings": "Trasladado a la configuración del calendario",
    "multiple_locations_using_same_twilio_account": "Varias ubicaciones usando la misma cuenta de twilio",
    "must_be_in_range_of_0": " Debe estar en el rango de 0-",
    "must_be_less_than_monthly_plan_12": " Debe ser inferior al plan mensual * 12 ",
    "my_business_is": "Mi empresa es ",
    "my_snapshots": "Mis instantáneas",
    "name": "Nombre",
    "name_of_other_registration_id_type": "Nombre de otro tipo de ID de registro",
    "newFolder": "Nueva carpeta",
    "new_task_update": "¡Nueva actualización de la tarea!",
    "next": "Siguiente",
    "no_answer": "Sin respuesta",
    "no_bigger_than_25mb": "no más de 2,5 MB",
    "no_customer_selected": "No se ha seleccionado ningún cliente",
    "no_error_data_found": "No se han encontrado datos de error",
    "no_payment_method_available": "No hay un método de pago disponible",
    "no_provider_found": "No se ha encontrado ningún proveedor",
    "no_snapshots_found": "¡No se han encontrado instantáneas!",
    "noshow": "No asistida",
    "not": "No",
    "not_now": "Ahora no",
    "not_saved": "No guardado",
    "notes": "Notas",
    "notifications": "Notificaciones",
    "now": "Ahora",
    "numbers_and": " número(s) y ",
    "objective": "Objetivo:",
    "of": "de",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Tutoriales en vídeo de incorporación - haga clic para abrir en una nueva pestaña",
    "online_listings": "Listados en línea",
    "only_assigned_data": "Solo datos asignados",
    "open_performance_debugger": "Abrir depurador de rendimiento",
    "opened": "Abierto",
    "opportunities": "Oportunidades",
    "options": {
      "ascending": "Ascendente",
      "descending": "Descendente",
      "none": "-- Ninguno --"
    },
    "or_drag_and_drop": "o arrastre y suelte",
    "outbound": "Saliente",
    "pagination": "Paginación",
    "pass_body_content_here": " Pase el contenido del cuerpo aquí ",
    "password": "Password",
    "paused": "En pausa",
    "payment_links": "Enlaces de pago",
    "payment_methods": "Métodos de pago",
    "payment_refund": "Reembolso de Pago",
    "payment_settings_navigation": "Navegación de configuración de pago",
    "payments": "Pagos",
    "payments_integration": "Integración de pagos",
    "pending": "Pendiente",
    "per_page": "Por página",
    "percentage": "Porcentaje",
    "permanently_delete_this_email": "Borre permanentemente este correo electrónico",
    "personal_logo": "Logotipo personal",
    "phone": "Teléfono",
    "phone_number_with_country_code": "Número de teléfono (con código de país)",
    "pick_a_niche": "Seleccionar un nicho",
    "pick_a_snapshot": "Elegir una instantánea",
    "pick_business_industry": "Seleccionar sector de la empresa",
    "pick_business_registration_id_type": "Seleccionar tipo de ID de registro de la empresa",
    "pick_business_type": "Seleccionar tipo de empresa",
    "pick_job_position": "Seleccionar puesto de trabajo",
    "plans_pricing": "Planes y precios",
    "please_enter_a_value_greater_than_20": "Introduzca un valor mayor que 20.",
    "pm": "p. m.",
    "points": "Puntos",
    "postalzip_code": "Código postal",
    "previous": "Anterior",
    "privacy_policy_url": "URL de la política de privacidad",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "La URL de la política de privacidad se mostrará en la información de su agente de Google.",
    "process_your_payment": "Procese su pago",
    "profile_picture": "Foto de perfil",
    "profit": "Beneficio",
    "prospecting": " Prospección ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Proporcione instantáneas precreadas a las nuevas cuentas.",
    "queries": " consultas",
    "questions": "Preguntas",
    "quick_actions_icon": "Icono de acciones rápidas",
    "re_generate_key": "Regenerar clave",
    "read_only": "Solo Lectura",
    "receipts_settings": "Configuración de los recibos",
    "receiving_calls": "Recibir llamadas",
    "recent_events": "Eventos recientes",
    "recommended": "Recomendado",
    "recommended_resolution": "Resolución recomendada:",
    "reconnect": "Reconectar ",
    "record_payment": "Registrar el pago",
    "registered": " registrado.",
    "renameFolder": "Renombrar carpeta",
    "replied": "Respondido",
    "representative_email": "Correo electrónico del representante",
    "resell_settings": " Configuración de reventa",
    "reset": "Restablecer",
    "resolve_now": "Resolver ahora",
    "resource_counts": "Recuentos de recursos",
    "restore": "Restaurar",
    "results": "Resultados",
    "reviews": "Reseñas",
    "rollover_unused_credits_to_next_month": "Transfiera los créditos no utilizados al próximo mes",
    "row": " fila",
    "runNow": "Ejecutar ahora",
    "sample_data": "(Datos de muestra)",
    "sat": "Sáb.",
    "save": "Guardar",
    "save_missed_call_text_settings": "Guardar la configuración de texto de llamadas perdidas",
    "save_staging_url": "Guardar URL provisional",
    "saved": "Guardado",
    "saving": "Guardando…",
    "search": "Buscar",
    "search_active_apps": "Buscar en las aplicaciones activas...",
    "search_components": "Buscar componentes...",
    "search_customer": "Buscar cliente",
    "search_email": "Buscar Correo Electrónico",
    "search_history": "Historial de búsqueda...",
    "search_icon": "icono de búsqueda",
    "search_listeners": "Buscar oyentes...",
    "search_modules": "Buscar módulos...",
    "search_queries": "Buscar consultas...",
    "see_this_review_on_gbp": "Ver esta reseña en GBP ",
    "segments": " segmentos",
    "select": "Seleccionar",
    "select_a_snapshot": "Seleccionar una instantánea",
    "monetary": "MONETARIO",
    "pleaseSelectAValue": "Seleccione un valor",
    "select_account": "Seleccionar cuenta",
    "select_an_account": "Seleccionar una cuenta",
    "select_eliza_bypass_tag": "Seleccione la etiqueta Eliza Bypass",
    "select_phone_number": "Seleccione el número de teléfono",
    "select_send_to_eliza_tag": "Seleccionar la etiqueta Enviar a Eliza",
    "select_snapshot": " Seleccionar instantánea",
    "select_upto": "Seleccione hasta ",
    "selected": "Seleccionado: ",
    "send": "Enviar",
    "send_to_eliza_tag_optional": "Etiqueta Enviar a Eliza (opcional) ",
    "seo": " SEO ",
    "settings": "Configuración",
    "setup_pending": "Configuración Pendiente",
    "share": "Compartir",
    "shared_snapshots": "Instantáneas compartidas",
    "shared_type": "Tipo compartido",
    "shipping_and_delivery": "Envío y entrega",
    "shipping_origin": "Origen del envío",
    "show": "Mostrar",
    "showed": "Asistido",
    "signin_with_single_signon": "Iniciar sesión con el inicio de sesión único",
    "size": "Tamaño",
    "sms_message_sent_to_customer": "Mensaje SMS enviado al cliente",
    "snapshot_date": "Fecha de la instantánea",
    "snapshot_name": "Nombre de la instantánea",
    "social_planner": "Planificador de redes sociales",
    "sortBy": "Filtrar por",
    "sortOptions": {
      "createdDate": "Fecha de creación"
    },
    "source": "Fuente",
    "sources": "Fuentes:",
    "spent": "Gastado",
    "staging_url_settings_for_db_event": "Configuración de la URL provisional (para evento de base de datos)",
    "state": "Región/provincia/estado",
    "state_prov_region_": "Estado / prov. / región*",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "California",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "Distrito de Columbia",
      "florida": "Florida",
      "georgia": "Georgia",
      "hawaii": "Hawái",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Luisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Míchigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "Nuevo Hampshire",
      "new_jersey": "Nuevo Jersey",
      "new_mexico": "Nuevo México",
      "new_york": "Nueva York",
      "north_carolina": "Carolina del Norte",
      "north_dakota": "Dakota del Norte",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregón",
      "pennsylvania": "Pensilvania",
      "rhode_island": "Rhode Island",
      "south_carolina": "Carolina del Sur",
      "south_dakota": "Dakota del Sur",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginia",
      "washington": "Washington",
      "west_virginia": "Virginia Occidental",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "No se han encontrado registros",
      "noEntriesToShow": "No hay entradas que mostrar",
      "unsuccessful": "No ha funcionado",
      "pending": "Pendiente",
      "noUsersFound": "No se han encontrado usuarios"
    },
    "status": "Estado",
    "stop_delete_operation": "Detener la operación de eliminación",
    "street_address": "Dirección postal",
    "street_address_as_it_appears_in_the_ein_listing": "Dirección postal tal como aparece en el EIN.",
    "stripe_icon": "Icono de Stripe",
    "stripe_integration": "Integración de Stripe",
    "stripe_secret_key": "Clave secreta de Stripe",
    "subscriptions": "Suscripciones",
    "sun": "Dom.",
    "surveys": "Encuestas",
    "suspend_subaccount_when_their_saas_subscription_fa": "Suspenda la subcuenta cuando falle su suscripción SaaS.",
    "switchAccount": "Cambiar cuenta",
    "switch_off_sections_below_to_disable": "Desactive las secciones a continuación para deshabilitarlas",
    "tags": "Palabras clave",
    "tax_settings": "Configuración de tasas",
    "team_management": "Gestión de equipos",
    "team_notifications": "Notificaciones de equipo",
    "template": "Plantilla",
    "terms_and_conditions": "Términos y condiciones",
    "test_mobile_no": "Prueba de n.º de móvil",
    "text_messages": "Mensajes de texto",
    "the_proposed_size_is_350px_180px": "El tamaño propuesto es de 350 × 180 px",
    "the_proposed_size_is_512512px": "El tamaño propuesto es 512 x 512 px",
    "the_selected_language_will_be_used_by_the_system_a": "El idioma seleccionado será utilizado por el sistema como predeterminado.",
    "the_welcome_message_automatically_appears_after_a_": "El mensaje de bienvenida aparece automáticamente después de que un usuario inicie una nueva conversación.",
    "these_are_margins_that_are_billed_to_your_clients_": "Son márgenes que se facturan a sus clientes sobre el ",
    "this_data_will_be_used_for_future_compliance_regis": "Estos datos se utilizarán para el registro futuro de conformidad.",
    "this_is_my_twilio_use_same": "Este es mi Twilio, use el mismo",
    "this_is_visible_to_both_agency_and_location": "Esto es visible tanto para la agencia como para la ubicación",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Este nombre será visible para los clientes potenciales que chateen con su empresa",
    "this_setting_is_applicable_with_only_team_calendar": "Esta configuración es aplicable solo a los calendarios de equipo.",
    "this_stripe_customer_is_already_connected_to_anoth": "Este cliente de Stripe ya está conectado a otra subcuenta.",
    "thu": "Jue.",
    "tiktok": "Tiktok",
    "time_signed": " Hora de la firma: ",
    "time_zone_": "Zona horaria *",
    "timestamp": "Marca de tiempo",
    "title": "Título",
    "to_resolve_this_problem_follow_the": "Para resolver este problema, siga las ",
    "token": "Token:",
    "total": "Total: ",
    "trigger_link": "Enlace de activación",
    "triggers": "Activadores",
    "tue": "Mar.",
    "twilio": "Twilio",
    "twilio_setup_pending": "Configuración de Twilio pendiente",
    "type": "Tipo",
    "type_campaign_objective": "Escriba el objetivo de la campaña",
    "type_message": "Escribir mensaje",
    "unsavedChangesWarning": "Sus cambios no se guardarán. ¿Seguro que desea salir?",
    "unsaved_changes": "Cambios no guardados",
    "unsubscribed": "Suscripción cancelada",
    "unsuccessful": "No ha funcionado",
    "update_business_profile_details": "Actualizar los detalles del perfil de la empresa",
    "update_is_inprogress_visit_integrations_page_to_fi": "La actualización está en curso. Visite la página de integraciones para obtener más información.",
    "update_url": "Actualizar URL",
    "updated_date": "Fecha actualizada",
    "updates": " Actualizaciones",
    "updating": "Actualizando…",
    "upgrade_to_agency_pro": "Actualizar a Agency Pro ",
    "upload": "Subir",
    "upload_a_file": "Suba un archivo",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Utilícelo para la integración con Zapier y API.",
    "user_email": "Correo electrónico del usuario",
    "user_permissions": "Permisos de usuario",
    "user_role": "Rol de usuario",
    "user_type": "Tipo de usuario",
    "valid": "Válido",
    "verification_status": "Estado de verificación",
    "verify": "Verificar",
    "verify_email_using_otp": "Verifique el correo electrónico usando OTP",
    "view_less": " Ver menos ",
    "visiblehidden": "Visible/Oculto",
    "visit_our_help_center_click_to_open_in_new_tab": "Visite nuestro centro de ayuda, haga clic para abrirlo en una nueva pestaña",
    "voicemail": "Mensaje de voz",
    "wave_integration": "Integración de Wave",
    "we_have_found_some_errors_in_your_contact_fields_c": "Hemos encontrado algunos errores en los campos de sus contactos. Haga clic en la carpeta para verla y resolverla.",
    "websites": "Sitios web",
    "wed": "Miér.",
    "welcome_message": "Mensaje de bienvenida",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "Icono de WhatsApp",
    "when": "Cuando",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Cuando esté seleccionado, las llamadas se dirigirán a su aplicación móvil. (Compatible con ambos iOS y Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Cuando esté seleccionado, las llamadas se dirigirán a su aplicación web.",
    "which_business_do_you_want_to_link_to_this_locatio": "¿Con qué empresa desea vincular esta ubicación?",
    "widget_code": "Código del Widget",
    "will_give_you_about": " obtendrá aproximadamente",
    "wordpress": "WordPress",
    "wordpress_icon": "Icono de WordPress",
    "workflows": "Flujos de trabajo",
    "xero_integration": "Integración de Xero",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Debe seguir unos sencillos pasos antes de eliminar esta ubicación",
    "you_are_not_authorized_to_perform_this_action_only": "No tiene autorización para realizar esta acción. Únicamente los administradores de la agencia pueden eliminar subcuentas.",
    "your_email_cost": "El coste de su correo electrónico",
    "your_facebook_page_has_been_integrated_however_the": "Su página de Facebook ha sido integrada. Sin embargo, las siguientes funciones no funcionarán, ya que LeadConnector no tiene los permisos requeridos: ",
    "your_outlook_connection_has_expired_please_disconn": "Su conexión de Outlook ha caducado. Desconéctese y luego vuelva a conectarse con la cuenta para establecer la conexión.",
    "zip_code": "Código postal",
    "zoom_connected_please_close_this_modal": "Zoom conectado, cierre este modal",
    "hidden": "Oculto",
    "messageDetails": "Información del mensaje",
    "openOptions": "Abrir opciones",
    "progress": "Progreso",
    "close": "Cerrar",
    "loading": "Cargando",
    "fullName": "Nombre completo",
    "languages": "Idiomas",
    "phoneNumber": "Número de teléfono",
    "phoneNumberWithCountry": "Número de teléfono con código de país",
    "sendMessage": "Subir Mensaje",
    "services": "Servicios",
    "servicesProvided": "Servicios proporcionados",
    "pleaseProvideAValid": "Proporcione un número de teléfono válido.",
    "copy": "Copiar",
    "editApiKey": "Editar clave API",
    "confirmPay": "Confirmar y pagar",
    "contactUs": "Contacte con nosotros",
    "decline": "Rechazar",
    "deleteSubaccount": "Eliminar subcuenta",
    "disabled1": "deshabilitado",
    "purchaseSummary": "Resumen de la compra",
    "subscriptionPlan": "Plan de suscripción",
    "businessName": "Nombre comercial",
    "chooseOne": "Seleccionar un...",
    "stateProvRegion": "Estado / prov. / región",
    "streetAddress": "Dirección postal",
    "timeZone": "Zona horaria",
    "website": "Sitio web",
    "zipPostalCode": "Código postal",
    "apiKey": "Clave API",
    "createdAt": "Creado en",
    "deleteAllLocationApi": "Eliminar todas las claves API de la ubicación",
    "deleteApiKey": "Eliminar clave API",
    "generatedBy": "Generado por",
    "lastUsedAt": "Último uso el",
    "pageNavigation": "Navegación por la página",
    "somethingWentWrong": "¡Algo ha salido mal!",
    "clickHere": "Haz clic aquí",
    "emailRebillingActive": "Refacturación por correo electrónico activa",
    "saasSubscriptionActive": "Suscripción SaaS activa",
    "scheduledForDeletion": "Programado para su eliminación",
    "twilioRebillingActive": "Refacturación de Twilio activa",
    "iAcknowledgeThisIs": "Confirmo que esta es una subcuenta válida y he verificado el caso de uso para enviar más de {limit} {type} al día",
    "iAcknowledgeThisIs1": "Confirmo que se trata de una subcuenta válida y he verificado el caso de uso del envío, por lo que he ajustado el límite diario de SMS",
    "emailSentByLocation": "Correos electrónicos enviados por localización en lo que va de día.",
    "goToSmsLimit": "Ir a la configuración del límite de SMS",
    "toIncreaseTheLimit": "Para ampliar aún más el límite, póngase en contacto con el equipo de asistencia.",
    "newLimitOfLimit": "El nuevo límite de {limit} no es válido. Proporcione un valor entre {min} y {max}",
    "typeLimitUpdatedSuccessfully": "El límite {type} se ha actualizado correctamente",
    "locationsCurrentLimitIs": "El límite actual de la ubicación es de {current}. Solo puede actualizar el límite entre {min} y {max} desde aquí. Para cualquier actualización de límite más allá de {maxAllowed}, póngase en contacto con el equipo de asistencia.",
    "notNow": "Ahora no",
    "smsSentByLocation": "SMS enviados por ubicación en lo que va de día.",
    "youHaveSuccessfullyUpdated": "Ha actualizado correctamente el límite",
    "willAutoUnlockIn": "Se desbloqueará automáticamente en",
    "contactType": "Tipo de contacto",
    "createdBy": "Creado por:",
    "createdOn": "Creado el:",
    "dateOfBirth": "Fecha de nacimiento",
    "emailAddress": "Dirección de correo electrónico",
    "firstName": "Nombre",
    "lastName": "Apellidos",
    "twilioLookupMarkedThis": "Twilio Lookup ha marcado este número de teléfono como no válido.",
    "twilioLookupStatedThis": "Twilio Lookup ha indicado que se trata de un número {type}, por lo que no recibirá SMS.",
    "accountSnapshot": "Instantánea de la cuenta",
    "auditLogs": "Registros de auditoría",
    "account": "Cuenta",
    "selectAccount": "Seleccionar cuenta",
    "facebookUrl": "URL de Facebook",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "URL de X",
    "youtubeUrl": "URL de YouTube",
    "text": "Texto",
    "allTagsLinkedTo": "Se deben eliminar todas las etiquetas vinculadas a los contactos seleccionados",
    "automation": "Automatización",
    "bulkOperation": "Operación masiva",
    "campaign1": "Campaña",
    "created": "Creado",
    "dateTime": "Fecha y hora",
    "description1": "Descripción",
    "drip": "Goteo",
    "edit": "Editar",
    "someStatsAreNot": "Algunas estadísticas no están disponibles si el proveedor es SMTP. La precisión de las estadísticas depende del dominio del destinatario.",
    "error": "Error",
    "from1": "De",
    "immediately": "Inmediatamente",
    "pause": "Pausar",
    "processed": "Procesado",
    "queued": "En cola",
    "restored": "Restablecido",
    "resume": "Reanudar",
    "sent": "Enviado",
    "scheduled": "Programado",
    "success": "Éxito",
    "templateName": "Nombre de la plantilla",
    "total1": "Total",
    "totalAttempted": "Total de intentos",
    "user": "Usuario",
    "viewDetails": "Ver detalles",
    "workflow": "Flujo de trabajo",
    "company": "Empresa",
    "note": "Nota",
    "perPage": "por página",
    "showing": "Mostrando",
    "task": "Tarea",
    "tasks": "Tareas",
    "customFields": "Campos personalizados",
    "dueDate": "Fecha de vencimiento",
    "tryNow": "¡Pruébelo ahora!",
    "archive": "Archivar",
    "markAsRead": "Marcar como leído",
    "markAsUnread": "Marcar como no leído",
    "youNeedToAdd": "Debe añadir un calendario para comenzar a programar citas.",
    "additionalNotes": "Notas adicionales",
    "appointmentStatus": "Estado de la cita",
    "appointmentTitle": "Título de la cita",
    "contactName": "Nombre del contacto",
    "contactTimezoneUsedFor": "Zona horaria del contacto (utilizada para el recordatorio)",
    "day": "Día",
    "editAppointment": "Editar cita",
    "nameRequired": "Nombre obligatorio",
    "slotRequired": "Franja horaria obligatoria",
    "teamMemberIsRequired": "Se requiere un miembro del equipo.",
    "meetingLocation": "Ubicación de la reunión",
    "pickTeamMember": "Seleccionar miembro del equipo",
    "phoneNumbers": "Números de teléfono",
    "roundRobin": "Rotación",
    "selectCalendar": "Seleccionar calendario",
    "selectTeamMember": "Seleccionar un miembro del equipo",
    "actionRequired": "Acción requerida",
    "scheduleAppointment": "Programar cita",
    "considerLeavingItBlank": "Considere dejarlo en blanco si decide utilizar el título de cita preconfigurado",
    "assignedTo": "Asignado a",
    "download": "Descargar",
    "loadingTranscription": "Cargando transcripción…",
    "mute": "En silencio",
    "playpause": "Reproducir/pausar",
    "playbackSpeed": "Velocidad de reproducción",
    "remove": "Eliminar",
    "stop": "Detener",
    "timePlayedTotalTime": "Tiempo de reproducción: Tiempo total",
    "viewTranscript": "Ver transcripción",
    "below": "debajo",
    "calls1": "Llamadas",
    "liveChat": "Chat en tiempo real",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Conversación de chat asignada",
    "youAreChoosingNot": "No ha seleccionado eliminar y cerrar la subcuenta LC Phone, lo que significa que se le seguirá cobrando por todo el uso, independientemente de la ubicación en la que se lleve a cabo.",
    "thingsAreJustGetting": "Las cosas no han hecho más que empezar, exploremos cómo GHL puede ayudarle a construir su negocio.\nMientras tanto, puede seguir enviando mensajes a voluntad",
    "wohooConversationsAreFlowing": "¡Guau! Ahora sí que fluyen las conversaciones",
    "conversationBegan": "La conversación empezó el",
    "fetchOlderMessages": "Obtener mensajes antiguos",
    "inboundDndHasBeen": "Se ha activado la función DND entrante para este contacto",
    "internalComment": "Comentario interno",
    "confirmByTyping": "Confirmar escribiendo",
    "iConfirmToDisconnect": "Confirmo que desconectar y cerrar la cuenta de LC Phone para esta ubicación. Soy consciente de que esto significaría que todos los números y las campañas A2P serán eliminados y no podrán recuperarse.",
    "iConfirmThatI": "Confirmo que lo he comentado con mi cliente y que tengo autoridad para tomar esta acción.",
    "connect": "Conectar",
    "disputeThisReview": "Impugnar esta reseña",
    "dndIsActiveFor": "La función DND está activa para las llamadas",
    "off": "Desactivado",
    "done": "Hecho",
    "downloadFile": "Descargar archivo",
    "AddAccount": "+ añadir cuenta",
    "attachFile": "Adjuntar archivo",
    "clickHereToAdd": "Haga clic aquí para añadir una.",
    "customerName": "Nombre del cliente",
    "customerPhone": "Teléfono del cliente",
    "orEnterAMessage": "o escriba un mensaje",
    "fromEmail": "Correo electrónico del remitente",
    "fromName": "Nombre del remitente",
    "youDontHaveAny": "Todavía no tiene plantillas.",
    "requestPayment": "Solicitar pago",
    "schedule": "Programar",
    "selectATemplate": "Seleccione una plantilla",
    "sendNow": "Enviar ahora",
    "smtpProvidersHasSome": "Los proveedores de SMTP tienen algunas limitaciones. Haga clic aquí para obtener más información.",
    "subject": "Asunto",
    "useATemplateSnippet": "Utilice una plantilla (fragmento)",
    "deliveredtotalDelivered": "{delivered}/{total} enviados",
    "countMoreEmailsIn": "{count} correos electrónicos más en el hilo",
    "primary": "(Principal)",
    "reply": "Responder",
    "respond": "Responder",
    "retry": "Reintentar",
    "to": "Para:",
    "fbCommentReplyDm": "Respuesta al comentario de FB - MD",
    "fbMessage": "Mensaje de FB",
    "theseAttachmentsMayNot": "Es posible que estos archivos adjuntos ya no sean compatibles.",
    "urlCannotBeFound": "No se puede encontrar la URL",
    "activity": "Actividad",
    "filters": "Filtros",
    "goToPost": "Ir a la publicación",
    "inboundCall": "Llamada entrante",
    "instagramDm": "DM de Instagram",
    "internalChat": "Chat interno",
    "search2": "Buscar...",
    "starred": "Destacado",
    "leftAVoicemail": "Ha dejado un mensaje de voz",
    "manual": "Manual",
    "mergeFields": "Campos de combinación",
    "addToDocuments": "Añadir documentos",
    "failedToAddAttachments": "Error al añadir los archivos adjuntos a los documentos",
    "attachmentsAddedToDocuments": "Los archivos adjuntos se han añadido correctamente a los documentos",
    "newCommentOnPagename": "Nuevo comentario en la publicación {pageName}.",
    "outboundCall": "Llamada saliente",
    "replyAsDm": "Responder por MD",
    "replyingAsAPrivate": "Responder como MD privado no está disponible para comentarios de más de 7 días.",
    "reportFeedbackForAi": "Informe de los comentarios acerca de la IA",
    "storyMention": "Mención de la historia",
    "storyReply": "Respuesta a la historia",
    "bulkRequest": "Solicitud masiva",
    "eventsAreCurrentlyCaptured": "Actualmente, los eventos solo se capturan para la dirección de correo electrónico del contacto.",
    "failed": "Error",
    "gbpMessage": "Mensaje de GBP",
    "pageName": "Nombre de la página",
    "unknown": "Desconocido",
    "typeAMessage": "Escribir un mensaje",
    "new": "Nuevo",
    "newAppointmentBookedBy": "Nueva cita reservada por",
    "customerNameRequired": "El nombre del cliente es obligatorio",
    "messageIsRequired": "El mensaje es obligatorio",
    "pickATemplateTo": "Seleccione la plantilla que desea utilizar.",
    "newMessage": "Nuevo mensaje",
    "newTask": "Nueva tarea",
    "toMakeACall": "Para hacer una llamada, introduzca un número de teléfono en este campo.",
    "primary1": "Principal",
    "provider": "Proveedor",
    "refresh": "Actualizar",
    "resetPassword": "Restablecer contraseña",
    "thisReviewHasAlready": "Esta reseña ya ha sido publicada en {network}. ¿Seguro que desea volver a publicarla?",
    "seeThisReviewOn": "Ver esta reseña en GBP",
    "reviewResponse": "Respuesta a reseña",
    "searchUsers": "Buscar usuarios",
    "sendEmail": "Enviar correo electrónico",
    "sending": "Enviando...",
    "thisSubaccountHasPhonenumberco": "Esta subcuenta tiene {phoneNumberCount} número(s) y {campaignsCount} campaña(s) A2P. Incluso si se elimina esta cuenta, se seguirán aplicando cargos si la cuenta del sistema LC Phone no se desconecta y se cierra.",
    "thisSubaccountDoesNot": "Esta subcuenta no tiene ningún número ni campañas A2P. Pausar esta cuenta no le supondrá ningún gasto, pero le sugerimos que desconecte y cierre la cuenta de LC Phone.",
    "summary": "Resumen",
    "unassigned": "Sin asignar",
    "viewSubmission": "Ver envío",
    "contactSupport": "Contactar con el servicio de asistencia",
    "create": "Crear",
    "illDoThisLater": "Lo haré más tarde",
    "enterBusinessName": "Introduzca el nombre comercial",
    "firstNameOfThe": "Nombre del propietario de la empresa",
    "mobileBusinessPhone": "Teléfono móvil/de empresa",
    "iDontHaveA": "No tengo un sitio web",
    "clientName": "Nombre del cliente",
    "letUsSetupYour": "Permítanos configurar su propia cuenta o la de su primer cliente",
    "clientNameIsRequired": "El nombre del cliente es obligatorio",
    "pleaseEnterAValid": "Introduzca una dirección de correo electrónico válida",
    "emailAddressIsRequired": "La dirección de correo electrónico es obligatoria",
    "firstNameIsRequired": "El nombre es obligatorio",
    "lastNameIsRequired": "Los apellidos son obligatorios",
    "phoneNumberIsRequired": "El número de teléfono es obligatorio",
    "copyOfName": "Copia de {name}",
    "goToDashboard": "Ir al tablero",
    "permissionsNotEnabled": "¡Permisos no habilitados!",
    "createAndSellCustom": "Cree y venda productos personalizados con dropshipping bajo demanda",
    "viewApp": "Ver aplicación",
    "seamlessFulfillmentRealtimeShi": "Cumplimiento sin fisuras y tarifas de envío en tiempo real para sus tiendas de comercio electrónico",
    "learnMore": "Más información",
    "activateFormMapping": "Activar la asignación de formularios",
    "avatarName": "Nombre del avatar",
    "formFields": "Campos de formulario",
    "formName": "Nombre del formulario",
    "mapFields": "Asignar campos",
    "update": "Actualización",
    "pauseSubaccount": "Pausar subcuenta",
    "pausing": "Pausando...",
    "subaccount": "subcuenta",
    "howItWorks": "Cómo funciona",
    "uponCompletingThisAction": "Al completar esta acción, la solicitud de transferencia se enviará a la agencia receptora ({relNo}). La subcuenta se transferirá inmediatamente después de que la acepten. Tenga en cuenta que esta acción es irreversible.",
    "ejectSubaccount": "Expulsar subcuenta",
    "newAgencyCreationMail": "Correo de creación de nueva agencia enviado al usuario seleccionado. El usuario puede crear una nueva agencia haciendo clic en el enlace enviado por correo.",
    "unableToTransferSubaccount": "No se puede transferir la subcuenta a esta agencia.",
    "nominateAccountOwnerFor": "Designar al propietario de la cuenta nueva",
    "pleaseConfirmOwnershipWill": "Confirme que la propiedad se transferirá a",
    "scheduledDate": "Fecha programada",
    "thisDateIsBased": "Esta fecha se basa en la zona horaria de la empresa, que es {timezone}",
    "campaignName": "Nombre de la campaña",
    "copyCampaign": "Copiar campaña",
    "endTime": "Hora de finalización",
    "event10xEmail4": "Evento: 10X correo electrónico 4 (distribución de fichas) ",
    "10xEmail1Reviews": "10X Correo electrónico 1 (reseñas)",
    "fromAddress": "Desde la dirección",
    "leadValue": "Valor del cliente potencial",
    "option1": "Opción 1",
    "option2": "Opción 2",
    "option3": "Opción 3",
    "preview": "Previsualizar",
    "selectCampaign": "Seleccionar campaña",
    "startTime": "Hora de inicio",
    "time": "Hora",
    "users": "Usuarios",
    "noRecordsFound": "No se han encontrado registros",
    "pageDetail": "Detalle de la página",
    "selectAll": "Seleccionar todo",
    "submission": "Envío",
    "addProduct": "Añadir producto",
    "visitors": "visitantes",
    "By": " por",
    "conversions": "Tasa de conversión ",
    "liveReviews": "Reseñas en tiempo real",
    "liveVisitors": "Visitantes en tiempo real",
    "pageVisits": "Visitas a la página",
    "stream": "Transmitir",
    "addOneOrMore": "Añada una o varias direcciones URL de páginas o cópielas directamente desde su navegador web.",
    "WeWillAutomatically": " Haremos un seguimiento automático de los visitantes de su sitio web en tiempo real. ",
    "connectYourLocationsFacebook": "Conecte la cuenta de Facebook de su ubicación",
    "connected": "¡Conectado!",
    "Contains": " contiene ",
    "expression": "Expresión",
    "facebookAccount": "Cuenta de Facebook",
    "wowYouDontNeed": "¡Vaya! No hay nada que configurar aquí, puede seguir adelante.",
    "Regex": " regex ",
    "selectUrlMatchType": "Seleccione el tipo de coincidencia de URL",
    "Simple": " sencillo ",
    "LivePreview": " Previsualización en tiempo real",
    "seconds": "segundos",
    "launch": "Lanzamiento ",
    "decorativeVector1": "Vector decorativo 1",
    "showingFromToTo": "Mostrando {from} a {to} de {total} entradas",
    "cloneProduct": "Clonar producto",
    "connectFacebookInstagram": "Conectar Facebook e Instagram",
    "connectPage": "Conecte la página.",
    "everythingIn": "Todo en",
    "agentChat25": "Chat con un agente (aprox. 2-5 minutos de espera)",
    "aiSupportChat": "Chat de asistencia por IA",
    "startChat": "Iniciar chat",
    "locations1": "ubicaciones",
    "phone1": "teléfono",
    "slack": "Slack",
    "segments1": "segmentos",
    "areYouSureYou": "¿Está seguro de que desea eliminar esta carpeta?",
    "verified": "Verificado",
    "highlevelPrice": "Precio de HighLevel",
    "howDoesItWork": "¿Cómo funciona?",
    "payNow": "Pagar ahora",
    "priceMustBeMore": "El precio debe ser mayor o igual al precio de HighLevel",
    "saving2": "Guardando",
    "yourPrice": "Su precio",
    "yourProfit": "Su beneficio",
    "youNeedToComplete": "Debe completar unos sencillos pasos de cumplimiento antes de desactivar el modo SaaS para esta ubicación",
    "youAreNotAuthorized": "No tiene autorización para realizar esta acción. Solo los administradores de la agencia pueden realizarla.",
    "disableSaasModeFor": "Deshabilitar el modo SaaS para {name}",
    "companyBilling": "Facturación de la empresa",
    "bccEmailsCommaDelimited": "Correos electrónicos Cco (separados por comas)",
    "unableToDeleteMailgun": "No ha sido posible eliminar la cuenta de Mailgun, póngase en contacto con el servicio de asistencia.",
    "forwardingAddress": "Dirección de reenvío",
    "forwardingAddressesCommaDelimi": "Direcciones de reenvío (delimitadas por comas)",
    "amount": "Cantidad",
    "billingDate": "Fecha de facturación",
    "debugWalletTransactionsTotal": "DEPURAR transacciones del monedero, total: {count}",
    "detailedTransactions": "Transacciones detalladas",
    "transactionsOnlyAfter26th": "Solo las transacciones después del 26 de abril de 2022 aparecen enumeradas y disponibles para la exportación",
    "someRecordsMayTake": "Algunos registros pueden tardar 24 horas en actualizarse aquí.",
    "totalBalance": "Saldo total",
    "walletTransactions": "Transacciones del monedero",
    "walletTransactionsAllDate": "Transacciones del monedero - todas - {date}",
    "enterMessage": "Introduzca el mensaje",
    "applyThisChangeTo": "Aplique este cambio a todas las subcuentas.",
    "characters": "Caracteres",
    "iConfirmThatI1": "Confirmo que lo he hablado con mi cliente y que tengo su aprobación.",
    "iConfirmThatI2": "Confirmo que me aseguraré de que todos los mensajes SMS enviados desde esta cuenta cumplan con la política actual.",
    "theContentsOfThis": "El contenido de este mensaje se añadirá automáticamente al primer SMS que se envíe a través de los mensajes masivos.",
    "iConfirmThatSms": "Confirmo que los mensajes SMS solo se enviarán a los contactos que hayan optado por recibirlos.",
    "quickTip": "Consejo rápido",
    "messageWillBeAppended": "El mensaje se añadirá en el primer SMS de una conversión si no contiene una indicación de exclusión voluntaria",
    "readMore": "Leer más",
    "noncompliantActivityMayLead": "Las actividades que no cumplan con las normas pueden dar lugar a la suspensión de las funciones de SMS y de voz de su cuenta.",
    "typeConfirmBelowTo": "Escriba Confirmar abajo para continuar",
    "products": "Productos",
    "chooseCountry": "Seleccione un país…",
    "email2": "Correo electrónico*",
    "firstName1": "Nombre*",
    "lastName1": "Apellidos*",
    "brandDetails": "Detalles de la marca",
    "brandName": "Nombre de la marca*",
    "useEitherLegalName": "Utilice el nombre legal de la organización que envía los mensajes o su propio nombre si esta marca no es para una organización.",
    "businessIndustry": "Sector empresarial*",
    "chooseVertical": "Seleccione el sector…",
    "mobileNumberForOtp": "Número de móvil para verificación OTP (con código de país)*",
    "pleaseProvideAMobile": "Proporcione un número de móvil al que tenga acceso para confirmar la verificación OTP. Solo se aceptarán números de EE. UU./Canadá. No puede utilizar un número de teléfono CPaaS, como los obtenidos de LeadConnector. No puede usar el mismo número móvil para registrar más de 3 marcas de propietario único. Este límite lo gestiona TCR.",
    "increasedDeliveryRate": "Aumento de la frecuencia de entrega",
    "sendUpto3000Segments": "Envíe hasta 3000 segmentos por día",
    "businessDetails": "Información de la empresa",
    "thereWasSomeIssue": "Ha habido algún problema al enviar el perfil.",
    "yourProfileSubmissionFailed": "Error en el envío de su perfil.",
    "endUserConsent": "Consentimiento del usuario final",
    "minLength40Characters": "Longitud mín.: 40 caracteres. Longitud máx.: 2048 caracteres.",
    "closeExamples": "Cerrar ejemplos",
    "sampleMessage1": "Mensaje de muestra #1*",
    "seeExamples": "Ver ejemplos",
    "enterCampaignDetails": "Introduzca los detalles de la campaña",
    "youWillReceiveAn": "Recibirá un mensaje con el OTP en el número móvil que facilitó para verificar desde TCR. Por favor, responda Sí en un plazo de 24 horas desde la recepción del SMS.",
    "brandNameIsRequired": "El nombre de la marca es obligatorio.",
    "businessVerticalIsRequired": "La vertical empresarial es obligatoria.",
    "mobileNumberIsRequired": "El número de móvil es obligatorio.",
    "hideDetail": "Ocultar detalle",
    "showDetail": "Mostrar detalle",
    "people": "gente",
    "person": "persona",
    "after": "después",
    "before": "antes",
    "hour": "hora",
    "hours": "horas",
    "minute": "minuto",
    "minutes": "minutos",
    "triggerLinksEmbeddedIn": "los enlaces de activación (incrustados en el mensaje) hacían clic como % de los mensajes enviados",
    "addNewEvent": "Añadir nuevo evento",
    "addTask": "Añadir tarea",
    "manualCall": "Llamada manual",
    "manualSms": "SMS manual",
    "messenger": "Messenger",
    "wait": "Esperar",
    "webhook": "Webhook",
    "about": "Acerca de",
    "accessRestricted": "Acceso restringido",
    "addPartner": "Añadir socio",
    "addPartnerForm": "Añadir formulario de socio",
    "affiliatePortal": "Portal de afiliados",
    "badges": "Insignias",
    "aBriefBio": "Una breve biografía",
    "dashboard": "Tablero",
    "experience": "Experiencia",
    "industryServed": "Sector correspondiente",
    "instagramAccount": "Cuenta de Instagram",
    "invoiceHistory": "Historial de facturas",
    "englishGermanHindi": "Inglés, alemán, hindi",
    "linkToWebsite": "enlace al sitio web",
    "linkedinAccount": "Cuenta de LinkedIn",
    "locationId": "Id. de ubicación",
    "partnerName": "Nombre del socio",
    "partnerStatus": "Reputación del socio",
    "paymentDetails": "Información del pago",
    "paymentHistory": "Historial de pagos",
    "profilePhoto": "Foto de perfil",
    "profilePhotoUrl": "URL del enlace de la foto del perfil",
    "promoterReports": "Informes de promotores",
    "searchPartner": "Buscar socio",
    "twitterAccount": "Cuenta de X",
    "updatePartner": "Actualizar socio",
    "updatePartnerForm": "Actualizar formulario de socio",
    "yearOfExperience": "año de experiencia",
    "youtubeAccount": "Cuenta de YouTube",
    "serviceProvided": "Servicio proporcionado",
    "controlTheSubaccountSettings": "Gestionar la configuración de la subcuenta",
    "generalInfo": "Información general",
    "okay": "De acuerdo",
    "proceed": "Proceder",
    "addCard": "Añadir tarjeta",
    "makeThisCardPrimary": "Establecer esta tarjeta como principal",
    "nameOnCard": "Nombre en la tarjeta",
    "chargedToCustomer": "Cobrado al cliente",
    "clientBillingPage": "Página de facturación del cliente",
    "companyStripeIntegrationPage": "página de integración de Stripe de la empresa",
    "enableRebilling": "Habilitar la refacturación",
    "enabling": "Habilitando...",
    "forMoreDetails": "para obtener más información.",
    "youreOnTheFreelancer": "Tiene un plan Freelancer, que limita su margen a 1,05x.",
    "minimumAmountShouldBe": "La cantidad mínima debe estar entre ${min} y ${max}",
    "beforeEnablingThisFeature1": "Antes de habilitar esta función, conecte su cuenta de Stripe en la",
    "planToSetYour": "plan para establecer unos márgenes más altos.",
    "rebillAmount": "Importe de la refacturación",
    "supportDoc": "documento de apoyo",
    "10WillGiveYou": "Con 10 dólares obtendrá unos",
    "minimumMustBeBetween": "El mínimo debe estar entre 0,0001 y 0,005",
    "sorryYouCannotRebillAtTheMarkup": "Lo sentimos, no puede volver a facturar con el margen de beneficio del plan Freelancer,",
    "modifyingTheseSettingsWillChange": "Modificar esta configuración cambiará el coste en el que incurrirán sus clientes en el futuro.",
    "pleaseDoNotModifyThese": "No la modifique si no tiene la certeza de sus efectos.",
    "theseSettingsWillApply": "Esta configuración se aplicará a sus nuevos clientes a partir de ahora",
    "congratulationsYourDedicatedIp": "¡Enhorabuena! Su valor de reventa de IP dedicada se ha guardado correctamente.",
    "youHaveAgreedToProvide": "Usted ha aceptado proporcionar IP dedicadas directamente a una subcuenta. La agencia asumirá los gastos en representación de la subcuenta.",
    "youHaveDiscontinuedToProvide": "Ha dejado de proporcionar IP dedicadas directamente a una subcuenta. La agencia ya no asumirá los cargos en representación de la subcuenta.",
    "oopsSomethingWentWrongAndWeCouldnt": "¡Vaya! Algo ha ido mal y no hemos posido guardar la configuración de reventa de su IP dedicada. Inténtelo de nuevo más tarde.",
    "pleaseAgreeToTheTerms": "Por favor, acepte los términos",
    "errorWhileFetchingDomains": "Error al obtener los dominios",
    "sameStripeCustomerProfileCantBeMapped": "El mismo perfil de cliente de Stripe no puede asociarse a más de una subcuenta.",
    "pleasePickADifferentStripeCustomer": "Elija un perfil de cliente de Stripe diferente o utilice la opción «Compartir un enlace» para que podamos crear un nuevo perfil de cliente de Stripe para esta subcuenta.",
    "clickNextToChooseAPlan": "Haga clic en «Siguiente» para elegir un plan y crear una nueva suscripción.",
    "youDontHaveAnyActiveSubscriptions": "No tiene ninguna suscripción activa",
    "youCanEitherSelectAnExistingSubscription": "Puede seleccionar una suscripción existente o crear una nueva suscripción en el siguiente paso.",
    "useCommasToSeparateMultipleEmails": "Utilice comas para separar los correos electrónicos.",
    "useCommasToSeparateMultiplePhoneNumbers": "Utilice comas para separar múltiples números de teléfono",
    "noUserFoundInThisLocation": "No se ha encontrado ningún usuario en esta ubicación",
    "noPhoneNumberAttached": "No hay número de teléfono adjunto",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Utilice el siguiente enlace para adjuntar su método de pago.",
    "allowDuplicateContact": "Permitir la duplicación de contactos",
    "allowDuplicateOpportunity": "Permitir la duplicación de oportunidades",
    "mergeFacebookContactsByName": "Fusionar los contactos de Facebook por nombre",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Solo se fusionarán los mensajes entrantes de Facebook si coinciden con el nombre de un contacto existente. Los nombres distinguen entre mayúsculas y minúsculas.",
    "disableContactTimezone": "Deshabilitar la zona horaria del contacto",
    "markEmailsAsInvalidDueToHardBounce": "Marcar correos electrónicos como no válidos debido a un rebote duro",
    "contactsEmailsWillBeMarkedAsInvalid": "Los correos electrónicos del contacto se marcarán como no válidos automáticamente cuando haya un rebote duro. Las acciones de correo electrónico en Automatizaciones se omitirán para los contactos con correos electrónicos no válidos.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Recopilar información sobre números de teléfono desconocidos",
    "makeSmsCompliantByAddingAnOptOutMessage": "Haga que los SMS cumplan la normativa añadiendo un mensaje de exclusión voluntaria.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Si está activado, el mensaje de exclusión se añadirá automáticamente al primer SMS que se envíe a través de los mensajes masivos para garantizar el cumplimiento y aumentar las tasas de entrega.",
    "platformLanguage": "Idioma de la plataforma",
    "outboundCommunicationLanguageForCustomValues": "Idioma de comunicación saliente para valores personalizados",
    "updateInformation": "Actualizar la información",
    "upgradeToTheAgency": "Cambiar al plan Agency Pro",
    "yourCost": "Su coste",
    "addACalendarTo": "Añadir un calendario para empezar a reservar citas.",
    "addselectAContactTo": "Añadir/seleccionar un contacto para programar citas",
    "appointmentSlotIsNot": "Aún no se ha seleccionado ninguna franja horaria para la cita",
    "loading1": "Cargando...",
    "teamMemberIsRequired1": "Se requiere un miembro del equipo",
    "currentPlan": "Plan actual",
    "features1": "Funciones",
    "upgrade": "Actualizar/mejorar",
    "viewLess": "Ver menos",
    "viewMoreCount": "Mostrar más (+{count})",
    "cardNumber": "Número de tarjeta",
    "expiryDate": "Fecha de caducidad",
    "paymentMethods": "Métodos de pago",
    "primaryCard": "Tarjeta principal",
    "removeCurrentCard": "Eliminar tarjeta actual",
    "AddBalance": "+ añadir saldo",
    "complimentaryCredits": "Créditos gratuitos:",
    "expiringOnDate": "Caduca el {date}",
    "apiVersion": "Versión de la API",
    "application": "Aplicación",
    "ipAddress": "Dirección IP",
    "related": "Relacionado",
    "request": "Solicitud",
    "yourAccountIncludingAll": "Su cuenta, incluida toda la actividad saliente como mensajes y correos electrónicos programados, se detendrá inmediatamente.",
    "yourAccountIncludingAll1": "Su cuenta, incluida toda la actividad saliente como mensajes y correos electrónicos programados, se detendrá inmediatamente.",
    "nextBillingDateDate": "Siguiente fecha de facturación: {date}",
    "scheduledForCancellation": "Programado para su cancelación",
    "abandoned": "Abandonado",
    "add1": "Añadir",
    "addOpportunity": "Añadir oportunidad --",
    "addOpportunityName": "Añadir nombre de la oportunidad",
    "Task": "+ tarea",
    "bookupdateAppointment": "Reservar/actualizar cita",
    "companyName": "Nombre de la empresa",
    "areYouSureYou1": "¿Seguro que desea eliminar esta oportunidad?",
    "contactInfo": "Información de contacto",
    "editOpportunity": "Editar oportunidad --",
    "enterValue": "Introduzca un valor",
    "goToContactDetail": "Ir a la página de detalles de contacto",
    "leads": "Clientes potenciales",
    "lost": "Perdido",
    "nameIsRequired": "El nombre es obligatorio.",
    "youreNotAllowedTo": "No puede cambiar el nombre del cliente. Consulte su permiso con el administrador de la agencia.",
    "open": "Abrir",
    "opportunity": "Oportunidad",
    "opportunityAlreadyExistsIn": "La oportunidad ya existe en esta secuencia",
    "opportunityInfo": "Información de la oportunidad",
    "opportunityName": "Nombre de la oportunidad",
    "opportunitySource": "Fuente de la oportunidad",
    "owner": "Propietario",
    "pipeline": "Secuencia",
    "removeOwner": "Eliminar propietario",
    "selectPipeline": "Seleccionar secuencia",
    "selectStage": "Seleccionar etapa",
    "stage": "Paso",
    "countTasks": "{count} tareas",
    "won": "Ganado",
    "and": "y ",
    "addASubscription": "Añadir una suscripción",
    "noSaasPlanEnabled": "No hay ningún plan SaaS habilitado",
    "per": "por",
    "assignTo": "Asignar a",
    "assignedTo1": "Asignado a:",
    "areYouSureYou2": "¿Seguro que desea eliminar esta tarea?",
    "due": "Pendiente:",
    "dueDateIsRequired": "La fecha de vencimiento es obligatoria",
    "dueIn": "Pendiente en",
    "dueToday": "Vence hoy",
    "late": "Tarde",
    "notAssigned": "No asignado",
    "taskDescription": "Descripción de la tarea",
    "taskTitle": "Título de la tarea",
    "annually": "anualmente",
    "attachments": "Archivo(s) adjunto(s)",
    "areYouSureYou3": "¿Seguro que quiere eliminar esta solicitud masiva?",
    "startImmediately": "Comenzar inmediatamente",
    "customers": "Clientes",
    "tag": "Etiqueta",
    "pickType": "Seleccionar tipo",
    "whoShouldItRun": "¿Para quién debería ejecutarse?",
    "addBulkRequest": "Añadir Solicitud masiva",
    "editBulkRequest": "Editar solicitud masiva",
    "scheduledDateIsRequired": "Fecha programada obligatoria",
    "newCampaignName": "Nombre de la nueva campaña",
    "areYouSureYou4": "¿Seguro que quiere eliminar esta campaña?",
    "moveToFolder": "Mover a carpeta",
    "pleaseRename": "cambie el nombre",
    "removeFromFolder": "Eliminar de la carpeta",
    "photoPreview": "vista previa de la foto",
    "pleaseWait": "Espere...",
    "customValues": "Valores personalizados",
    "whatActionShouldWe": "¿Qué acción deberíamos realizar?",
    "entitynameName": "Nombre de la {entityName}",
    "useLcEmail": "Utilizar LC Email",
    "21Jun2018": "21 de junio de 2018",
    "930Am": "9:30 h",
    "Via": " a través de ",
    "createdTrackingNumbers": "Números de seguimiento creados",
    "iUnderstandImBuyingadding": "Entiendo que estoy comprando/añadiendo {count} nuevos números de teléfono.",
    "forwardCallsTo": "Reenviar llamadas a",
    "numberName": "Nombre del número",
    "numberPoolName": "Nombre del grupo de números",
    "numberToSwap": "Número para intercambiar",
    "sameAsForwardingNumber": "Igual que el número de reenvío",
    "callFromSource": "Llamada de [Source].",
    "callRecording": "Grabación de llamadas",
    "84Complete": "84 % completado",
    "thisCallWillBe": "Esta llamada será grabada con fines de control de calidad.",
    "whisperMessage": "Mensaje susurrado",
    "allExceptDirect": "Todos excepto los directos",
    "allExceptDirectOrganic": "Todos excepto directo y orgánico",
    "allSearch": "Todas las búsquedas",
    "allVisitorsRecommended": "Todos los visitantes (recomendado)",
    "bing": "Bing",
    "direct": "Directo",
    "visitorsWithoutAReferring": "Visitantes sin un sitio web de referencia",
    "for": "para",
    "google": "Google",
    "landingPageOrUrl": "Página de destino o parámetro de URL",
    "organic": "Orgánico",
    "paid": "Pagado",
    "pickOneYouCan": "Elija uno: siempre puede cambiarlo después.",
    "ppcSearch": "Búsqueda de PPC",
    "visitorsFromGoogleBing": "Visitantes de la búsqueda PPC de Google, Bing y Yahoo",
    "referringPage": "Página de referencia",
    "visitorsFrom": "Visitantes de",
    "visitorsFromGoogleAds": "Visitantes procedentes de Google Ads",
    "visitorsWhoAreReferred": "Visitantes que se recomiendan de",
    "visitorsWhoLandOn": "Visitantes que llegan a",
    "whichVisitorsDoYou": "¿De qué visitantes quieres hacer un seguimiento?",
    "yahoo": "Yahoo",
    "17Complete": "17 % completado",
    "callTimeoutS": "Tiempo de espera de la llamada (s)",
    "callWhisper": "Susurro de llamada",
    "disableVoicemailDetect": "Deshabilitar la detección de mensajes de voz",
    "eventName": "Nombre del evento",
    "timeoutSeconds": "Tiempo de espera (segundos)",
    "editCall": "Editar llamada",
    "callWillPatchInstantly": "La llamada se conectará inmediatamente, no escucharemos para verificar si el mensaje de voz se activó en el lado de los clientes potenciales. Esto significa que la campaña se marcará como respondida aunque salte el mensaje de voz.",
    "thisIsTheMessage": "Este es el mensaje que quieres que escuche la persona que coge el teléfono, puedes usar variables personalizadas para personalizarlo.",
    "pleaseCheckTheLinks": "Compruebe los enlaces donde tiene un valor personalizado. Hay un «%20» adicional entre {{ y los valores personalizados.",
    "anErrorOcurredPlease": "Se ha producido un error. Inténtelo de nuevo.",
    "pleaseInsertATo": "Introduzca una dirección.",
    "pickEmailTemplate": "Seleccionar plantilla de correo electrónico",
    "sendTest": "Enviar una prueba",
    "composeEmail": "Redactar correo electrónico",
    "composeEmailTemplate": "Redactar plantilla de correo electrónico",
    "toAddress": "A la dirección",
    "addFileThroughUrl": "Añadir archivo a través de URL",
    "appCharacters": "Caracteres de la aplicación:",
    "approximateCost": "Coste aproximado:",
    "estimatedCostForUs": "Coste estimado solo para SMS dentro de EE. UU.",
    "mobilePhoneNumber": "Número de teléfono móvil",
    "numSegments": "Núm. de segmentos",
    "pickMessageTemplate": "Seleccione la plantilla de mensaje",
    "pleaseProvideAPhone": "Proporcione un número de teléfono al que enviar la prueba.",
    "composeEventtype": "Redactar {eventType}",
    "composeEventtypeTextTemplate": "Redactar plantilla de texto para {eventType}",
    "unsupportedSmsContentType": "Tipo de contenido de SMS no compatible: {fileType}",
    "countOfTheProvided": "{count} de los archivos adjuntos de URL proporcionados {plural} no una imagen. Esto podría causar errores en Twilio. ¿Desea guardarlo de todas formas?",
    "dropFileHereOr": "Suelte el documento aquí o haga clic para subirlo",
    "ifYouHaveAdditional": "Si tiene más preguntas, consulte las preguntas frecuentes sobre soltar mensajes de voz en la sección de ayuda.",
    "editVoicemail": "Editar mensaje de voz",
    "selectAMp3Or": "Seleccione un archivo mp3 o wav; no se admiten otros formatos.",
    "voicemailFile": "Archivo de mensaje de voz",
    "warningVoicemailDropsAre": "Advertencia: Soltar mensajes de voz se basan en un sistema de «mejor intento» y suelen funcionar aproximadamente el 70 % de las veces.",
    "youNeedToPick": "Debe seleccionar al menos un día",
    "editWait": "Editar la espera",
    "url": "URL",
    "customTime": "Hora personalizada",
    "executeThisActionIf": "Ejecute esta acción si la hora actual está dentro de esta ventana. Si la hora actual está fuera de esta ventana, omita este paso y pase al siguiente.",
    "pickDays": "Seleccione días",
    "pickTime": "Seleccionar hora",
    "noRecordsFound1": "No se han encontrado registros.",
    "formAnalyze": "Análisis de formulario",
    "totalSubmission": "Envíos totales",
    "forgotPassword": "¿Ha olvidado la contraseña?",
    "orContinueWith": "O continúe con",
    "signIn": "Iniciar sesión",
    "signIntoYourAccount": "Inicie sesión en su cuenta",
    "thePasswordYouPicked": "La contraseña que ha elegido",
    "yourEmailAddress": "Su dirección de correo electrónico",
    "newEmailFrom": "Nuevo correo electrónico de",
    "newMessageFrom": "Nuevo mensaje de",
    "hasLeftANew": "ha dejado una nueva reseña.",
    "repliedToTheReview": "respondió a la reseña.",
    "loaded": "Cargado",
    "snapshot": "Instantánea",
    "appointment": "Cita",
    "appointmentDueInMinutes": "Cita prevista en {minutes} min para {contactName}",
    "appointmentReminder": "Recordatorio de cita",
    "completedCount": "Completado: {count}",
    "conversation": "Conversación",
    "facebookReview": "Reseña de Facebook",
    "failedCount": "Error: {count}",
    "googleReview": "Reseña de Google",
    "internalChatMessage": "Mensaje de chat interno",
    "usernameMentionedYouIn": "{userName} le ha mencionado en una conversación con {contactName}",
    "newAppointmentAssigned": "Nueva cita asignada",
    "aNewAppointmentWith": "Se le ha asignado una nueva cita con {contactName}.",
    "newAppointmentBooked": "Nueva cita reservada",
    "youHaveNewAppointment": "Tiene una nueva cita reservada con {contactName}",
    "newCall": "Nueva llamada",
    "aNewChatWith": "Se le ha asignado un nuevo chat con {contactName}.",
    "newEmail": "Nuevo correo electrónico",
    "newMention": "Nueva mención",
    "newReviewReceivedFrom": "Nueva reseña recibida de {contactName}",
    "aNewTypeIs": "Se ha recibido un nuevo {type} de {contactName}",
    "notification": {
      "noRecentActivity": "No hay actividad reciente"
    },
    "subAccount": "Subcuenta",
    "subaccount1": "Subcuenta:",
    "titleOnDateAt": "{title} el {date} a las {time} para {contactName}",
    "titleDueInDuetime": "Hay previsto {title} en {dueTime} {unitOfTime} para {contactName}",
    "taskReminder": "Recordatorio de tarea",
    "youHaveCountTasks": "Tiene {count} tareas pendientes para hoy",
    "youHaveCountTasks1": "Tiene {count} tareas atrasadas hasta el momento",
    "droppedVoicemailTo": "Dejé un mensaje de voz a",
    "errorWhileCloningProduct": "No se ha podido clonar el producto",
    "productName": "Nombre del producto",
    "selectLocations": "Seleccionar ubicaciones",
    "selectUptoMaxselectablelocatio": "Seleccione hasta {maxSelectableLocations} ubicaciones",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} más",
    "emails": "Correos electrónicos",
    "accountNotification": "Notificación de cuenta",
    "customerCare": "Atención al cliente",
    "deliveryNotification": "Notificación de entrega",
    "fraudAlertMessaging": "Mensajes de alerta de fraude",
    "higherEducation": "Educación superior",
    "lowVolumeMixedRecommended": "Bajo volumen híbrido (recomendado)",
    "mixed": "Híbrido",
    "pollingAndVoting": "Sondeos y votaciones",
    "publicServiceAnnouncement": "Anuncio de servicio público",
    "securityAlert": "Alerta de seguridad",
    "mixedRecommended": "Híbrido (recomendado)",
    "australiaCompanyNumberFrom": "Australia: Número de Empresa de la ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canadá: Número Comercial Canadiense (CBN)",
    "indiaCorporateIdentityNumber": "India: Número de Identificación Corporativa",
    "greatBritainCompanyNumber": "Gran Bretaña: Número de Empresa",
    "usaEmployerIdentificationNumbe": "EE. UU.: Número de Identificación del Empleador (EIN)",
    "other": "Otro",
    "israelRegistrationNumber": "Israel: Número de Registro",
    "estoniaVatNumber": "Estonia: Número de IVA",
    "cooperative": "Cooperativa",
    "corporation": "Corporación",
    "limitedLiabilityCompanyOr": "Sociedad de responsabilidad limitada o sociedad unipersonal",
    "nonprofitCorporation": "Corporación sin ánimo de lucro",
    "partnership": "Colaboración",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Director",
    "generalCounsel": "Asesor jurídico general",
    "onlineTrainingEducation": "Formación y educación en línea",
    "financialServices": "Servicios financieros",
    "fitnessLifestyle": "Fitness y estilo de vida",
    "healthMedical": "Salud & Medicina",
    "homeServices": "Servicios para el hogar",
    "legalServices": "Servicios legales",
    "marketingAdvertising": "Marketing y publicidad",
    "others": "Otros",
    "realEstate": "Bienes raíces",
    "restaurants": "Restaurantes",
    "retailEcommerce": "Venta al por menor y comercio electrónico",
    "yourInformationHasBeen": "Su información se ha enviado correctamente.",
    "somethingWentWrong1": "Algo ha ido mal",
    "newPassword": "Nueva contraseña",
    "proceedToLogin": "Proceder al inicio de sesión",
    "anyTime": "en el momento en que lo desee.",
    "callUsHighlevelSupport": "Llámenos a la asistencia de HighLevel",
    "troubleLoggingIn": "¿Tiene problemas para iniciar sesión?",
    "sendSecurityCode": "Enviar el código de seguridad",
    "sendCodeToEmail": "Enviar código al correo electrónico",
    "verifySecurityCode": "Verificar código de seguridad",
    "privacyPolicy": "Política de privacidad",
    "businessProfile": "Perfil de empresa",
    "reserveWithGoogleIntegration": "Reserva con integración de Google",
    "friendlyName": "Nombre descriptivo",
    "updateCallerId": "Actualizar identificador de llamada",
    "internationalFormat": "Formato internacional",
    "localFormat": "Formato local",
    "poolNumbers": "Grupo de números",
    "swappingNumbers": "Intercambio de números",
    "selectField": "Seleccionar campo",
    "surveyAnalyze": "Análisis de la encuesta",
    "locationIsRequired": "La ubicación es obligatoria.",
    "newSurveyName": "Nuevo nombre de la encuesta",
    "copySurvey": "Copiar encuesta",
    "primaryCalendar": "Calendario principal",
    "cloneEntityname": "Clonar {entityName}",
    "youHaveSuccessfullySubmitted": "Ha enviado correctamente los documentos",
    "addCustomValue": "Añadir valor personalizado",
    "value": "Valor",
    "youHaveSuccessfullyDeleted": "Ha eliminado correctamente el paquete.",
    "bundleDeletedSuccessfully": "Paquete eliminado correctamente",
    "thereIsAnIssue": "Hay un problema con uno de sus documentos justificativos. Revise los documentos justificativos y los motivos de rechazo.",
    "connect1": "¡Conectar!",
    "itSeemsEitherThe": "Parece que la conexión a Google está rota o no se está conectando en la ubicación actual. Revise la configuración de las integraciones y vuelva a integrar si la conexión ya existe.",
    "selectPage": "Seleccionar página",
    "somethingWentWrongPlease": "algo ha salido mal, inténtelo de nuevo",
    "accept": "Aceptar",
    "moreThan1Phone": "Se permite más de un número de teléfono",
    "byContinuingToUse": "Al continuar utilizando la plataforma HighLevel, usted acepta estos nuevos {termsLink} y {privacyLink}.",
    "byContinuingToUse1": "Al continuar utilizando la plataforma HighLevel, usted acepta estos nuevos",
    "termsOfService": "términos de servicio",
    "weHaveUpdatedOur": "Hemos actualizado nuestros términos de servicio y política de privacidad, consúltelos.",
    "newTriggerName": "Nombre del nuevo activador",
    "triggerName": "Nombre del activador",
    "disableDndForSpecific": "Deshabilitar DND para canales específicos",
    "selectAdAccount": "Seleccionar cuenta publicitaria",
    "selectAppointmentStatus": "Seleccionar estado de la cita",
    "below1": "más abajo.",
    "Required": "* obligatorio",
    "whenYouGetA": "Cuando reciba una nueva reseña, la compartiremos automáticamente en su página de Facebook. Recuerde que lo más recomendable es no publicar más de tres reseñas al día en su cuenta.",
    "skip": "Saltar",
    "copyShareLink": "Copiar el enlace de la compartición",
    "agencyRelationshipNumbers": "Números de relación con la agencia",
    "alteast1AgencyRelationship": "Se requiere al menos un número de relación con la agencia.",
    "alteast1SubaccountId": "Se requiere al menos un id. de subcuenta.",
    "somethingWentWrongWhile": "Se ha producido un error al guardar. Vuelva a intentarlo más tarde.",
    "5PerPage": "5 por página",
    "10PerPage": "10 por página",
    "amountMustGreaterOr": "La cantidad debe ser mayor o igual a 1 AUD.",
    "regions": {
      "africa": "África",
      "asia_pacific": "Asia / Pacífico",
      "europe": "Europa",
      "latin_america": "América Latina",
      "usa_and_canada": "EE. UU. y Canadá",
      "asia": "Asia",
      "latinAmerica": "América Latina",
      "usaCanada": "EE. UU. y Canadá"
    },
    "expandIcon": "►",
    "noEntriesToShow": "No hay entradas que mostrar",
    "clear": "Borrar",
    "filter": "Filtrar",
    "test": "Prueba",
    "createNewTwilioSubAccountText": "Necesitará crear una nueva cuenta de Twilio, actualizar las credenciales de esta cuenta en la configuración de Twilio y mover los números de teléfono antes de habilitar la refacturación.",
    "viewing": "Visita",
    "makeSmsCompliantByAddingASenderInformation": "Haga que los SMS cumplan la normativa añadiendo la información del remitente.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Haga que su correo electrónico cumpla la normativa añadiendo un enlace para cancelar la suscripción en su correo electrónico",
    "enableMissedCallTextBack": "Habilitar el mensaje de respuesta para llamadas perdidas",
    "productInventory": "Inventario de Productos",
    "viewProductVariants": "Ver variantes de producto",
    "smtpSettings": "Configuración de SMTP",
    "locationOPMTrafficStatis": "Estadísticas de tráfico de OPM en la ubicación",
    "locationGPMTrafficStatis": "Estadísticas de tráfico de GPM de ubicación",
    "blacklistMonitorReports": "Informes del control de listas negras",
    "twoFactorAuthentication": "Autenticación de dos factores (2FA)",
    "recent": "Reciente",
    "noPermission": "No tiene permiso para administrar plantillas para este producto. Redirigiendo al tablero.",
    "tasksNowHave": "Las tareas ahora tienen",
    "option": "Opción",
    "facebookAdsReporting": "Informe de Facebook Ads",
    "googleAdsReporting": "Informes de Google Ads",
    "adsDatePicker": "Selector de fechas de anuncios",
    "feedbackSubmitBtn": "Botón Enviar comentarios",
    "ifYouThinkMistakePleaseContact": "Si cree que se trata de un error, póngase en contacto con nosotros",
    "forResolution": "para su resolución.",
    "live": "En tiempo real",
    "payouts": "Pagos",
    "greatChoice": "¡Gran elección!",
    "toNavigate": "para navegar",
    "teams": "Equipos",
    "role": "Rol",
    "searchAccounts": "Buscar cuentas",
    "searchByNameEmailPhone": "Buscar por nombre, correo electrónico o teléfono",
    "addEmployee": "Añadir Empleado",
    "removeFromLocation": "Eliminar de la ubicación",
    "knowMore": "Más información",
    "usingNumberPool": "Uso del grupo de números",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Revisor",
    "cancel1": "Cancelar",
    "delete1": "Eliminar",
    "call1": "Llamada",
    "message1": "Mensaje",
    "name1": "Nombre",
    "voicemail1": "Mensaje de voz",
    "title1": "Título",
    "choose_one": "Seleccionar uno",
    "select_page": "Seleccionar página",
    "confirm1": "Confirmar",
    "conversations1": "Conversaciones",
    "copied1": "Copiado",
    "timeOfDay": {
      "am": "a. m.",
      "pm": "p. m."
    },
    "back1": "Atrás",
    "details1": "Detalles",
    "month1": "/mes",
    "select1": "Seleccionar",
    "share1": "Compartir",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Informes del control de listas negras",
      "domainPurchase": "Compra de dominio"
    },
    "confirmDelete": "¿Seguro que desea eliminar {name}?",
    "clicked1": "Pulsado",
    "delivered1": "Entregado",
    "invalid1": "No válido",
    "open_options": "Abrir opciones",
    "_add_account": "Añadir cuenta",
    "setTimezoneWarning": "Configure la zona horaria de su ubicación para obtener las franjas horarias gratis adecuadas.",
    "save1": "Guardar",
    "action1": "Acción",
    "actions1": "Acciones",
    "all1": "Todo",
    "previous1": "Anterior",
    "results1": "Resultados",
    "next1": "Siguiente",
    "payments1": "Pagos",
    "settings1": "Configuración",
    "total_js_heap": "Total del montón de JS",
    "table": {
      "pagination": {
        "previous": "Anterior",
        "next": "Siguiente"
      },
      "rowsSelected": "{count} filas seleccionadas",
      "cantRearrange": "{type} no se puede ser reordenar"
    },
    "ivrCall": "Llamada IVR",
    "sms": "SMS",
    "username": "Nombre de usuario",
    "stay": "Manténgase",
    "placeholders": {
      "selectCountry": "Seleccione su país",
      "nameOfBusiness": "Nombre de la empresa",
      "line1": "Línea 1",
      "line2": "Línea 2",
      "enterState": "Introduzca la región/provincia/estado",
      "enterCity": "Introduzca la ciudad",
      "enterPostalCode": "Introduzca el código postal",
      "chooseCountry": "Seleccione un país…"
    },
    "addressLine1": "Línea de dirección 1",
    "addressLine2": "Línea de dirección 2",
    "postalCode": "Código postal",
    "nameOfBusiness": "Nombre de la empresa",
    "dispute_this_review": "Impugnar esta reseña",
    "story_mention": "Mención de la historia",
    "story_reply": "Responder a la historia",
    "no": "No",
    "yes": "Sí",
    "annual": "anual",
    "plan": "Plan",
    "errors": {
      "somethingWrong": "Algo ha ido mal"
    },
    "zero": "0",
    "perMonth": "por mes",
    "emailCheckLinks": "Compruebe los enlaces donde tiene un valor personalizado. Hay un \"%20\" adicional entre {{ y custom_values.",
    "fileSizeTooLarge": "El tamaño del archivo es superior a 5 MB",
    "fileSizeTooLargeDescription": "El documento que está tratando de subir es demasiado grande. Inténtelo con un archivo más pequeño.",
    "minMaxLength40Characters2048Characters": "Longitud mín.: 40 caracteres. Longitud máx.: 2048 caracteres.",
    "sampleMessage2": "Mensaje de muestra #2*",
    "pleaseSelectWorkflow": "Seleccione un flujo de trabajo",
    "childrens": "Niños",
    "brandAndCampaignRegistration": "Se hará un cargo único de 20,95 $ por el registro de la marca y de la campaña. Se aplicará un cargo adicional de campaña de hasta 2,25 $ al mes conforme a las normas de TCR.",
    "einRequiredForRegistration": "EIN obligatorio para el registro",
    "changed_props": "Propiedades cambiadas",
    "total_memory": "Memoria Total",
    "total_store_size": "Tamaño total de la tienda",
    "total_watchers": "Total de espectadores",
    "update_count": "Recuento de actualizaciones"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Acciones en bloque",
      "clickHere": "Haga clic aquí para ver la lista de acciones en bloque.",
      "mergedMessage": "Esta página se ha fusionado con la lista de acciones en bloque.",
      "title": "Solicitudes de Contacto"
    }
  },
  "conversations": {
    "noConversationsFound": "No se han encontrado {status} conversaciones",
    "create_new": "Crear nuevo mensaje​",
    "validations": {
      "minCharsRequired": "Se requieren al menos 3 caracteres",
      "twoMoreCharsRequired": "Se requieren 2 caracteres más",
      "oneMoreCharRequired": "Se requiere 1 carácter más"
    },
    "sortLabels": {
      "latestAllMessages": "Más reciente - Todos los mensajes",
      "oldestAllMessages": "Más antiguo - Todos los mensajes",
      "latestManualMessages": "Más reciente - Mensajes manuales",
      "oldestManualMessages": "Más antiguo - Mensajes manuales",
      "latestAll": "Más reciente - Todo",
      "oldestAll": "Más antiguo - Todo",
      "latestManual": "Más reciente - Manual",
      "oldestManual": "Más antiguo-Manual",
      "highToLow": "{name} (de mayor a menor)",
      "manualMessagesTooltip": "La opción de clasificación será aplicable a los mensajes después del 18 de mayo de 2023."
    },
    "deleteConversation": {
      "title": "Confirmación",
      "confirmWithName": "¿Seguro que desea borrar la conversación con {name} para siempre? Esta acción no se puede deshacer.",
      "confirmWithoutName": "¿Seguro que desea borrar esta conversación para siempre? Esta acción no se puede deshacer."
    },
    "makeCall": {
      "enterPhoneNumber": "Para hacer una llamada, introduzca un número de teléfono en este campo.",
      "invalidPhoneNumber": "Twilio Lookup ha marcado este número de teléfono como no válido."
    },
    "actions": {
      "markAsStarred": "Marcar como destacado",
      "unarchive": "Desarchivar",
      "unmarkAsStarred": "Desmarcar como destacado"
    },
    "send": {
      "perMonthPerIp": "/mes/IP",
      "perIp": "/ IP",
      "replyingTo": "Respondiendo a",
      "requestClientsPaymentDetails": "Solicitar la información de pago de los clientes",
      "saasModeCreditCardRequired": "El modo SaaS requiere que el cliente tenga una tarjeta de crédito registrada.",
      "please": "Por favor,",
      "firstBeforeEnablingSaaS": "primero, antes de habilitar el modo SaaS",
      "shareALink": "Comparta un enlace",
      "shareLinkInstructions": "Comparta un enlace con su cliente para recopilar sus datos de pago",
      "requestViaEmail": "Solicitud por correo electrónico",
      "twilioRebillingDescription": "Refacture los costes de Twilio ({twilioCopy}) a sus clientes e incluya un margen de beneficio",
      "seeHow": "Descubra cómo",
      "phoneRebillingCardInfoRequired": "La refacturación telefónica requiere tener la información de la tarjeta del cliente registrada.",
      "clientsCompanyBillingPage": "página de facturación de la empresa del cliente",
      "ifYouPayForTwilioKeepUsing": "Si paga por Twilio, siga usando la misma cuenta de Twilio",
      "ifClientPaysForTwilioCreateNew": "Si el cliente paga por Twilio, cree una nueva cuenta de Twilio",
      "learnHow": "Aprenda cómo",
      "createNewTwilioAccountInstructions": "Cree una nueva cuenta de Twilio para esta ubicación",
      "learnHowToMovePhoneNumbers": "Aprenda cómo transferir números de teléfono",
      "thisIsMyClientsTwilioCreateNew": "Este es el Twilio de mi cliente, crear una nueva cuenta",
      "featureUnderDevelopment": "Esta función está en desarrollo",
      "emailRebillingDescription": "Refacture los costes de correo electrónico a sus clientes e incluya un margen",
      "emailRebillingCardInfoRequired": "La refacturación por correo electrónico requiere que la información de la tarjeta esté archivada para el cliente.",
      "emailRebillingMarginsDescription": "Estos son márgenes que se facturan a sus clientes además de los costos de correo electrónico",
      "provider": "Proveedor",
      "morePlanCustomizationsAvailable": "Más opciones de personalización de planes disponibles",
      "plansAndPricing": "Planes y precios",
      "connectYourStripeAccountFirst": "Primero conecta tu cuenta de Stripe",
      "createRecommendedPlansOnStripe": "Cree planes recomendados en Stripe",
      "createdPlanInStripe": "Plan creado en Stripe",
      "customizeYourSaasPlans": "Personalice sus planes SaaS",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Puede ofrecer planes recomendados o crear los suyos propios",
      "trialPeriod": "Periodo de prueba",
      "enterNumberOfDaysForTrial": "Introduzca el número de días para la prueba",
      "nameCantBeEmpty": "El nombre no puede estar vacío",
      "showStripeProductDetails": "Mostrar Detalles del Producto Stripe",
      "addEmail": "Añadir correo electrónico",
      "resetMountCounts": "Reiniciar recuento de montajes",
      "connectReconnectGoogleForGbp": "Conecte o vuelva a conectar Google para GBP",
      "downloadFile": "Descargar archivo",
      "showOnlySlowQueries": "Mostrar solo consultas lentas",
      "gmbMessagingAvailable": "La mensajería de GMB ya está disponible",
      "reconnectGbpPageToEnable": "Reconecte su página de GBP para habilitar la mensajería",
      "failedPaymentsCheckBilling": "Se han detectado pagos fallidos. Revise su facturación.",
      "onlyAgencyAdminsCanSeeWarning": "Solo los administradores de la agencia pueden ver esta advertencia.",
      "filter": "Filtrar",
      "stopDeleteOperation": "Detener operación de eliminación",
      "summary": "Resumen",
      "enableTracking": "Habilitar el seguimiento",
      "exportAll": "Exportar todo",
      "newConversationStarted": "Nueva conversación iniciada",
      "startNewConversation": "Iniciar nueva conversación",
      "subAccountScheduledForDeletion": "Subcuenta programada para su eliminación",
      "deleteSubAccountOnScheduledTime": "Eliminar subcuenta a la hora programada",
      "componentUpdatesDebuggerAlpha": "Depurador de actualizaciones de componentes (alfa)",
      "componentUpdateTrackingDisabled": "El seguimiento de actualizaciones de componentes está desactivado",
      "deleteSubAccount": "Eliminar subcuenta",
      "subAccountHasNumbersAndCampaigns": "Esta subcuenta tiene {phoneNumberCount} número(s) de teléfono y {campaignsCount} campaña(s).",
      "subAccountNoNumbersOrCampaigns": "Esta subcuenta no tiene números de teléfono ni campañas.",
      "areYouSureDeleteSubAccount": "¿Seguro que desea eliminar esta subcuenta?",
      "confirmDiscussedWithClient": "Confirmo que he hablado con mi cliente",
      "understandActionIrreversible": "Entiendo que esta acción es irreversible",
      "confirmDisconnectCloseLcPhone": "Confirmo que deseo desconectar y cerrar la cuenta de LC Phone",
      "choosingNotDeleteLcPhoneWarning": "Advertencia: Si decide no eliminar la cuenta de LC Phone, seguirá incurriendo en cargos por los números de teléfono asociados a esta subcuenta.",
      "deleteAccount": "Eliminar cuenta",
      "send": "Enviar",
      "typeMessage": "Escribir mensaje",
      "requestPayment": "Solicitar pago",
      "reply": "Responder",
      "retry": "Reintentar",
      "analyzeMemory": "Analizar Memoria",
      "memoryAnalysisApproximate": "🚧 El análisis de memoria es aproximado y no es 100 % preciso.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Esta subcuenta se ha programado para su eliminación. Será eliminada por",
      "youCanChangeYourMindBeforeThisTime": "Puede cambiar de opinión antes de que transcurra este plazo.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Saltar",
          "cannotIdentifyContact": "No se puede identificar el contacto ni su ubicación.",
          "contactNotSelected": "El contacto no ha sido seleccionado.",
          "messageRequired": "Asegúrese de haber introducido un mensaje o haber seleccionado una plantilla.",
          "noPhoneNumber": "El contacto no dispone de número de teléfono.",
          "genericError": "{message}",
          "stayPrompt": "Manténgase"
        },
        "scheduledSuccess": "Correo electrónico programado correctamente",
        "confirmDelete": "¿Seguro que desea eliminar {name}?"
      },
      "clear": "Borrar",
      "edit": "Editar",
      "sendNow": "Enviar ahora",
      "schedule": "Programar",
      "useTemplate": "Utilice una plantilla (fragmento)",
      "mergeFields": "Campos de combinación",
      "customVariablesError": "Hay algunos problemas en sus variables personalizadas, corríjalos antes de enviar.",
      "sendLater": "Enviar más tarde",
      "scheduledFor": "Programado para {date}",
      "call": "Llamada",
      "leftVoicemail": "Ha dejado un mensaje de voz",
      "pleaseSelectCampaign": "Seleccione una campaña",
      "whatsapp": {
        "no24HourMessage": "Solo puede enviar mensajes de plantilla fuera de la ventana de 24 horas. Por favor, seleccione una plantilla para enviar."
      },
      "attachFile": "Adjuntar documento",
      "email": {
        "fromEmail": "Correo electrónico del remitente",
        "fromName": "Nombre del remitente",
        "smtpWarning": "Los proveedores de SMTP tienen algunas limitaciones. Haga clic aquí para obtener más información.",
        "subject": "Asunto",
        "errors": {
          "cannotIdentifyContact": "No se puede identificar el contacto ni su ubicación.",
          "contactNotSelected": "El contacto no ha sido seleccionado.",
          "genericError": "{message}",
          "bodyRequired": "El correo electrónico requiere un cuerpo de texto para poderse enviar.",
          "noEmailAddress": "El contacto no tiene una dirección de correo electrónico."
        },
        "scheduledSuccess": "Correo electrónico programado correctamente"
      },
      "addCalendarToSchedule": "Debe añadir un calendario para comenzar a programar citas.",
      "slotRequired": "Franja horaria obligatoria",
      "teamMemberRequired": "Se requiere un miembro del equipo."
    },
    "added": "añadido",
    "loadMore": "Cargar más",
    "admin": "Administrador",
    "aiEmployee": {
      "popupBlockedAlert": "Ha deshabilitado la ventana emergente. Permita que las ventanas emergentes de este sitio redirijan automáticamente a la llamada de Zoom. Haga clic en unirse ahora para redirigir directamente a la llamada Zoom."
    },
    "alsoCloseAssociatedSubAccount": "También estrechamente asociado",
    "analyzeMemory": "Analizar la memoria",
    "announcements": "Avisos",
    "apply": "Aplicar",
    "appointment": {
      "pickDay": "Seleccionar un día",
      "pickSlot": "Seleccionar una franja horaria de cita",
      "selectDate": "Seleccionar la fecha",
      "selectSlot": "Seleccionar la franja horaria",
      "slot": "Franja horaria",
      "day": "Día"
    },
    "areYouReallySureDeleteSubAccount": "¿Está realmente seguro de que desea eliminar esta subcuenta?",
    "areYouSureDeleteSubAccount": "¿Seguro que desea eliminar esta subcuenta?",
    "assignedContactOwner": "Asignado (propietario del {contact})",
    "assignedToMe": "Asignado a mí",
    "audio": {
      "browserNotSupported": "Su navegador no admite el elemento de audio.",
      "loadingTranscription": "Cargando transcripción…",
      "viewTranscript": "Ver transcripción",
      "stop": "Detener",
      "playPause": "Reproducir/pausar",
      "timePlayed": "Tiempo de reproducción: tiempo total",
      "mute": "Silenciar",
      "playbackSpeed": "Velocidad de reproducción",
      "download": "Descargar",
      "remove": "Eliminar"
    },
    "automated": "Automatizado",
    "avatar": {
      "aiGenerated": "Este mensaje fue generado por Conversation AI",
      "messengerAutomation": "Automatización de Messenger",
      "workflowGenerated": "Este mensaje fue generado por la acción de flujo de trabajo de Conversation AI",
      "messageByAI": "Este mensaje fue generado por Conversation AI",
      "messageByWorkflow": "Este mensaje fue generado por la acción de flujo de trabajo de Conversation AI",
      "agentPrefix": "E-",
      "unknownFallback": "¿?"
    },
    "bePartOfFastestGrowingCommunity": "Forme parte de la comunidad de más rápido crecimiento.",
    "callHighlevelAt": "Llame a HighLevel al +1(888)732-4197",
    "callQueueTooltip": "Esta llamada está en la cola de llamadas del usuario esperando a activarse.",
    "callTranscript": "Transcripción de la llamada",
    "clearFilters": "Borrar filtros",
    "clientsCompanyBillingPage": "página de facturación de la empresa del cliente",
    "closeChat": "Cerrar chat",
    "closeConversation": "Cerrar conversación",
    "component": {
      "dismissMessage": "DESCARTAR ESTE MENSAJE",
      "unblock": "Desbloquear",
      "inboundDndActive": "Se ha activado la función DND entrante para este contacto",
      "fetchOlderMessages": "Obtener mensajes antiguos",
      "conversationBegan": "La conversación ha comenzado",
      "celebrationTitle": "¡Guau! Ahora sí que fluyen las conversaciones",
      "celebrationBody": "Las cosas no han hecho más que empezar, veamos cómo GHL puede ayudarle a construir su negocio.<br />Mientras tanto, puede seguir enviando mensajes a voluntad"
    },
    "componentUpdateTrackingDisabled": "El seguimiento de actualizaciones de componentes está desactivado actualmente.",
    "componentUpdatesDebuggerAlpha": "🚧 Depurador de actualizaciones de componentes (Alpha) - En progreso",
    "confirmDelete": "¿Eliminar conversaciones?",
    "confirmDeleteTextLine11": "¿Seguro que desea eliminar esta conversación? Esta acción es irreversible.",
    "confirmDeleteTextLine12": "conversaciones seleccionadas",
    "confirmDeleteTextLine21": "Esta acción es irreversible. ¿Aún desea continuar?",
    "confirmDisconnectedAllIntegrations": "Confirmo que he desconectado todas las integraciones como Twilio, Mailgun, GMB, dominios, Facebook, Zoom, etc.",
    "confirmStoppedAllAutomations": "Confirmo que he puesto en pausa todas las automatizaciones en esta cuenta",
    "connectReconnectGoogleForGbp": "¡Conecte o vuelva a conectar su Google para obtener mensajes de GBP!",
    "connectWithCertifiedAdmin": "Conéctese con un Administrador Certificado",
    "connectWithTeamForHelp": "Conéctese con nuestro equipo para obtener ayuda a través de una videollamada en directo.",
    "connectWithUs": "Conéctese con nosotros",
    "connectZoomAccount": "Conectar la cuenta de Zoom",
    "contactEngagementScore": "Puntuación de interacción de {contact}",
    "dailyBrainstormingSessions": "Sesiones diarias de lluvia de ideas con HighLevel",
    "deleteAccount": "Eliminar cuenta",
    "deleteSubAccountOnScheduledTime": "Eliminar la subcuenta en el momento programado",
    "disableSaasMode": "Desactive el modo SaaS",
    "dnd": {
      "configure": "CONFIGURAR",
      "status": {
        "on": "SÍ",
        "partial": "Parcial"
      }
    },
    "editAppointment": {
      "updateButton": "Actualizar cita",
      "scheduleAppointment": "Programar cita",
      "editAppointment": "Editar cita",
      "calendar": "Calendario",
      "selectCalendar": "Seleccionar calendario",
      "roundRobin": "Rotación",
      "pickTeamMember": "Seleccionar miembro del equipo",
      "selectTeamMember": "Seleccionar un miembro del equipo",
      "teamMemberRequired": "Se requiere un miembro del equipo.",
      "slotRequired": "Franja horaria obligatoria",
      "appointmentTitle": "Título de la cita",
      "appointmentTitleTooltip": "Considere la posibilidad de dejarlo en blanco si opta por utilizar el título de cita preconfigurado",
      "contactName": "Nombre del contacto",
      "name": "Nombre",
      "nameRequired": "Nombre obligatorio",
      "emailAddress": "Dirección de correo electrónico",
      "phoneNumber": "Número de teléfono",
      "phoneNumbers": "Números de teléfono",
      "dateOfBirth": "Fecha de nacimiento",
      "contactTimezone": "Zona horaria de contacto (utilizada para el recordatorio)",
      "chooseOne": "Seleccionar una...",
      "meetingLocation": "Lugar de la reunión",
      "meetingLocationTooltip": "Considere la posibilidad de dejarlo en blanco en caso de que decida utilizar el lugar de reunión preconfigurado",
      "status": "Estado",
      "appointmentStatus": "Estado de la cita",
      "additionalNotes": "Notas adicionales",
      "notes": "Notas",
      "actionRequired": "Acción requerida",
      "confirmed": "Confirmado",
      "invalid": "No válido",
      "cancelled": "Cancelado",
      "showed": "Asistido",
      "noShow": "No asistido",
      "busy": "Ocupado",
      "free": "Gratis",
      "noCalendarMessage": "Debe añadir un calendario para comenzar a programar citas."
    },
    "email": {
      "errors": {
        "bodyRequired": "El correo electrónico requiere un cuerpo de texto para poderse enviar.",
        "cannotIdentifyContact": "No se puede identificar el contacto ni su ubicación.",
        "contactNotSelected": "El contacto no ha sido seleccionado.",
        "noEmailAddress": "El contacto no tiene dirección de correo electrónico."
      },
      "thread": {
        "failedToFetch": "Error al recuperar el contenido del correo electrónico",
        "forward": "Reenviar"
      },
      "reply": "Responder",
      "share": "Compartir",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ añadir cuenta",
      "respond": "Responder",
      "retry": "Reintentar",
      "moreEmailsInThread": "{count} correos electrónicos más en el hilo",
      "fromName": "Nombre del remitente",
      "fromEmail": "Correo electrónico del remitente",
      "subject": "Asunto",
      "attachFile": "Adjuntar archivo",
      "useTemplate": "Utilice una plantilla (fragmento)",
      "requestPayment": "Solicitar pago",
      "clear": "Borrar",
      "sendNow": "Enviar ahora",
      "schedule": "Programar",
      "send": "Enviar",
      "smtpWarning": "Los proveedores de SMTP tienen algunas limitaciones. Haga clic aquí para obtener más información.",
      "chooseOne": "Seleccionar una...",
      "deliveredCount": "{delivered}/{total} enviados",
      "typeMessage": "Escriba mensaje",
      "sendLater": "Enviar más tarde",
      "scheduledFor": "Programado para el {date}"
    },
    "emailRebillingCardInfoRequired": "Para activar la refacturación por correo electrónico, necesita introducir la información de la tarjeta de su cliente en",
    "emailRebillingDescription": "Esto le permite volver a facturar los costes de correo electrónico a sus clientes e incluir un recargo.",
    "emailRebillingMarginsDescription": "Estos son márgenes que se facturan a sus clientes, además del coste del correo electrónico que usted asume.",
    "enableTracking": "Habilitar el seguimiento",
    "exploreHighlevelExperts": "Explore a los expertos de HighLevel que pueden ayudarle a configurar su sistema, automatizar flujos de trabajo o personalizar su proyecto.",
    "exportAll": "Exportar todo",
    "facebook": {
      "errors": {
        "generalError": "Se ha producido un error. Inténtelo de nuevo o compruebe la integración de Facebook. Mensaje de error:",
        "noFacebookId": "El contacto no tiene un id. de Facebook"
      }
    },
    "failedPaymentsCheckBilling": "Tiene uno o más pagos fallidos. Revise su historial de facturación",
    "fbMessengerDM": "DM de FB Messenger",
    "filters": {
      "above": "Encima",
      "aiActionLogs": "Registros de acciones de AI",
      "inRange": "En el intervalo",
      "invoice": "Factura",
      "messageDirectionTooltip": "El filtro se aplicará a los mensajes posteriores al 9 de mayo de 23",
      "appointments": "Citas"
    },
    "followed": "Seguido por",
    "followedByMe": "Seguido por mí",
    "followedBySpecificUser": "Seguido por un usuario específico",
    "follower": "Seguidor",
    "followerAssignmentContact": "Seguidor (asignación de {contact})",
    "gbp": {
      "errors": {
        "generalError": "Se ha producido un error. Inténtelo de nuevo o compruebe la integración de Google Business Profile. Mensaje de error:",
        "noGBPId": "El contacto no tiene un id. de GBP."
      }
    },
    "gbpChatNoLongerAvailable": "El chat de Google Business Profile ya no está disponible",
    "getAccessToHighlevelWelcomeCourse": "Obtener acceso al curso de bienvenida de HighLevel",
    "getPriorityTroubleshooting": "Obtenga asistencia prioritaria para la resolución de problemas, asesoramiento de expertos y acceso directo a nuestro equipo técnico a través de Slack.",
    "gmbMessagingAvailable": "Google Business Messaging está disponible para su cuenta.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Valoración:",
      "replyDate": "Fecha de respuesta:",
      "replyFrom": "Respuesta de:",
      "review": "Revisar",
      "reviewDate": "Día de Reseña:",
      "reviewFrom": "Reseña de:"
    },
    "highlevelEvents": "Eventos de HighLevel",
    "igMessengerDM": "DM de IG Messenger",
    "includeSignatureBeforeQuotedText": "Incluir esta firma antes del texto citado en las respuestas",
    "instagram": {
      "errors": {
        "generalError": "Se ha producido un error. Inténtelo de nuevo o compruebe la integración de Instagram. Mensaje de error:",
        "noInstagramId": "El contacto no tiene un Id. de Instagram"
      }
    },
    "joinOurFacebookGroup": "Únase a nuestro grupo de Facebook",
    "keepUpToDateWithLatestNews": "Manténgase al día de las últimas noticias y lanzamientos.",
    "lastMessageChannel": "Canal del último mensaje",
    "lastMessageDirection": "Dirección del último mensaje",
    "lastOutboundMessageType": "Tipo del último mensaje saliente",
    "learnHow": "Descubra cómo",
    "leftComment": "ha dejado un comentario",
    "leftPanel": {
      "recents": "Recientes",
      "unread": "No leído",
      "createNewMessage": "Crear nuevo mensaje",
      "minCharsRequired": "Se requieren al menos 3 caracteres",
      "twoMoreCharsRequired": "Se requieren 2 caracteres más",
      "oneMoreCharRequired": "Se requiere 1 carácter más"
    },
    "liveChat": {
      "endLiveChat": "Finalizar el chat en tiempo real",
      "errors": {
        "generalError": "Se ha producido un error. Inténtelo de nuevo o compruebe la integración de Google My Business. Mensaje de error:"
      },
      "requestContact": "Solicitar contacto"
    },
    "live_chat_message": "Mensaje de chat en tiempo real",
    "made": "hechos",
    "memoryAnalysisApproximate": "🚧 El análisis de memoria es aproximado y no es 100 % preciso.",
    "mentioned": "Mencionado a",
    "mentions": "Menciones",
    "mentionsOfMe": "Se me menciona",
    "mentionsOfSpecificUser": "Menciones de usuario determinado",
    "message": {
      "replyAll": "Responder a todos",
      "details": "Detalles",
      "reply": "Responder",
      "unsuccessful": "No ha funcionado",
      "pending": "Pendiente",
      "inboundCall": "Llamada entrante",
      "outboundCall": "Llamada saliente",
      "ivrCall": "Llamada IVR",
      "leftVoicemail": "Ha dejado un mensaje de voz",
      "storyReply": "Responder a la historia",
      "storyMention": "Mención de la historia",
      "replyAsDM": "Responder como DM",
      "newCommentOnPost": "Nuevo comentario en la publicación {pageName}.",
      "goToPost": "Ir a la publicación",
      "replyNotAvailable": "Responder como DM Privado no está disponible para comentarios de más de 7 días.",
      "addToDocuments": "Añadir documentos",
      "attachmentsAddedSuccess": "Los archivos adjuntos se han añadido correctamente a los documentos",
      "attachmentsAddedFailed": "Error al añadir los archivos adjuntos a los documentos",
      "reportFeedbackForAI": "Informe de comentarios para AI",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "CCO",
      "cancelScheduleConfirm": "¿Seguro que desea cancelar esta programación?",
      "cancelScheduledMessage": "¿Cancelar el mensaje programado?",
      "cancelSend": "Cancelar el envío",
      "cancelScheduledSuccess": "Mensaje programado cancelado correctamente",
      "cancelScheduledError": "Se ha producido un error al cancelar el mensaje programado",
      "cc": "CC",
      "channel": "Canal",
      "createdBy": "Creado por",
      "direction": "Dirección",
      "emailCampaign": "Campaña de correo electrónico",
      "facebookMessage": "Mensaje de Facebook",
      "instagramMessage": "Mensaje de Instagram",
      "messageId": "Id. de mensaje",
      "messageIdLabel": "ID del mensaje: ",
      "trigger": "Activador",
      "unanswered": "Sin respuesta",
      "yes": "Sí",
      "messageDetails": "Información del mensaje",
      "from": "De",
      "fromLabel": "De:",
      "to": "A",
      "toLabel": "Para:",
      "unknown": "Desconocido",
      "unknownFrom": "Desconocido de",
      "unknownTo": "Desconocido para",
      "unknownDirection": "Dirección desconocida",
      "dateUnknown": "Fecha desconocida",
      "emailFromUnknown": "Correo electrónico de desconocido",
      "smsFromUnknown": "SMS de desconocido",
      "callFromUnknown": "Llamada de desconocido",
      "voicemailFromUnknown": "Mensaje de voz de desconocido",
      "emailToUnknown": "Correo electrónico a desconocido",
      "smsToUnknown": "SMS a Desconocido",
      "callToUnknown": "Llamada a desconocido",
      "voicemailToUnknown": "Mensaje de voz a desconocido",
      "failed": "Fallido",
      "datetime": "Día y hora",
      "manual": "Manual",
      "automation": "Automatización",
      "workflow": "Flujo de trabajo",
      "campaign": "Campaña",
      "bulkRequest": "Solicitud masiva",
      "delivered": "Entregado",
      "bounced": "Rebotado",
      "opened": "Abierto",
      "sent": "Enviado",
      "scheduled": "Programado",
      "pageName": "Nombre de la página",
      "gbpMessage": "Mensaje de GBP",
      "no": "No",
      "eventsTrackedForContactOnly": "Actualmente, los eventos solo se capturan para la dirección de correo electrónico del contacto.",
      "completed": "Completado",
      "voicemail": "Mensaje de voz",
      "busy": "Ocupado",
      "pending": "Pendiente",
      "read": "Leer",
      "nativeIntegrations": "Integraciones Nativas",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "Correo electrónico",
      "sms": "SMS",
      "phoneCall": "Llamada de teléfono",
      "voiceMail": "Mensaje de voz",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Reseñas",
      "others": "Otros",
      "partialDetailsWarning": "Los detalles parciales estarán disponibles para los mensajes anteriores al 15 de julio de 2022.",
      "agencySystem": "Sistema de agencias",
      "reply": "Responder"
    },
    "multiplePhone": {
      "chooseNumber": "Elija un número para iniciar la conversación:",
      "continue": "Continuar",
      "noPhones": "No hay números de teléfono disponibles"
    },
    "myChat": "Mi chat",
    "myInbox": "Mi bandeja de entrada",
    "newConversationStarted": "Nueva conversación iniciada",
    "newMessage": {
      "title": "Nuevo mensaje:",
      "errors": {
        "phoneRequired": "El teléfono es obligatorio"
      }
    },
    "noConversationSelected": "No se ha seleccionado ninguna conversación",
    "noResultsToShow": "No hay resultados para mostrar",
    "onboardingVideoTutorials": "Tutoriales de vídeo de incorporación",
    "onlyAgencyAdminsCanSeeWarning": "Solo los administradores de la agencia pueden ver esta advertencia. Para más información",
    "onlyVisibleToUsers": "Solo visible para los usuarios",
    "perMonthPerIp": "/mes/IP",
    "phone": {
      "call": "Llame a {name}",
      "callingOptions": "{count} opciones de llamada",
      "phoneNumbers": "Números de teléfono",
      "callOptions": "{count} opciones de llamadas",
      "dndActive": "La función DND está activa para las llamadas",
      "primary": "Principal"
    },
    "pleaseDisableSaasMode": "Desactive el modo SaaS para esta subcuenta",
    "pleaseSelectCampaign": "Seleccione una campaña",
    "premiumSupport": "Asistencia prémium",
    "quickFilters": "Filtros rápidos",
    "reconnectGbpPageToEnable": "Reconecte su página de GBP para habilitarla.",
    "replyAsDMTooltip": "Responda a este comentario como enviando un DM privado.",
    "replyingTo": "Respondiendo a",
    "resetMountCounts": "Restablecer recuentos de montajes",
    "review": {
      "errors": {
        "generalError": "Se ha producido un error. Mensaje de error:",
        "googleIntegrationError": "No es posible responder a esa reseña. Parece que hay un error con su integración de Google. Reconéctela en Configuración -> Integraciones.",
        "noReviewId": "La conversación no tiene un id. de reseña."
      },
      "reviewPostTo": "Revisar la publicación en {network}",
      "sharedOn": "Reseña compartida en {network}",
      "disputeReview": "Impugnar esta reseña",
      "learnHow": "(Descubra cómo)",
      "seeOnGBP": "Ver esta reseña en GBP",
      "alreadyShared": "Esta reseña ya ha sido publicada en {network}. ¿Seguro que desea volver a publicarla?"
    },
    "reviewId": "ID de reseña",
    "schedule": {
      "sendSchedule": "Enviar programación",
      "timezone": "Zona horaria ({heading})",
      "title": "Programe su {type}"
    },
    "scheduling": "Programando...",
    "seeHow": "Descubra cómo",
    "selectFilter": "Seleccionar filtro",
    "selected": "seleccionado",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Asunto:",
      "subjectPlaceholder": "Asunto del correo electrónico",
      "to": "Para:",
      "sending": "Enviando...",
      "sendButton": "Enviar correo electrónico"
    },
    "setupAccountWithFreeTutorials": "Configure su cuenta, con tutoriales gratuitos",
    "showOnlySlowQueries": "Mostrar solo consultas lentas (>{threshold}ms)",
    "sms": {
      "confirmSending": "Confirmar el envío del mensaje",
      "editModal": {
        "compose": "Redactar SMS"
      },
      "errors": {
        "customVariablesIssue": "Hay algunos problemas en sus variables personalizadas, corríjalos antes de enviar.",
        "messageOrTemplateRequired": "Asegúrese de haber introducido un mensaje o haber seleccionado una plantilla.",
        "noPhoneNumber": "El contacto no dispone de número de teléfono."
      },
      "scheduledSuccessfully": "SMS programado correctamente",
      "sendAnyway": "Enviar de todos modos",
      "spamWarning": "El contenido de sus SMS puede incluir referencias al cannabis, SHAFT, vapeadores u otros temas prohibidos. El envío de este tipo de contenido vía SMS está estrictamente prohibido y puede ocasionar restricciones en la cuenta. Revise el contenido detenidamente antes de continuar.",
      "send": "Enviar"
    },
    "startNewConversation": "Iniciar nueva conversación",
    "subAccountAndDeleteAllPhoneNumbers": "subcuenta y eliminar todos los números de teléfono",
    "subAccountScheduledForDeletion": "Esta subcuenta está programada para su eliminación",
    "subAccountScheduledForDeletionItWillBeDeleted": "Esta subcuenta se ha programado para su eliminación. Será eliminada por",
    "teamInbox": "Bandeja de entrada del grupo",
    "threshold": "Límite",
    "understandActionIrreversible": "Entiendo que esta acción es irreversible y que se perderán todos los datos dentro de esta subcuenta",
    "unstarred": "Eliminado de destacados",
    "use_a_template": "Utilice una plantilla",
    "userAvailability": "Disponibilidad de usuarios",
    "userCalendarConfiguration": "Configuración del Calendario de Usuario",
    "userInfo": "Información del usuario",
    "userRoles": "Roles de usuario",
    "viewSupportTickets": "Consulte sus incidencias de asistencia, nuestros artículos de asistencia y las preguntas frecuentes de gran utilidad.",
    "visitOurHelpCenter": "Visite nuestro centro de ayuda",
    "welcomeCourse": "Curso de bienvenida",
    "whatsapp_logo": "Logotipo de WhatsApp",
    "youCanChangeYourMindBeforeThisTime": "Puede cambiar de opinión antes de que transcurra este plazo.",
    "zoomAccount": "Cuenta de Zoom",
    "deleteEmails": "Eliminar {count} correo(s) electrónico(s)",
    "fileAttachment": {
      "urlNotFound": "No se puede encontrar la URL",
      "unsupportedAttachment": "Es posible que estos archivos adjuntos ya no sean compatibles.",
      "downloadFile": "Descargar archivo"
    },
    "composer": {
      "internalComment": "Comentario interno"
    },
    "dropdown": {
      "openOptions": "Abrir opciones",
      "messageDetails": "Información del mensaje"
    },
    "respond": "Responder",
    "selectTemplate": "Seleccionar plantilla",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Ha deshabilitado la ventana emergente. Permita que las ventanas emergentes de este sitio redirijan automáticamente a la llamada de Zoom. Haga clic en unirse ahora para redirigir directamente a la llamada Zoom.",
        "helpAndSupport": "Ayuda y asistencia",
        "summerOfAI": "Verano de AI"
      }
    },
    "celebration": {
      "dismiss": "Descartar",
      "body": "Las cosas no han hecho más que empezar, exploremos cómo GHL puede ayudarle a construir su negocio.\nMientras tanto, puede seguir enviando mensajes a voluntad",
      "title": "¡Guau! Ahora sí que fluyen las conversaciones"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "artículo de ayuda aquí",
      "message": "Active las cookies de terceros para ver esta página correctamente. Puede consultar nuestro",
      "ok": "De acuerdo",
      "title": "Las cookies de terceros no están funcionando"
    }
  },
  "crash": {
    "message": "Lo sentimos, pero ha ocurrido algo inesperado. Pruebe a actualizar la página.",
    "refresh": "Actualizar la página",
    "title": "¡Vaya! Algo ha ido mal"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Interrumpiendo la eliminación de {name}",
      "confirmAbort": "Sí, interrumpir",
      "keepDeleting": "No, continuar con la eliminación",
      "message": "¿Seguro que desea interrumpirla?",
      "scheduledForDeletion": "Esta ubicación está programada para eliminarse el {date}",
      "title": "Interrumpir la eliminación",
      "warning": "Tenga en cuenta que la ubicación se borrará en la fecha programada a menos que interrumpa la eliminación."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Suelte aquí los archivos para subirlos",
      "uploadError": "Error de red: No se ha podido enviar la solicitud a AWS (posible error CORS)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Añadir {entityName}",
      "clonedMessage": "¡Se ha clonado {entityName}! Cambie a la cuenta donde se clonó y búsquela en la pestaña de {entityName}.",
      "errorGettingDetails": "Parece que ha habido un error al obtener los detalles de {entityName}. Compruebe la URL o inténtelo de nuevo.",
      "permissionError": "Error de permiso: Este embudo está protegido y no puede crearse aquí."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "Logotipo de GoogleCalendar"
    },
    "printful": {
      "logo": "Logotipo de Printful",
      "title": "Printful: Impresión bajo demanda"
    },
    "printify": {
      "logo": "Logotipo de Printify",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "Logotipo de ShipStation",
      "title": "ShipStation"
    },
    "shippo": {
      "logo": "Logotipo de Shippo",
      "title": "Shippo: Integración de Envíos"
    },
    "tikTok": {
      "accountNotConnected": "Cuenta no conectada",
      "accountNotConnectedMessage": "Su cuenta no está conectada con la cuenta publicitaria de TikTok. Integración completa para ver formularios y asignar campos.",
      "advertiserId": "ID del anunciante",
      "companyFields": "Campos de {companyName}",
      "editFields": "Editar campos",
      "errorSubscribing": "Error al suscribirse a la página.",
      "formsNotAvailable": "Formularios no disponibles",
      "mandatoryFieldsNote": "Nota: Asigne cualquiera de los siguientes campos obligatorios a fin de recibir clientes potenciales en su cuenta de forma correcta. Campos: Nombre, Apellidos, Correo electrónico, Número de teléfono",
      "noFormsMessage": "Actualmente no tiene ningún formulario de generación de clientes potenciales creado en su cuenta publicitaria de TikTok. Visite su cuenta publicitaria de TikTok y cree uno para empezar.",
      "pageId": "ID de página",
      "selectAdvertiserAccount": "Seleccione la cuenta del anunciante"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Otro / No lo sé",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Tiene que seguir unos sencillos pasos para pausar esta subcuenta"
    },
    "transfer": {
      "chooseDescription": "Seleccione el método de transferencia",
      "chooseMethod": "Transferir esta subcuenta",
      "eject": {
        "description": "Obtenga una comisión recurrente del 40 % por la suscripción de la nueva cuenta.",
        "title": "Expulsar como cuenta nueva"
      },
      "modal": {
        "confirmDetails": "Confirme los detalles antes de hacer la transferencia",
        "confirmNomineePrefix": "Nominar al propietario para",
        "confirmTransfer": "Confirmar transferencia",
        "consentText": "He leído y comprendido la guía anterior y acepto todas las limitaciones",
        "ejectErrorTitle": "No se ha podido expulsar la subcuenta.",
        "ejectGenericError": "La subcuenta que intenta expulsar no puede ser expulsada. Póngase en contacto con el servicio de asistencia.",
        "ejectGuidelines": "Directrices para la expulsión de subcuentas",
        "ejectSubject": "La expulsión de la subcuenta está sujeta a que el usuario acepte la solicitud de creación de una nueva agencia.",
        "ejectSuccessTitle": "Solicitud para expulsar la subcuenta enviada al usuario seleccionado",
        "enterPassword": "Introduzca su contraseña para confirmar",
        "genericError": "No es posible transferir la subcuenta que está tratando de transferir. Póngase en contacto con el servicio de asistencia.",
        "guidelines": "Directrices para la transferencia de cuentas",
        "guidelinesConsent": "Lea y acepte lo siguiente",
        "hipaaDisclaimer": "Exención de responsabilidad",
        "hipaaText": "Es posible que desee informar a esta subcuenta de que actualmente recibe la cobertura de la HIPAA, pero que es posible que no obtenga la misma cobertura en la agencia a la que se va a transferir.",
        "noUsersDescription": "No hay usuarios asociados a esta subcuenta. Añada un usuario de subcuenta y continúe.",
        "noUsersSearch": "No se han encontrado usuarios.",
        "noUsersTitle": "No se han encontrado usuarios",
        "nomineeInstructions": "El nominado recibirá un enlace para inscribirse en HighLevel",
        "passwordError": "Contraseña no válida",
        "passwordErrorDescription": "La contraseña que ha introducido es incorrecta. Inténtelo de nuevo.",
        "relationshipError": "Introduzca el n.º de relación correcto",
        "relationshipNumber": "Número de relación de la agencia receptora",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Solicitar transferencia",
        "seeAllRequests": "Ver todas las solicitudes",
        "successMessage": "La cuenta se transferirá una vez que la agencia receptora acepte su solicitud.",
        "successTitle": "Solicitud de transferencia de subcuenta enviada a la agencia receptora",
        "title": "Transferir subcuenta",
        "transferSubject": "La transferencia de la subcuenta está sujeta a que la agencia receptora la acepte en su cuenta.",
        "confirmNomineeSuffix": " a "
      },
      "transferExisting": {
        "description": "Transfiera toda esta subcuenta a otra cuenta.",
        "title": "Transferir a una cuenta existente"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Siguiente ejecución",
      "title": "Solicitudes masivas"
    },
    "campaign": {
      "account": "Cuenta",
      "accountBuffer": "Buffer de cuenta",
      "accountBufferDescription": "No hay límite en el número de destinatarios añadidos a esta campaña cada día (de una lista).",
      "accounts": "Cuentas",
      "activity": "Actividad",
      "acquire": "Adquirir",
      "acquisitionDescription": "Las campañas de adquisición de clientes le ayudan a generar más clientes potenciales «calientes» que están listos para interactuar.",
      "addEvent": "Añadir evento",
      "addUser": "Añadir usuario",
      "allMarket": "Todo el mercado",
      "allowMultiple": "Habilitar múltiples",
      "assignedToTooltip": "Cuando comenzó esta campaña, este contacto fue asignado a este usuario. Los cambios en Asignado a del Contacto se reflejarán en los eventos, pero no cambiarán este valor inicial.",
      "atLeastOneEvent": "Se requiere al menos un evento.",
      "automations": "Automatizaciones",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero minus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Rebotado",
      "buffering": "Buffering",
      "campaignActivity": "Actividad de campaña",
      "campaignConfiguration": "Configuración de la campaña",
      "campaignConfigurationWarning": "La configuración de la campaña afecta a todos los mercados. Asegúrese de que tiene que realizar cambios en estas configuraciones.",
      "campaignCreation": "Creación de campaña",
      "campaignId": "ID de campaña",
      "campaignStatusByRecipients": "Estado de la campaña por destinatarios",
      "clickThroughRate": "Frecuencia de clics",
      "clickedThrough": "Clics realizados",
      "conditionIfExplanation": "Ejecute esta campaña o evento si la hora actual está dentro de esta ventana; si la hora actual está fuera de esa ventana, salte la campaña o evento y pase a la siguiente.",
      "conditionWhenExplanation": "Ejecute los eventos de esta campaña cuando la hora actual caiga en esa ventana o espere hasta la siguiente ventana para ejecutar los eventos.",
      "createCampaign": " Crear campaña",
      "ctr": "CTR",
      "customerAcquisition": "Adquisición de clientes",
      "dateAdded": "Fecha de adición",
      "dateAddedTooltip": "La fecha y hora exactas en que se añadió el contacto a esta campaña. La hora de inicio del primer evento puede variar según la configuración.",
      "deletedRestorePrompt": "¡Esta campaña ha sido eliminada! ¿Desea restaurarla?",
      "delivered": "Entregado",
      "deliveryRate": "Frecuencia de entrega",
      "draftMode": "Modo Borrador",
      "draftModeDescription": "Esta campaña es un borrador. No se puede utilizar hasta que esté publicada.",
      "dropped": "Detenido",
      "emailActivity": "Actividad de correo electrónico",
      "emailActivityFilterExample": "Actividad de correo electrónico: clics realizados",
      "event": "Evento",
      "eventFilterExample": "Evento: 10X correo electrónico 4 (distribución de fichas)",
      "filters": "Filtros",
      "emailPerformanceByAccount": "Rendimiento del correo electrónico por cuenta",
      "emailsNotSentOnDays": "Los correos electrónicos no se enviarán sábados ni domingos.",
      "emailsSentOnDays": "Los correos electrónicos se enviarán los lunes, martes, miércoles, jueves y viernes.",
      "eventStartDate": "Fecha de inicio del evento",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "City Perks Coffehouse",
      "exampleDate": "8 de mayo de 2017 13:27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Asegúrese de que los datos no tengan más de 30 días",
      "exampleEventName": "10X correo electrónico 4 (distribución de fichas)",
      "getMoreCustomers": "Consiga más clientes",
      "inProgress": "En curso",
      "includedDays": "Días Incluidos",
      "internalSource": "Fuente interna",
      "lastUpdate": "Última actualización",
      "leadValuePlaceholder": "Valor del cliente potencial en $",
      "loopDetected": "Esta campaña ha quedado bloqueada en estado de borrador porque está causando un bucle. Para activar esta campaña, contacta con asistencia.",
      "market": "Mercado",
      "moreDetails": "Más información",
      "myCampaigns": "Mis Campañas",
      "na": "N/A",
      "newFolder": " Nueva carpeta",
      "nextCampaign": "Siguiente campaña",
      "nextExecutionTime": "Siguiente hora de ejecución",
      "opened": "Abierto",
      "openRate": "Tasa de apertura",
      "option2": "Opción 2",
      "option3": "Opción 3",
      "pageNavigation": "Ejemplo de navegación de página",
      "processed": "Procesado",
      "published": "Publicado",
      "recipient": "Destinatario",
      "recipients": "Destinatarios",
      "sampleCampaign": "Campaña de Muestra ",
      "scheduling": "Programación",
      "seeHotLeads": "Ver clientes potenciales calientes",
      "selectDateRange": "Seleccionar intervalo de fechas",
      "selectTimeZone": "Seleccionar zona horaria",
      "separator": " / ",
      "showingCount": "Mostrando {current} de {total}",
      "spamReport": "Informe de Spam",
      "startByAddingEvent": "Empiece añadiendo un evento a esta campaña.",
      "stopOnResponse": "Detener en respuesta",
      "stopped": "Detenido",
      "time": "Hora",
      "timeConditionNote": "Nota: Si el primer paso en las campañas está configurado en \"Inmediatamente\", entonces la condición de tiempo no se aplicaría para ese primer paso.",
      "timeZoneDescription": "Esta configuración afectará la hora en que se enviará su contenido.",
      "totalLeads": "Total de clientes potenciales",
      "undeliverable": "No entregable",
      "unsubscribe": "Cancelar la suscripción",
      "upNext": "A continuación",
      "utc": "UTC",
      "window": "Ventana"
    },
    "embed": {
      "copyLinkInstructions": "Copie el enlace a continuación y compártalo fácilmente donde quiera.",
      "embed": "Insertar",
      "iframeEmbed": "Incrustación de iframe",
      "integrateInstructions": "Use las siguientes opciones para integrar su formulario personalizado en su sitio web",
      "integrateYourForm": "Integre su formulario",
      "link": "Enlace",
      "saveAndExit": "Guardar y salir"
    },
    "jotbox": {
      "deleteSubmission": "Eliminar envío",
      "downloadPdf": "Descargar PDF",
      "ofSubmissions": " de {total} envíos",
      "pages": "páginas",
      "records": "registros",
      "searchPlaceholder": "Buscar por nombre, correo electrónico, teléfono e identificación de contacto",
      "selectYourForm": "Seleccione su formulario",
      "timeSigned": "Hora de firma:",
      "totals": "Totales:"
    },
    "survey": {
      "createNewSurvey": "Crear nueva encuesta",
      "integrateYourSurvey": "Integre su encuesta",
      "noSurveysForAnalyze": "Todavía no tiene ninguna encuesta. Cree primero una encuesta para poder analizarla aquí.",
      "noSurveysForSubmission": "Todavía no tiene ninguna encuesta. Por favor, genere una encuesta para ver el Envío aquí.",
      "noSurveysYet": "Todavía no tiene ninguna encuesta.",
      "refreshData": "Actualizar datos",
      "searchSurveys": "Buscar encuestas",
      "surveyBuilder": "Creador de encuestas",
      "toCreateFirstSurvey": "para crear tu primera encuesta."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "¡Producto clonado! Cambie a una cuenta donde fue clonado y búscalo en la pestaña de Suscripción > Productos.",
      "errorGettingDetails": "Parece que ha habido un error al obtener los detalles del producto. Compruebe la URL o inténtelo de nuevo."
    },
    "resetPassword": {
      "title": "Restablecer la contraseña",
      "button": "Restablecer la contraseña",
      "newPassword": "Nueva contraseña",
      "generateStrongPassword": "Generar una password segura",
      "sendEmailNotification": "Además, recibir una notificación automática por email.",
      "errorMessage": "Se ha producido un error al restablecer la contraseña. Inténtelo de nuevo.",
      "updating": "Actualizando..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ por",
      "combo": {
        "signedUp": "inscritos en ProveSource en las últimas 24 horas",
        "verifiedBy": "verificado Vía "
      },
      "conversions": {
        "recentlyBought": "recientemente se ha comprado esto",
        "timeAgo": "en los últimos 16 minutos ",
        "visitorsCount": "50 visitantes"
      },
      "pageVisits": {
        "description": "parecen tener hambre, también.",
        "timeAgo": "en los últimos 21 minutos                        ",
        "title": "50 amantes de la comida"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessage",
        "rating": "Valoración de 5 estrellas",
        "recently": "Recientemente",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "inscrito en ProveSource",
        "location": "(London, Reino Unido)",
        "name": "Mike ",
        "timeAgo": "Hace 40 minutos                        "
      },
      "visitors": {
        "description": "amantes de la música en línea"
      }
    },
    "step1": {
      "combo": {
        "description": "Muestra el número total de personas que han efectuado una acción concreta durante 24 horas, 7 o 30 días.",
        "title": "Combo"
      },
      "conversions": {
        "description": "Genere validación social vía la visualización de cuántos clientes realizaron una acción específica."
      },
      "liveReviews": {
        "description": "Muestre a sus visitantes reseñas en tiempo real de cuatro o más estrellas de los últimos seis meses."
      },
      "liveVisitors": {
        "beta": "Beta",
        "description": "Muestra cuántos visitantes están viendo actualmente su sitio completo en tiempo real."
      },
      "pageVisits": {
        "description": "Demuestra a tus visitantes que no están solos destacando las visitas recientes a la página."
      },
      "stream": {
        "description": "¿Qué hay mejor que poner cara en esa prueba social? Mostrar a sus clientes recientes y sus acciones."
      }
    },
    "step2": {
      "captureDescription2": "Cada URL de página debe tener un campo de formulario de correo electrónico",
      "captureDescription3": " y ProveSource instalado. ",
      "comboType": "Tipo de combo",
      "connectAccounts": "Asegúrese de conectar las cuentas de las que desea obtener opiniones",
      "connectGoogleAccount": "Conecte la cuenta de Google de su ubicación",
      "formSubmissions": "Envíos de formularios",
      "googleAccount": "Cuenta de Google",
      "howToTrack": "Cómo hacer un seguimiento",
      "howToTrackDescription": "¿Cómo deberíamos rastrear sus conversiones?",
      "pageUrl": "URL de la página",
      "productPurchase": "Compra de productos",
      "trackAllUrls": "Hacer un seguimiento de todas las direcciones URL de páginas que contengan la siguiente expresión. ",
      "trackVisitors": "Rastrear Visitantes",
      "trackVisits": "Rastrear Visitas",
      "urlTip": " Tratamos http://, https://, la versión con www y la versión sin www como páginas diferentes. ",
      "urlValidationError": "Debe añadir al menos una URL. La URL no es válida. Asegúrese de Incluir http:// o https://",
      "userSignup": "Registro de usuarios",
      "visits": " Visitas",
      "webhookDescription": "Llame al siguiente punto final para informarnos de un evento o conversión que haya ocurrido en su lado y que esté relacionado con esta notificación, nosotros haremos el resto.",
      "webhookRequest": "Solicitud de Webhook",
      "whatToTrack": "¿Qué le gustaría rastrear?",
      "whereToCapture": "Dónde capturar",
      "whereToCaptureDescription": "¿Dónde captura las conversiones?",
      "whichPagesToTrack": "¿Qué páginas desea que rastreemos?",
      "yourWebhookUrl": "Su URL de Webhook"
    },
    "step3": {
      "allPages": " Todas las páginas",
      "displayOnAllPages": "Mostrar en todas las páginas URL que contengan la siguiente expresión: ",
      "whereToDisplay": "Dónde Mostrar",
      "whereToDisplayActivity": "¿Dónde desea que mostremos esta actividad?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "para obtener iconos atractivos (haga clic con el botón derecho en un símbolo -> Copiar dirección de imagen)",
      "messageSettings": "Configuración de mensajes",
      "messageText": "Texto del mensaje",
      "referToVisitorsAs": "Refiérase a los visitantes como",
      "visitIcons8": "Visitar"
    },
    "step5": {
      "allowUsersToClose": " Permitir a los usuarios cerrar la notificación ",
      "behavior": "Comportamiento",
      "bottomLeft": "Parte inferior izquierda",
      "bottomRight": "Parte inferior derecha",
      "clickableNotification": " Notificación automática en la que se puede hacer clic ",
      "customizeDescription": "Cambie la siguiente configuración para controlar el comportamiento y el aspecto de su notificación",
      "design": "Estilo",
      "displayNotificationFor": "Mostrar notificación durante",
      "displayRules": "Reglas de visualización",
      "hideOnMobileScreens": " Ocultar en pantallas móviles ",
      "linkRelativeNote": " Si se omite http://, el enlace se abrirá en relación con la página que se muestra. ",
      "minimumEventsToDisplay": "Mínimo de eventos a mostrar",
      "notificationLink": "Enlace de notificación",
      "notificationPosition": "Posición de notificación",
      "openLinkInNewTab": "Abrir el enlace en una nueva pestaña",
      "selectPosition": "Seleccionar posición",
      "showOnlyOncePerSession": " Mostrar solo una vez por sesión ",
      "titleBackground": "Fondo del título",
      "titleColor": "Color del encabezado",
      "topLeft": "Parte superior izquierda",
      "topRight": "Parte superior derecha",
      "typeUrlHere": "Escriba la URL aquí"
    },
    "step6": {
      "identifyNotification": "Identificar su notificación",
      "launchMessage": "El lanzamiento está a punto, tome asiento y abróchese el cinturón.",
      "notificationName": "Nombre de la notificación automática",
      "notificationNamePrompt": "¿Cuál es el nombre de su notificación?",
      "wellDone": "Bien hecho."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Suscripción creada correctamente",
      "youCanNowSetupWordPress": "Ahora puede configurar su sitio de WordPress",
      "subscriptionFailed": "Error en la suscripción",
      "resubscriptionSuccessful": "Resuscripción completada correctamente",
      "successfullyReactivated": "Su suscripción a WordPress ha sido reactivada con éxito",
      "reactiveSub": "No se ha podido reactivar la suscripción",
      "resubscriptionFailed": "Error de resuscripción"
    },
    "v2": {
      "viewDetails": "Ver detalles",
      "chatConversationAssigned": "Conversación de chat asignada",
      "internalChat": "Chat interno",
      "newTask": "Nueva tarea",
      "appointmentReminder": "Recordatorio de cita",
      "facebookReview": "Reseña de Facebook",
      "googleReview": "Reseña de Google",
      "internalChatMessage": "Mensaje de chat interno",
      "newAppointmentAssigned": "Nueva cita asignada",
      "newAppointmentBooked": "Nueva cita reservada",
      "newCall": "Nueva llamada",
      "newEmail": "Nuevo correo electrónico",
      "newMention": "Nueva mención",
      "newReviewReceived": "Nueva reseña recibida de {contactName}",
      "taskReminder": "Recordatorio de tarea",
      "completed": "completado",
      "failed": "error",
      "subAccount": "Subcuenta",
      "newMessage": "Nuevo mensaje",
      "newAppointmentBookedWith": "Nueva cita programada con {contactName}",
      "newAppointmentAssignedTo": "Nueva cita asignada a {contactName}",
      "appointmentDueIn": "Cita programada para dentro de {minutes} minutos con {contactName}",
      "newTypeReceived": "Nuevo {type} recibido de {contactName}",
      "newChatAssigned": "Nuevo chat asignado de {contactName}",
      "taskDueDate": "La tarea \"{title}\" vence el {date} a las {time} para {contactName}",
      "tasksDueToday": "{count} tareas vencen hoy",
      "tasksOverdue": "{count} tareas atrasadas",
      "taskDueIn": "Tarea «{title}» vence en {dueTime} {unitOfTime} para {contactName}",
      "mentionedInConversation": "{userName} le mencionó en una conversación con {contactName}",
      "now": "ahora"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Logotipo de la empresa"
      },
      "bestExperience": "mejor experiencia.",
      "optimizedFor": "Esta página está optimizada para",
      "portraitMode": "modo retrato",
      "toGiveYou": "para ofrecerle la"
    }
  },
  "pagination": {
    "goToFirstPage": "Vaya a la primera página",
    "goToLastPage": "Vaya a la última página",
    "goToNextPage": "Ir a la página siguiente",
    "goToPreviousPage": "Ir a la página anterior",
    "itemsSelected": "{count} elementos seleccionados",
    "showingEntries": "Mostrando {from} a {to} de {total} entradas"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "Añada un método de pago para",
    "_segment": "/ segmento",
    "ad_manager": "Administrador de anuncios",
    "add": "[AÑADIR:",
    "ai_employee": "AI Employee",
    "billing": {
      "incompleteBillingInfo": "Tiene información de facturación incompleta en esta cuenta. Le rogamos que lo actualice inmediatamente.",
      "updateNow": "Actualizar ahora"
    },
    "charge": "Cargo",
    "contactLimit": {
      "message": "Ha alcanzado el límite de su plan actual para añadir {contact}. Para continuar, actualice su plan y libere capacidad adicional.",
      "upgradeNow": "Actualizar ahora",
      "warningMessage": "Usted tiene {current} contacto(s) mientras que su plan solo permite hasta {limit}.",
      "warningTitle": "El uso de la cuenta ha superado el límite. Actualícelo para seguir trabajando sin interrupciones."
    },
    "cost_borne_by_you": "coste asumido por usted",
    "dedicated_ip": "IP dedicada",
    "electeditem": "Elemento seleccionado",
    "feedback": "Comentarios:",
    "hello": "Hola",
    "helpDrawer": {
      "aiSupportAssistant": "Asistente de AI",
      "clickToCopy": "Haga clic para copiar el número de relación",
      "clickToCopyToClipboard": "Haga clic para copiar el número de relación en el portapapeles",
      "companyRelationshipNumber": "Número de relación de la empresa",
      "hiImHighly": "¡Hola! Soy Highly",
      "implementation": "Implementación",
      "joinImplementationVideo": "Unirse a la llamada de vídeo de implementación",
      "joinTrialZoom": "Unirse a la llamada de prueba de Zoom",
      "kickoff": "inicio",
      "needHelpChatVideo": "¿Necesita ayuda? Inicie ahora un chat o una videollamada con nosotros",
      "openAIAssistant": "Abrir el asistente AI",
      "premium": "Prémium",
      "priority": "Prioridad",
      "raiseSupportTicket": "Abrir una incidencia de asistencia",
      "raiseTicket": "Abrir una incidencia",
      "relationshipNumber": "Número de relación",
      "startAISupportChat": "Iniciar chat de asistencia mediante AI",
      "startAgentChatWait": "Inicie el chat con un agente con un tiempo de espera de 2-5 minutos",
      "startChatChoose": "Iniciar chat: elija entre la asistencia mediante AI o el chat con un agente",
      "startImplementationVideo": "Iniciar la videollamada de implementación",
      "startZoom": "Iniciar Zoom",
      "startZoomCall": "Iniciar llamada con Zoom",
      "subtitle": "Tanto si desea hablar con nosotros, con la comunidad o aprender por su cuenta, ¡tenemos todo lo que necesita!",
      "title": "Ayuda y asistencia",
      "trialExperience": "Experiencia de periodo de prueba",
      "useButtonsBelow": "Utilice cualquiera de los botones a continuación para obtener ayuda.",
      "videoCallReward": "Participe en una videollamada para configurar su cuenta y reciba {amount} en su monedero cuando haya asistido.",
      "videoCallType": "Entre en una videollamada conmigo para su llamada de {type}.",
      "yourPremiumSupportSpecialist": "Su  especialista en asistencia en {type}",
      "yourSpecialist": "Su especialista en {type}",
      "yourSupportSpecialist": "Su especialista en asistencia",
      "videoCall": "Videollamada",
      "active": "Activa",
      "announcementsAria": "Anuncios: haga clic para abrir en una nueva pestaña",
      "chat": "Chatear",
      "accessWelcomeCourseAria": "Haga clic para acceder al Curso de Bienvenida de HighLevel",
      "clickToUpgrade": "Hacer clic para mejorar",
      "connectCertifiedAdminAria": "Conéctese con un administrador certificado, haga clic para abrir en una nueva pestaña",
      "connectWithUsAria": "Conéctese con nosotros: abra un chat en tiempo real",
      "contactUsAria": "Póngase en contacto con nosotros: llame a HighLevel al +1(888)732-4197",
      "copied": "Copiado",
      "highlevelEventsAria": "Eventos de alto nivel: haga clic para abrir en una nueva pestaña",
      "joinFacebookGroupAria": "Únase a nuestro grupo de Facebook: haga clic para abrir en una nueva pestaña",
      "onboardingVideoTutorialsAria": "Tutoriales en vídeo de incorporación: haga clic para abrir en una nueva pestaña",
      "recommended": "Recomendado",
      "visitHelpCenterAria": "Visite nuestro centro de ayuda: haga clic para abrirlo en una nueva pestaña",
      "contactUs": "Póngase en contacto con nosotros",
      "agentChatWaitTime": "Chat con un agente (aprox. 2-5 minutos de espera)",
      "aiSupportChat": "Chat de asistencia por AI",
      "startChat": "Iniciar chat",
      "announcements": "Anuncios",
      "fastestGrowingCommunity": "Forme parte de la comunidad de más rápido crecimiento.",
      "callHighlevelPhone": "Llame a HighLevel al +1(888)732-4197",
      "connectCertifiedAdmin": "Conéctese con un administrador certificado",
      "connectTeamVideoCall": "Conéctese con nuestro equipo para obtener ayuda a través de una videollamada en directo.",
      "connectWithUs": "Conéctese con nosotros",
      "dailyBrainstormingSessions": "Sesiones diarias de lluvia de ideas con HighLevel",
      "certifiedAdminDescription": "Explore a los expertos de HighLevel que pueden ayudarle a configurar su sistema, automatizar flujos de trabajo o personalizar su proyecto.",
      "getAccessWelcomeCourse": "Obtener acceso al Curso de Bienvenida de HighLevel",
      "premiumSupportDescription": "Obtenga asistencia prioritaria para la resolución de problemas, asesoramiento de expertos y acceso directo a nuestro equipo técnico a través de Slack.",
      "highlevelEvents": "Eventos de HighLevel",
      "joinFacebookGroup": "Únase a nuestro grupo de Facebook",
      "onboardingVideoTutorials": "Tutoriales de vídeo de incorporación",
      "premiumSupport": "Asistencia prémium",
      "setupAccountFreeTutorials": "Configure su cuenta, con tutoriales gratuitos",
      "viewSupportTicketsArticles": "Consulte sus incidencias de asistencia, nuestros artículos de asistencia y las preguntas frecuentes de gran utilidad.",
      "visitHelpCenter": "Visite nuestro centro de ayuda",
      "welcomeCourse": "Curso de bienvenida",
      "beta": "Beta",
      "closeHelpSupportDrawer": "Cerrar el panel Ayuda y asistencia",
      "upgradePlanToEnable": "Necesita actualizar su plan para habilitar esta función",
      "premiumSupportActive": "La asistencia prémium está activa",
      "premiumSupportClickUpgrade": "Soporte Premium - Haga clic para actualizar su plan",
      "premiumSupportActiveAria": "Soporte Premium - Su soporte premium está activo",
      "keepUpToDateNews": "Manténgase al día de las últimas noticias y lanzamientos."
    },
    "hi": "Hola",
    "is_scheduled_for_deletion_on": "está programado para su eliminación el",
    "k": "K",
    "limit_updated_from": "límite actualizado desde",
    "minimum_must_be": "El mínimo debe ser",
    "more_emails_in_thread": "más correos electrónicos en el hilo",
    "multipleUsers": {
      "chooseAccount": "Elija una cuenta para continuar"
    },
    "must_be_in_range_of_0": "Debe estar en el intervalo de 0-",
    "numbers_and": "número(s) y",
    "premiumSupport": {
      "assigningManager": "Asignando un gestor técnico de cuentas...",
      "bookCall": "Reservar una llamada",
      "hiIm": "Hola, soy {name}",
      "joinZoomNow": "Únase ahora a la llamada de Zoom",
      "quickActions": "Acciones rápidas de asistencia",
      "quickLinks": "Enlaces rápidos",
      "raiseFeatureRequest": "Abrir una solicitud de función",
      "slackChannelCreating": "Agárrese fuerte: ¡su canal prémium de Slack se está poniendo en marcha! 🚀",
      "technicalAccountManager": "Gestor técnico de cuentas",
      "viewRoadmap": "Ver la hoja de ruta del producto"
    },
    "prospecting": "Prospección",
    "reloadPopup": {
      "message": "Hemos observado que hace tiempo que no refresca la página. Vuelva a cargarla para disfrutar al máximo de la aplicación.",
      "refreshNow": "Actualice ahora"
    },
    "resell_settings": "Configuración de reventa",
    "row": "fila",
    "select_upto": "Seleccione hasta",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Obtenga una asistencia dedicada garantizada en el momento que más le convenga.",
      "title": "Programe una llamada con el servicio de asistencia de HighLevel"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Son márgenes que se facturan a sus clientes sobre el",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Permítanos gestionar Twilio por usted y olvídese de las complicaciones",
        "benefit2": "Nuestro equipo de asistencia se ocupará de sus problemas con Twilio",
        "button": "Hágalo por mí",
        "drawback": "Pague {price} más por el SVA en comparación con hacerlo usted mismo",
        "title": "Lo haremos por usted"
      },
      "lowCreditsMessage": "Necesita conectarse una cuenta Twilio para gestionar las llamadas y los mensajes de texto que se envían y reciben en HighLevel.",
      "lowCreditsTitle": "Le quedan pocos créditos Twilio gratuitos, pero ¡no se preocupe!",
      "selfSetup": {
        "benefit1": "Gestione sus gastos",
        "benefit2": "Tenga más control sobre su servicio de Twilio",
        "button": "Lo gestionaré yo",
        "drawback1": "Contrate a alguien para gestionar el servicio de Twilio",
        "drawback2": "Póngase en contacto con el servicio de asistencia de Twilio cuando algo no funcione.",
        "title": "Hágalo usted mismo"
      },
      "wip": {
        "button": "Configurar Twilio ahora",
        "fallback": "Por el momento, tendrá que gestionar su cuenta de Twilio por su cuenta.",
        "message": "Gracias por elegirnos. Seguimos trabajando para desarrollar esta función. Tendrá noticias nuestras en cuanto podamos ponerlo en marcha para su cuenta.",
        "title": "Seguimos trabajando en ello."
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Cargando más opciones...",
      "noElementsFound": "¡Vaya! No se han encontrado elementos. Considere cambiar la consulta de búsqueda.",
      "noLocationsFound": "No se han encontrado ubicaciones. Pruebe con otra búsqueda.",
      "typeToSearch": "Escribir para buscar",
      "enterUserEmail": "Introduzca el correo electrónico del usuario"
    },
    "updating": "Actualizando",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Utilizar plantilla"
    },
    "validEmail": {
      "andYouCan": "Y usted puede",
      "as": "como",
      "canReverify": "Usted puede reverificar su correo electrónico",
      "emailIs": "Este correo electrónico es",
      "emailMarkedAs": "Este correo electrónico marcado como",
      "markedAsInvalid": "Este correo electrónico está marcado como",
      "notVerified": "No verificado",
      "reverifyHere": "Vuelva a verificar aquí",
      "verifyHere": "Verificar aquí"
    },
    "will_give_you_about": "obtendrá aproximadamente",
    "checkout": {
      "confirm": "Confirmar",
      "cardInformation": "Información de la tarjeta",
      "cardNumberInvalid": "El número de su tarjeta no es válido.",
      "commitment": "compromiso",
      "paymentConsent": "Al confirmar, usted permite que LeadConnector cargue el importe de este pago a su tarjeta.",
      "subscriptionConsent": "Al confirmar su suscripción, permite que LeadConnector cargue a su tarjeta este pago y los pagos futuros de esta suscripción",
      "endingIn": "termina en",
      "month": "mes",
      "pay": "Pagar",
      "payWithCard": "pagar con tarjeta",
      "paymentBeingProcessed": "El pago se está procesando. No actualice la página ni pulse el botón Atrás",
      "proceedWithExistingCard": "Continuar con la tarjeta actual",
      "proceedWithNewCard": "Continuar con una nueva tarjeta",
      "purchase": "comprar",
      "subscribe": "Suscribirse",
      "subscribeTo": "Suscribirse a",
      "pleaseUpdateCardDetails": "Actualice los detalles de la tarjeta",
      "zip": "código postal",
      "retry": "reintentar",
      "initialChargesProrated": "Los cargos iniciales se prorratean y la facturación regular comenzará a partir del",
      "youWillBeChargedFor": "Se le cobrará por",
      "days": "días",
      "rightNowForPeriodTill": "ahora mismo para el período hasta",
      "startGettingChargedFullAmount": "y empezar a que se le cobre el importe total",
      "perMonthStartingFrom": "/mes desde",
      "nameOnCard": "Nombre en la tarjeta",
      "somethingWentWrong": "Algo ha ido mal",
      "errorImg": "error de imagen",
      "networkError": "Error de red, vuelva a intentarlo pasado un tiempo",
      "paymentCouldNotBeProcessed": "No se ha podido procesar el pago. Intente añadir una tarjeta de nuevo."
    },
    "deleteLocation": {
      "back": "Atrás",
      "delete": "Eliminar",
      "completeStepsToDelete": "Debe seguir unos sencillos pasos antes de eliminar esta ubicación",
      "alsoCloseAssociated": "También estrechamente asociado",
      "scheduling": "Programando...",
      "subAccountAndDeletePhoneNumbers": "subcuenta y eliminar todos los números de teléfono",
      "somethingWentWrongTryAgain": "Algo ha ido mal… Inténtelo de nuevo pasado un tiempo",
      "deleteSubAccount": "Eliminar subcuenta",
      "scheduleForDeletion": "Programar para eliminación"
    },
    "productRebilling": {
      "enableRebilling": "Habilitar la refacturación",
      "ratesMayDifferUK": "Las tarifas pueden diferir según la región. Los cálculos mostrados son por las tarifas para el Reino Unido,",
      "examplePricingGpt4oMini": "Ejemplo de precios: GPT-4o Mini",
      "input": "Entrada",
      "output": "Salida",
      "supportDoc": "documento justificante",
      "unsavedChanges": "Cambios no guardados",
      "to": "a",
      "chargedToCustomerLower": "Cobrado al cliente",
      "model": "Modelo",
      "profit": "Beneficio",
      "saving": "Guardando…",
      "type": "Tipo",
      "updating": "Actualizando…",
      "clickHere": "Haz clic aquí",
      "chargedToCustomer": "Cobrado al cliente",
      "enabling": "Habilitando...",
      "forMoreDetails": "para obtener más información.",
      "tenDollarsWillGive": "Con 10 dólares obtendrá unos",
      "yourCost": "Su coste",
      "seeHow": "Descubra cómo",
      "clientCompanyBillingPage": "página de facturación de la empresa del cliente",
      "connectStripeToEnable": "Para activar la refacturación, debe conectar su cuenta de Stripe en",
      "companyStripeIntegrationPage": "página de integración de Stripe con la empresa",
      "enterClientCardInfo": "Para activar la refacturación, debe introducir la información de la tarjeta de su cliente en",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(para 750 000 palabras)",
      "words": "palabras",
      "yourCostLower": "Su coste",
      "and": "y",
      "or": "o",
      "minimumMustBeBetween": "El mínimo debe estar entre",
      "upgradeToAgencyPro": "actualizar a Agency Pro",
      "planToSetMargins": "planificar para establecer márgenes"
    },
    "m": "m",
    "label": "Etiqueta",
    "company_email_": "Correo electrónico de la empresa (",
    "me_": "Yo (",
    "automation_type": "Tipo de automatización",
    "calendar_groups": "Grupos de calendarios",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "No hay productos disponibles",
    "selectProduct": "Seleccionar un producto"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Los mensajes adicionales de {product} no se cobrarán a las ubicaciones. Para refacturar al cliente, habilite el modo SaaS y la refacturación.",
      "agreementPrefix": "Acepto habilitar",
      "agreementSuffix": "para este cliente sin reventa y entiendo que se me cobrará",
      "buildResellerOffer": "Cree su oferta de reventa",
      "deployDirectlyDescription": "Utilice esta opción si ofrece {product} como parte de su oferta o si desea facturar a su cliente externamente",
      "deployPrefix": "Implementar",
      "directlySuffix": "Directamente",
      "learnMore": "Más información.",
      "offerPrefix": "Oferta",
      "resellPrefix": "Revender",
      "resellingPrefix": "Reventa",
      "subscriptionRestriction": "No se puede cambiar la configuración porque la ubicación ya está suscrita",
      "zero": "0",
      "highlevelPrice": "Precio de HighLevel",
      "howDoesItWork": "¿Cómo funciona?",
      "payNowButton": "Pagar ahora",
      "priceValidationError": "El precio debe ser mayor o igual al precio de HighLevel",
      "saving": "Guardando",
      "yourPrice": "Su precio",
      "yourProfit": "Su beneficio"
    },
    "whatsapp": {
      "inboundMessagesInfo": "La recepción de mensajes entrantes y la respuesta a los mismos mediante un texto libre en la ventana de conversación son gratuitas. En caso de que se envíen mensajes de plantilla salientes, se cobrarán gastos adicionales.",
      "whatsappLocation": "Ubicación de WhatsApp"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "No se puede cambiar la configuración porque la ubicación ya está suscrita",
        "offerPrefix": "Oferta ",
        "poweredByPrefix": " (Con la tecnología de Search Atlas)",
        "toggleTooltipDisable": "Esta acción desactivará la herramienta SEO para todas las subcuentas.",
        "toggleTooltipEnable": "Esta acción habilitará la herramienta SEO para todas las subcuentas.",
        "resellPrefix": "Revender ",
        "howDoesItWork": "¿Cómo funciona?",
        "buildResellerOffer": "Cree su oferta de reventa",
        "yourPrice": "Su precio",
        "highlevelPrice": "Precio de HighLevel",
        "yourProfit": "Su beneficio",
        "priceValidationError": "El precio debe ser mayor o igual al precio de HighLevel",
        "saving": "Guardando",
        "save": "Guardar",
        "deployPrefix": "Implementar ",
        "directlySuffix": "Directamente",
        "deployDirectlyDescription": "Utilice esta opción si ofrece SEO como parte de su oferta o si desea facturar a su cliente externamente",
        "agreementPrefix": "Acepto habilitar ",
        "agreementSuffix": " para este cliente sin reventa y entiendo que se me cobrará",
        "payNowButton": "Pagar ahora",
        "subscriptionCreating": "La suscripción se está creando.<br/>No actualice la página ni pulse el botón Atrás",
        "subscriptionCreated": "Suscripción creada correctamente. Espere...",
        "subscriptionError": "No se ha podido crear la suscripción. Póngase en contacto con el servicio de asistencia"
      },
      "adManager": {
        "subscriptionRestriction": "No se puede cambiar la configuración porque la ubicación ya está suscrita",
        "offerPrefix": "Oferta ",
        "resellingPrefix": "Reventa",
        "resellPrefix": "Revender ",
        "howDoesItWork": "¿Cómo funciona?",
        "bookACall": "Reservar una llamada",
        "bookCallTooltip": "Reserve una llamada con nuestro equipo para obtener más información sobre Ad Manager",
        "buildResellerOffer": "Cree su oferta de reventa",
        "yourPrice": "Su precio",
        "highlevelPrice": "Precio de HighLevel",
        "yourProfit": "Su beneficio",
        "priceValidationError": "El precio debe ser mayor o igual al precio de HighLevel",
        "loading": "Cargando...",
        "save": "Guardar",
        "deployPrefix": "Implementar ",
        "directlySuffix": "Directamente",
        "deployDirectlyDescription": "Utilice esta opción si ofrece Ad Manager como parte de su oferta o si desea facturar a su cliente externamente",
        "agreementPrefix": "Acepto habilitar ",
        "agreementMiddle": " para este cliente sin reventa y entiendo que se me cobrará",
        "agreementSuffix": " por mes",
        "stripeNotConnectedLocationWarning": "Stripe no está conectado para esta ubicación. Por favor, conecte Stripe para habilitar esta función.",
        "stripeNotConnectedAgencyWarning": "Stripe no está conectado para esta agencia. Conecte Stripe para habilitar esta función.",
        "underSubAccountReselling": "mensualmente bajo la reventa de subcuentas"
      },
      "dedicatedIp": {
        "description": "Esto le permite volver a facturar la IP dedicada (utilizada para el envío de correo electrónico saliente) a sus clientes e incluir un recargo",
        "numberOfIps": "N.º de IP:",
        "yourCost": "Su coste:",
        "chargedToCustomer": "Cobrado al cliente:",
        "profit": "Ganancia:",
        "monthlyProfit": "Beneficio mensual:",
        "loading": "Cargando...",
        "save": "Guardar",
        "revokeDedication": "Revocar dedicación",
        "revokeDescription": "Utilice esta opción para dejar de ofrecer nuevas IP dedicadas a su cliente sin cobrarles.",
        "existingSubscriptionsNote": "Las suscripciones IP actuales no se verán afectadas",
        "revoke": "Revocar",
        "provideDirectlyTitle": "Proporcionar una IP dedicada para el correo electrónico directamente",
        "provideDirectlyDescription": "Utilice esta opción para proporcionar una IP dedicada a su cliente sin cobrarle",
        "agreeToProvideText": "Acepto proporcionar la IP para este cliente sin ventas adicionales",
        "acknowledgeChargeText": "Entiendo que se me cobrarán 59 $ al mes por cada IP",
        "agree": "Aceptar",
        "yourMonthlyCost": "Su coste de IP mensual:",
        "monthlyChargeToCustomer": "Cargo mensual al cliente:",
        "resellingSettingsSuffix": " Configuración de reventa",
        "ipRebillingAmount": "Cantidad de refacturación IP"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Confirmo que he hablado con mi cliente y que cuento con su aprobación",
        "confirmQuestion": "¿Seguro que desea desactivar el modo SaaS para esta cuenta?",
        "dataLossAck": "Entiendo que se perderán todos los datos de refacturación, los datos de suscripción a SaaS y el libro mayor de transacciones",
        "disableSaas": "Deshabilitar SaaS",
        "irreversibleAck": "Entiendo que esta acción es irreversible"
      },
      "confirmationModal": {
        "cancelSubscription": "Cancelar también la suscripción SaaS asociada",
        "confirmDisable": "Confirme la desactivación",
        "confirmQuestion": "¿Seguro que desea desactivar el modo SaaS?",
        "somethingWentWrong": "Algo ha ido mal… Inténtelo de nuevo pasado un tiempo"
      },
      "processingModal": {
        "closeNow": "Cerrar ahora",
        "closeWindowInstructions": "Puede cerrar esta ventana, le informaremos por correo electrónico una vez que el proceso haya finalizado",
        "title": "SaaS se deshabilitará en breve para esta ubicación.",
        "typicalTime": "Esto suele tardar 10 minutos o menos."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Añadir campo personalizado",
      "fieldKey": "Clave de campo",
      "fieldName": "Nombre del campo",
      "idWillBeAdded": "El id se añadirá después de crear el motivo de la pérdida",
      "lostReasonID": "Id de razón de abandono",
      "placeholder": "Marcador de posición"
    },
    "locationMailGun": {
      "bccAddress": "Dirección BCC",
      "clearError": "Borrar error",
      "deleteConfirmationMessage": "Esta acción eliminará la conexión a Mailgun.",
      "deleteConnection": "Eliminar conexión",
      "domain": "Dominio",
      "domainsAvailable": "{count} disponible",
      "invalidApiKey": "Clave API no válida",
      "selectDomain": "Seleccionar dominio"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Error al obtener los detalles de la transacción",
      "transactions": "Transacciones"
    },
    "noShowSMS": {
      "smsWithImage": "SMS de No asistido con imagen",
      "title": "Personalizar SMS de Reseña"
    },
    "optOut": {
      "addKeywords": "Añada una de las siguientes palabras clave de exclusión: DETENER, DETENER TODO, CANCELAR LA SUSCRIPCIÓN, CANCELAR, TERMINAR o ABANDONAR.",
      "customizeTitle": "Personalizar el mensaje de exclusión voluntaria",
      "disableConfirm": "¿Seguro que desea deshabilitar el mensaje de exclusión?",
      "disableOptOut": "Deshabilitar la opción de exclusión voluntaria",
      "disableTitle": "¿Deshabilitar el mensaje de exclusión?",
      "optInConfirmClient": "Confirmo que me aseguraré de que los SMS solo se envíen a los contactos que hayan optado por recibirlos.",
      "quickTipMessage": "El mensaje inicial que envíe a una persona debe incluir una de las siguientes palabras clave estándar de exclusión: DETENER, DETENER TODO, CANCELAR LA SUSCRIPCIÓN, CANCELAR, TERMINAR o ABANDONAR.",
      "reallyDisableConfirm": "¿Seguro que desea deshabilitar el mensaje de exclusión?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Cuerpo de la solicitud PUBLICACIÓN",
        "requestQueryParameters": "Solicitud de parámetros de consulta",
        "responseBody": "Cuerpo de respuesta"
      },
      "logs": "Registros",
      "logsPage": {
        "clearAll": "Borrar todo",
        "loadMore": "Cargar más",
        "price": "Precio",
        "product": "Producto",
        "tabsAriaLabel": "Pestañas de registros de pagos"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Añadir texto general en el",
      "beginning": "Inicio",
      "complianceConfirm": "Confirmo que me aseguraré de que todos los mensajes SMS enviados desde esta cuenta cumplan con la política actual",
      "customizeTitle": "Personalizar el texto general",
      "disableConfirm": "¿Seguro que desea deshabilitar el ID de remitente?",
      "disableSenderID": "Deshabilitar SenderID",
      "disableTitle": "¿Deshabilitar SenderID?",
      "end": "Finalizar",
      "pleaseAdd": "Incluya {text} como se menciona in el consejo rápido.",
      "quickTipMessage": "El mensaje inicial que envíe a una persona debe incluir la información de identificación del remitente. Incluya {text} en el cuadro de texto general.",
      "reallyDisableConfirm": "¿Seguro de que desea deshabilitar el id. del remitente?",
      "senderID": "Id. del remitente"
    },
    "shopify": {
      "adminApiAccessToken": "Token de acceso a la API de administrador",
      "apiTokenRequired": "Se requiere un token de acceso a la API",
      "checkDocumentation": "Consulte esta documentación para obtener más información",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Token de acceso personalizado a la API de aplicaciones",
      "deleteWarning": "Al eliminarla, se eliminará la conexión existente.",
      "existStoreAlertTitle": "La integración de la tienda Shopify ya existe",
      "integration": "Integración de Shopify",
      "integrationHealth": "Estado de la integración",
      "orders": "Pedidos",
      "scopePermissionsWarning": "Asegúrese de que a su aplicación se le hayan concedido los permisos que están marcados con una cruz roja",
      "scopes": "Ámbitos",
      "scopesDescription": "Se requieren ámbitos de autorización para acceder a la información de Shopify. Debido a los recientes cambios en Shopify, ahora read_customers se requiere para obtener toda la información de los clientes debido a los datos de clientes protegidos por Shopify.",
      "storeConnectedMessage": "Esta tienda de Shopify ya está conectada a la subcuenta {locationName}",
      "storeNameHelp": "El nombre de su tienda se encuentra en la URL de su cuenta de Shopify, después de https:// y antes de .myShopify.",
      "storeNameLabel": "Nombre de su tienda de Shopify",
      "storeNamePlaceholder": "nombre de la tienda",
      "storeNameRequired": "El nombre de la tienda es obligatorio",
      "typeRemoveConfirm": "Escriba «REMOVE» para confirmar",
      "webhooks": "Webhooks",
      "webhooksDescription": "Para recibir todos los eventos de Shopify, debemos registrar estos webhooks de Shopify durante el proceso de integración. Estos webhooks son esenciales para garantizar el correcto funcionamiento de las funciones de Shopify."
    },
    "slack": {
      "accountConnected": "cuenta conectada",
      "accountsConnected": "cuentas conectadas",
      "accountsList": "Lista de todas las cuentas de Slack",
      "added": "Añadido {date}",
      "connectChannel": "Conecte su canal de Slack",
      "description": "Reciba notificaciones instantáneas en su canal de Slack. Haga clic en «Conectar» para añadir un canal de Slack",
      "manage": "Gestionar",
      "manageAccounts": "Gestionar cuentas de Slack",
      "noIntegrations": "No se encontraron integraciones de Slack."
    },
    "smtpService": {
      "addFirstService": "Añada su primer servicio SMTP.",
      "addService": "Añadir servicio",
      "bccEmails": "Correos electrónicos BCC",
      "cannotDeleteDefaultProvider": "No puede borrar el proveedor por defecto.",
      "contactDeveloper": "Póngase en contacto con el desarrollador de esta aplicación.",
      "customProvider": "Proveedor personalizado",
      "defaultProvider": "Proveedor por defecto",
      "defaultProviderUpdated": "El proveedor predeterminado se ha actualizado correctamente.",
      "emailDomain": "Correo electrónico / dominio",
      "emailService": "Servicio de correo electrónico",
      "enableReplyTracking": "Habilitar el seguimiento de respuestas",
      "forwardToAssignedUser": "Reenviar al usuario asignado",
      "providerType": "Tipo de Proveedor",
      "smtpConnectionIssue": "Hay un problema con esta conexión smtp. Vuelva a conectar esta integración.",
      "useLcEmailMessage": "Utilice LeadConnector Email System para enviar correos electrónicos a su agencia y sus clientes."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Publicación automática habilitada",
      "dailyPostLimit": "Límite diario de publicaciones",
      "directoriesDescription": "Cuando obtenga una nueva reseña, la publicaremos automáticamente en más de 80 directorios en línea que le ayudarán automáticamente a hacer crecer su marca y su SEO.",
      "directoriesTitle": "80+ directorios y sitios web",
      "fivePosts": "5 publicaciones",
      "fiveStars": "5 estrellas",
      "fourPosts": "4 publicaciones",
      "fourStars": "4 estrellas",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Personalice cómo y cuándo sus reseñas se publican automáticamente en cada una de sus redes sociales.",
      "manageSettingsTitle": "Gestione su configuración de publicación en redes sociales",
      "postReviewsForRating": "Publique reseñas con esta valoración con estrellas o superior.",
      "searchEngines": "Motores de búsqueda",
      "threePosts": "3 publicaciones",
      "threeStars": "3 estrellas",
      "title": "Publicación en redes sociales"
    },
    "tags": {
      "addNewTag": "Añadir nueva etiqueta",
      "allTags": "Todas las etiquetas",
      "deletedTags": "Etiquetas eliminadas",
      "here": "aquí.",
      "newTag": "Nueva etiqueta",
      "noTagsYet": "Aún no hay etiquetas que mostrar",
      "searchTags": "Buscar etiquetas",
      "viewDeletedTags": "Puedes ver y restaurar las etiquetas eliminadas en la página de registros de auditoría"
    },
    "templateMessage": {
      "addEmailTemplate": "Añadir plantilla de correo electrónico (fragmento)",
      "addTemplate": "Añadir plantilla (fragmento)",
      "addTextTemplate": "Añadir plantilla de texto (fragmento)",
      "body": "Cuerpo",
      "deleteTemplateConfirmation": "¿Seguro que desea eliminar esta plantilla?",
      "templatesCount": "{count} plantillas",
      "title": "Plantillas de mensajes (fragmentos)"
    },
    "unsubscribe": {
      "content": "Contenido",
      "contentTooltip": "El contenido de este mensaje se añadirá automáticamente a todos los correos electrónicos.",
      "customizeTitle": "Personalizar el contenido de cancelación de la suscripción",
      "disableConfirm": "¿Seguro que desea deshabilitar el enlace para cancelar la suscripción del correo electrónico?",
      "disableTitle": "¿Deshabilitar el enlace para cancelar la suscripción?",
      "disableUnsubscribe": "Deshabilitar la cancelación de la suscripción",
      "pleaseAddTag": "Añada la etiqueta /*cancelar la suscripción*/",
      "reallyDisableConfirm": "¿Seguro que desea deshabilitar el enlace para cancelar la suscripción del correo electrónico?",
      "subscribedConfirm": "Confirmo que el correo electrónico solo se enviará a los contactos que se hayan suscrito para recibirlo.",
      "subscribedConfirmClient": "Confirmo que me aseguraré de que el correo electrónico solo se envíe a los contactos que se hayan suscrito para recibirlo.",
      "suspensionWarning": "La actividad no conforme puede dar lugar a la suspensión de las funciones de correo electrónico de su cuenta.",
      "tagRequirement": "El correo electrónico inicial que envíe a una persona debe incluir la etiqueta /*cancelar la suscripción*/"
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Este es el mensaje de buzón de voz predeterminado para todos los números de Twilio en la ubicación, a menos que se personalice bajo",
      "forwardCallsToWebApp": "Redirija las llamadas a la aplicación web",
      "forwardCallsToMobileApp": "Redirija las llamadas a la aplicación móvil",
      "dedicatedNumberRequiredInfo": "Esto solo es obligatorio si los usuarios necesitan un número dedicado. No es obligatorio para el buzón de voz ni para enrutar la llamada al usuario asignado.",
      "voicemailMessageInfo": "Este mensaje del buzón de voz se reproducirá en lugar del mensaje del operador telefónico. Recomendamos un límite de tiempo de 20 segundos o menos.",
      "noTimeout": "Sin interrupción",
      "10Secs": "10 s",
      "20Secs": "20 s",
      "voicemailMessageDuration": " Registraremos un mensaje de voz si no se responde a la llamada antes de este tiempo",
      "saveCallSettings": "Guardar la configuración de llamadas"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Cuando esta etiqueta esté presente en el contacto, esos mensajes NO se entregarán a Eliza",
      "sendToElizaNote": "De forma predeterminada, todas las conversaciones se entregarán a Eliza. Si esta etiqueta está configurada, <br />entonces las nuevas conversaciones se enviarán a Eliza solo cuando esta etiqueta esté presente en un contacto.<br /> Si se configuran tanto la etiqueta de omisión de Eliza como la etiqueta Enviar a Eliza, solo se respetará la etiqueta Enviar a Eliza",
      "permissionNote": "Sus permisos de usuario no están habilitados para esta página. <br />Por favor, hable con su administrador",
      "addFAQ": "Añadir FAQ"
    },
    "locationSettings": {
      "ownCardWarning": "¡No añada su propia tarjeta a las subcuentas!",
      "addClientCardWarning": "Añada la tarjeta de su cliente (la de la subcuenta) y no la suya propia, ya que esta tarjeta se utilizará para facturar a su cliente en su nombre.",
      "stripeConnectMissing": "Falta Stripe Connect",
      "pleaseContactAgencyToAddPaymentMethods": "Por favor, póngase en contacto con la agencia ({email}) para añadir métodos de pago"
    },
    "integrations": {
      "connectWaveAccount": "Conecte la cuenta de Wave de su ubicación",
      "connectXeroAccount": "Conecte la cuenta Xero de su ubicación"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "El seguimiento de llamadas de GBP está habilitado en otra subcuenta. El seguimiento de llamadas puede habilitarse en una única subcuenta a la vez.",
      "gbpCallTrackingEnabledOnAnotherPage": "El seguimiento de llamadas GBP está habilitado en otra página ({pageName}). El seguimiento de llamadas se puede habilitar en una sola subcuenta y una sola página por ubicación a la vez.",
      "gbpCallsProperlySetup": "Las llamadas de GBP están configuradas correctamente y están entrando desde",
      "tooManyEditsToPrimaryPhone": "Ha realizado demasiadas ediciones en el teléfono principal de esta empresa. Vuelva a intentarlo más tarde.",
      "setupTwilioToStartCallTracking": "Configure Twilio para comenzar el seguimiento de llamadas",
      "twoSecondaryNumbersSetupAlready": "Ya tiene configurados 2 números secundarios, no puede intercambiar números",
      "yourAgentIDIs": "Su ID de agente es"
    },
    "numberPool": {
      "title": "Qué seguir",
      "tracking": {
        "percentComplete": "34 % completado",
        "searchLower": "buscar"
      },
      "create": {
        "title": "Crear número de seguimiento"
      }
    },
    "phoneNumbers": {
      "title": "Qué seguir",
      "tracking": {
        "percentComplete": "34 % completado",
        "heading": "Crear número de seguimiento"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Introduzca un valor",
      "selectOption": "* Seleccione una opción"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Se requiere al menos un {filterName}",
      "select": "Seleccionar {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Marca de tiempo"
    },
    "recordsNav": {
      "clickToReloadList": "Haga clic para recargar la lista"
    },
    "reviewRequestActions": {
      "emailReviewReq": "Solicitud de reseña por correo electrónico",
      "smsReviewReq": "Solicitud de reseña por SMS",
      "whatsappReviewReq": "Solicitud de reseña por WhatsApp"
    },
    "smartListFilters": {
      "clearAllFilters": "Eliminar todos los filtros",
      "noneFound": "ninguno encontrado",
      "saveChangesToList": "Guardar los cambios de filtro en esta lista inteligente",
      "saveCombinationAsNew": "Guardar la combinación de filtros, columnas y ordenación como nueva lista inteligente",
      "saveCurrentAsNew": "Guardar los filtros actuales como una nueva lista inteligente",
      "searchAndAddFilter": "Buscar e añadir un filtro",
      "searching": "buscando…",
      "undoUnsavedChanges": "Deshacer los cambios no guardados"
    },
    "smsStatsPanel": {
      "smsStats": "Estadísticas de SMS"
    },
    "manageDuplicates": "Gestionar duplicados",
    "emailAction": {
      "attachFiles": "Adjuntar archivos",
      "customValues": "Valores personalizados",
      "triggerLinks": "Enlaces de activación"
    },
    "atLeastOneRequired": "* Se requiere al menos un {filterName}",
    "arrayInput": {
      "searchPlaceholder": "Buscar {filterName}",
      "searching": "Buscando…"
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Error al recuperar el contenido de la instantánea",
      "overwriteAll": "Sobrescribir todo",
      "skipAll": "Omitir todo",
      "somethingWentWrongWhileFindingConflicts": "Algo ha ido mal al encontrar conflictos",
      "step": "Paso"
    },
    "confirmOverwrite": {
      "confirmButton": "Confirmar la sobrescritura",
      "description": "Esta acción es irreversible, y puede cambiar configuraciones de campañas, oportunidades, embudos, etc. Confirme su acción escribiendo lo siguiente en la entrada.",
      "title": "¿Seguro que desea sobrescribir los datos seleccionados?"
    },
    "conflicts": {
      "noConflictsDetected": "No se han detectado conflictos",
      "overwrite": "Sobrescribir"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Activos vinculados encontrados",
      "checkingConflicts": "Comprobación de conflictos",
      "chooseSnapshot": "Seleccionar una instantánea",
      "copyingDataNotification": "Copiando los datos en las ubicaciones seleccionadas. Espere...",
      "linkedLocations": "Ubicaciones enlazadas",
      "noConflictsFound": "No se han encontrado conflictos",
      "notAuthorizedMessage": "Solo los administradores de la agencia pueden llevar a cabo esta acción",
      "overwriteConflicts": "Conflictos de sobrescritura",
      "pickSnapshot": "Seleccionar una Instantánea",
      "response": "Responder",
      "selectAssetsToPush": "Seleccione los activos para enviar",
      "selectLocationsToUpdate": "Seleccione ubicaciones para actualizar",
      "snapshotNotAuthorized": "Esta instantánea no está autorizada para esta ubicación",
      "snapshotNotSelected": "Instantánea no seleccionada"
    },
    "share": {
      "agencyRestrictedLink": "Enlace privado de agencia",
      "deleteShareLink": "Borrar enlace para compartir",
      "editShareLink": "Editar enlace para compartir",
      "permanentLink": "Enlace permanente",
      "subaccountRestrictedLink": "Enlace privado de subcuenta"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(añada una coma (<span class='text-base font-bold'> , </span>) después de cada número de relación)",
      "addCommaAfterEachSubAccount": "(añada una coma (<span class='text-base font-bold'> , </span>) después de cada id. de subcuenta)",
      "atLeast1EmailRequired": "Se requiere al menos un correo electrónico.",
      "emailShareLink": "Enlace para compartir por correo electrónico",
      "enterOnePerLine": "(Introduzca uno por línea)",
      "errorGettingLink": "Se ha producido un error al obtener el enlace. Inténtelo de nuevo más tarde.",
      "getAgencyRestrictedLink": "Obtener enlace privado de agencia",
      "getLink": "Obtener enlace",
      "getOneTimeLink": "Obtener enlace para compartir una sola vez",
      "getPermanentLink": "Obtener enlace permanente",
      "getSubAccountRestrictedLink": "Obtener enlace privado de subcuenta",
      "shareType": "Compartir tipo",
      "title": "Compartir instantánea"
    },
    "snapshot": {
      "copySnapshotID": "Copiar id. de instantánea",
      "deleteSnapshot": "Borrar Instantánea",
      "editSnapshot": "Editar instantánea",
      "pushUpdate": "Actualizar a cuentas vinculadas",
      "refreshSnapshot": "Actualizar instantánea"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(añada una coma después de cada número de relación)",
      "addCommaAfterEachSubAccount": "(añada una coma después de cada id. de subcuenta)",
      "title": "Actualizar el enlace de la compartición"
    }
  },
  "socialMedia": {
    "engagement": "Interacciones",
    "potentialReach": "Alcance Potencial",
    "storiesCreated": "Historias creadas",
    "recentPosts": "Publicaciones recientes",
    "notConnected": "No conectado (¡Conéctese ahora!)",
    "totalAudience": "Audiencia Total",
    "activeAudience": "Audiencia activa",
    "socialMediaOverview": "Resumen de redes sociales"
  },
  "suspendModal": {
    "currentStatus": "Estado actual de la suscripción: en pausa",
    "instructions": "Debe completar unos sencillos pasos para {action} esta subcuenta",
    "nextBillingDate": "Siguiente fecha de facturación:",
    "noKeepCharging": "No, seguir cobrando al cliente.",
    "pauseSubscriptionQuestion": "¿Desea pausar también la suscripción con la subcuenta?",
    "resumeSubAccount": "Reanudar subcuenta",
    "resuming": "Reanudando…",
    "saasSubscriptionActive": "Esta subcuenta tiene una suscripción SaaS activa.",
    "saasSubscriptionResumed": "Se reanudará la suscripción a SaaS de esta cuenta.",
    "yesPause": "Sí, pausar la suscripción"
  },
  "table": {
    "perPageOptions": {
      "5": "5 por página",
      "10": "10 por página",
      "15": "15 por página",
      "20": "20 por página",
      "25": "25 por página",
      "50": "50 por página",
      "100": "100 por página"
    },
    "filterPlaceholder": "Buscar...",
    "emptyText": "No se han encontrado registros",
    "loading": "Cargando…",
    "showingEntries": "Mostrando {from} a {to} de {total} entradas",
    "noEntriesToShow": "No hay entradas que mostrar"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Cargando datos de la cuenta…",
      "toContinueWith": "para continuar con"
    },
    "switcherModal": {
      "comingSoon": "¡Próximamente!",
      "multiLocationMessage": "Esta función ahora está disponible solo para cuentas individuales. Estamos trabajando arduamente para implementar esto pronto en las cuentas multiubicación."
    },
    "importedMessage": "¡{productName} importado! Vaya a la biblioteca de plantillas y encuéntrela en la pestaña de {productName}s.",
    "permissionErrorMsg": "Esta opción solo está disponible en planes superiores Actualice ahora para desbloquearlo.",
    "errors": {
      "sourceDeleted": "Error: La plantilla fuente se ha eliminado. Ya no está disponible. Verifique el estado de la plantilla o póngase en contacto con la fuente para obtener ayuda.",
      "sourceDraft": "Error: La plantilla de origen se ha movido a borrador. Verifique el estado de la plantilla o póngase en contacto con la fuente para obtener ayuda.",
      "linkedDeleted": "Error: La plantilla de origen, vinculada a la plantilla compartida, ha sido eliminada. Verifique el estado de la plantilla o póngase en contacto con la fuente para obtener ayuda.",
      "fetchError": "Parece que ha habido un error al obtener los detalles de {productName}. Compruebe la URL o inténtelo de nuevo.",
      "sameAgency": "No se puede compartir la plantilla dentro de la misma agencia"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "La acción de añadir una etiqueta de contacto requiere una etiqueta.",
    "addNotesRequiresData": "La acción de añadir notas requiere datos de notas.",
    "addTaskRequiresFields": "La acción de añadir una tarea requiere un título y un día de vencimiento.",
    "addToCampaignRequiresCampaign": "La acción de añadir a la campaña requiere una campaña.",
    "addToCustomAudienceRequires": "La acción de añadir a la audiencia personalizada requiere una cuenta publicitaria y una audiencia personalizada.",
    "addTrigger": "Añadir activador",
    "anyAction": "Cualquier acción",
    "anyCondition": "Cualquier condición",
    "brokenCustomVariables": "Algunos campos contienen variables personalizadas que no funcionan, corríjalas antes de guardarlas.",
    "conditionCannotBeEmpty": "La condición \"{condition}\" no puede estar vacía",
    "confirmDeleteTrigger": "¿Seguro que desea eliminar este activador?",
    "customDateFieldRequired": "Se requiere un filtro de campo de fecha personalizado para el activador de recordatorio de fecha personalizado",
    "detailPage": {
      "chooseTriggerPlaceholder": "Seleccione un activador",
      "lastUpdate": "Última actualización:",
      "loopIdentifiedWarning": "Este activador ha quedado bloqueado en estado de borrador porque está causando un bucle. Para activar este activador, póngase en contacto con el servicio de asistencia.",
      "ruleNotActiveWarning": "Esta regla no se ejecutará hasta que la active.",
      "triggerCreation": "Creación de activador:",
      "triggerDeletedPrompt": "Este activador se ha eliminado. ¿Desea restaurarlo?",
      "triggerRunDailyTooltip": "El activador se ejecuta a las 8:00 a diario",
      "whatTriggersRule": "¿Qué debería activar esta regla?",
      "whichEventTriggersAutomation": "¿Qué evento debería activar esta automatización?"
    },
    "dndContactRequiresState": "La acción de contactar DND requiere que se configure el estado de DND.",
    "emptyConditionNotAllowed": "La condición no puede estar vacía.",
    "emptyFieldNotAllowed": "No se permite que el campo esté vacío.",
    "executeWebhookRequiresUrl": "La acción de ejecutar el webhook requiere la URL del webhook.",
    "fieldCannotBeEmpty": "{field} no puede estar vacío",
    "fillRequiredFields": "Rellene todos los campos obligatorios de las acciones.",
    "googleAdwordsRequiresConversion": "La acción de añadir a Google Adwords requiere una conversión.",
    "googleAnalyticsRequiresFields": "La acción de añadir a Google Analytics requiere un ID de seguimiento, un tipo de acción y una categoría de acción",
    "membershipGrantOfferRequiresOffer": "La acción de oferta de concesión de suscripción requiere una oferta.",
    "membershipRemoveOfferRequiresOffer": "La acción de oferta de eliminación de suscripción requiere una oferta.",
    "newBasicRule": "Nueva regla básica",
    "opportunitiesRequirePipeline": "Las acciones de oportunidades requieren que elijas una secuencia.",
    "opportunityLoopWarning": "Este activador provocará un bucle de creación de oportunidades. Elimine la opción Permitir la duplicación de oportunidades o cambie la etapa a la que hace referencia.",
    "removeContactTagRequiresTag": "La acción de eliminar la etiqueta de contacto requiere una etiqueta.",
    "removeFromCampaignRequiresCampaign": "La acción de eliminar de la campaña requiere una campaña.",
    "removeFromCustomAudienceRequires": "La acción de eliminar de audiencia personalizada requiere una cuenta publicitaria y una audiencia personalizada.",
    "rulesBasedOn": "reglas basadas en",
    "selectUserForNotification": "Seleccione usuario para enviar notificación.",
    "sendEmailRequiresFields": "La acción de enviar un correo electrónico requiere los campos de, para, asunto y mensaje.",
    "sendNotificationRequiresFields": "La acción de enviar una notificación requiere título, cuerpo y tipo de usuario para enviar notificación.",
    "sendSmsRequiresFields": "La acción de enviar un SMS requiere un número y un mensaje.",
    "stripeMinAmountUSD": "La cantidad debe ser mayor o igual a 50 centavos de USD.",
    "stripeRequiresFields": "La acción de cargo único de Stripe requiere el ID de cliente, cantidad y moneda",
    "thatWillFire": "que activará",
    "triggerCannotBeEmpty": "El activador no puede estar vacío",
    "updateContactFieldRequires": "Actualizar campo de contacto debe tener al menos 1 conjunto de campos."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Pagar ${amount} y suscribirse",
      "commitment": "Sin compromiso, cancele cuando quiera",
      "features": {
        "billedOnUsage": "Se factura en función del uso después de superar el límite",
        "externalAI": "Excluye las acciones externas del modelo AI, que se facturarán por separado",
        "leadingPricing": "¡Precios líderes del sector!",
        "monthlyPurchase": "Válido para una compra al mes",
        "premiumActions": "Se aplica a las acciones y activadores prémium"
      },
      "planDetails": "Detalles del plan",
      "subscribeAndSave": "¡Suscríbase hoy mismo y ahorre!",
      "title": "${amount} por {executions} ejecuciones al mes"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Este ajuste se ha trasladado a la página de calendarios.",
    "toNavigate": "aquí para navegar. Esta página se eliminará pronto."
  },
  "attribution": {
    "description": "La primera interacción es simplemente el primer punto de contacto que hace un usuario. Así que si alguien le descubre por primera vez mediante un anuncio de búsqueda de pago (PPC), ese canal recibirá el crédito cuando se trate de una conversión. Por otro lado, la última interacción sería el último canal.",
    "firstInteraction": "Primera interacción",
    "lastInteraction": "Última interacción",
    "title": "Atribución"
  },
  "campaign": {
    "addEvent": "Añadir evento",
    "a2p": {
      "address": {
        "chooseState": "Seleccione una región/provincia/estado…",
        "city": "Ciudad*",
        "postalCode": "Código postal*",
        "streetAddress": "Dirección postal*",
        "streetAddressHelper": "Debe ser una dirección válida vinculada a su empresa.",
        "title": "Dirección de la empresa"
      },
      "addressError": {
        "title": "Error en el envío de la dirección"
      },
      "authorizedRep": {
        "jobPosition": "Puesto de trabajo*",
        "jobTitle": "Cargo*",
        "title": "Datos del representante autorizado"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Marca de propietario único",
          "point1": "Solo se permite un número de teléfono",
          "point2": "No se requiere EIN/SSN/DUNS"
        },
        "solePropCampaign": {
          "heading": "Campaña de propietario único",
          "point1": "Solo se permite vincular 1 número a una campaña de propietario único",
          "point2": "Una vez aprobado, su número predeterminado se vinculará automáticamente",
          "infoText": "También puede actualizar el número después de la aprobación",
          "warningText": "Solo se permite vincular un número a una campaña de propietario único. Una vez aceptado, su número por defecto se vinculará automáticamente. También puede actualizar el número después de la aprobación."
        },
        "solePropSubtitle": "Detalles de marca y campaña de propietario único",
        "standardBrand": {
          "heading": "4,41 $ - Una vez",
          "point1": "EIN/SSN/DUNS obligatorio",
          "point2": "Se permite más de un número de teléfono"
        },
        "standardCampaign": {
          "heading": "16,54 $ - Una vez",
          "point1": "Se permite vincular más de 1 número a una campaña estándar",
          "point2": "EIN/SSN/DUNS obligatorio",
          "infoText": "Se aplicará un cargo adicional de campaña de hasta 12 $ al mes conforme a las normas de TCR."
        },
        "standardSubtitle": "Detalles de marca y campaña estándar",
        "title": "Detalles de marca y campaña"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Información de contacto",
          "contactInfoSubtitle": "Puede ser cualquier persona que pueda responder preguntas sobre esta marca, si fuera necesario. Tenga en cuenta que no puede reutilizar la información de contacto entre marcas. Cada marca que cree debe tener información de contacto única.",
          "emailHelper": "No utilice el mismo correo electrónico para más de cinco marcas.",
          "phoneNumberHelper": "No utilice el mismo número de teléfono para más de cinco marcas.",
          "profileName": "Nombre de la empresa o su nombre y apellidos*",
          "profileNameHelper": "Utilice el nombre legal de la organización que envía los mensajes o su propio nombre si esta marca no es para una organización.",
          "nextLoading": "Siguiente...",
          "invalidPhoneNumber": "Número de teléfono no válido",
          "phoneNumberWithCountryCode": "Número de teléfono (con código de país)*",
          "phoneNumberRequired": "El número de teléfono es obligatorio.",
          "emailRequired": "El correo electrónico es obligatorio.",
          "profileNameRequired": "El nombre del perfil es obligatorio."
        },
        "standard": {
          "businessType": "Tipo de empresa*",
          "legalBusinessName": "Nombre legal de la empresa*",
          "legalBusinessNameHelper": "Introduce el nombre exacto del negocio, tal como está registrado en el gobierno y como figura en sus documentos fiscales (CP 575). Por ejemplo, Leadconnector LLC en lugar de Leadconnector.",
          "regionsOfOperations": "Regiones de operación de la empresa*",
          "registrationNumber": "Número de registro de la empresa*",
          "registrationNumberHelper": "El número utilizado para identificar su empresa. En el caso del EIN de EE. UU., debe ser un número de 9 dígitos, por ejemplo, 12-3456789.",
          "registrationType": "Tipo de ID de registro de la empresa*",
          "website": "Sitio web de la empresa*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Paso {currentStep} de {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Su perfil de empresa se ha enviado correctamente.",
        "startA2P": "Iniciar registro A2P",
        "title": "Perfil de empresa enviado correctamente",
        "tooltips": {
          "agency": "Los usuarios de la agencia pueden comenzar el registro A2P",
          "location": "Los usuarios de la ubicación pueden comenzar el registro A2P"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Cerrar ejemplo",
          "optInKeywords": "Palabras clave de suscripción*",
          "optInKeywordsHelper": "Longitud máx.: 255 caracteres.",
          "optInKeywordsPlaceholder": "Palabras clave separadas por comas. Ejemplo: SUBSCRIBIRSE, EMPEZAR.",
          "optInMessage": "Mensaje de suscripción*",
          "optInMessageInfo": "Debe contener el nombre de la empresa y la palabra clave de cancelación",
          "optInMessagePlaceholder": "Ejemplo: Se ha suscrito correctamente para recibir SMS de notificación y promoción de nombre_empresa. Responda DETENER si necesita darse de baja en el futuro.",
          "placeholder": "Ejemplo: Los usuarios finales se inscriben visitando - https://www.miempresea.com/reservar y rellenando sus datos. Los usuarios marcan una casilla para recibir notificaciones & mensajes promocionales de nosotros y así brindar su consentimiento. Además, los usuarios finales también pueden enviar un mensaje de texto con la palabra EMPEZAR al +1 (213) 725-2867.",
          "question": "¿Cómo dan su consentimiento los usuarios finales para recibir mensajes?*",
          "seeExample": "Ver ejemplo"
        },
        "messageDetails": {
          "embeddedLink": "El mensaje incluirá un enlace insertado",
          "phoneNumbers": "Los mensajes incluirán números de teléfono",
          "sampleMessage1Placeholder": "Ejemplo: ¡Hola, John! Soy Jane, de nombre_empresa. Nuestra cita para el 20 de julio a las 11:00 está confirmada. Por favor, comuníquese al +1 (213) 725-2867 en caso de que necesite reprogramar. Responda DETENER para cancelar la suscripción.",
          "sampleMessage2Placeholder": "Ejemplo: ¡Hola, Brian! Soy Jane, de nombre_empresa. Veo que no pudo asistir a nuestra cita. ¿Le gustaría reprogramar? - https://www.miempresa.com/reservar. Responda DETENER para cancelar la suscripción.",
          "sampleMessageInfo": "Debe incluir el nombre del cliente potencial, su nombre, el nombre de la empresa y el idioma de cancelación",
          "subtitle": "Añadir mensajes de ejemplo"
        },
        "useCaseDetails": {
          "explainInDetail": "Explíquelo en detalle",
          "pickUseCase": "Seleccionar caso práctico de campaña",
          "solePropLabel": "Propietario único",
          "subtitle": "Introduzca los detalles y la descripción de la campaña",
          "useCase": "Caso práctico de campaña*",
          "useCaseDescription": "Descripción del caso de uso*",
          "useCaseDescriptionPlaceholder": "Ejemplo: Esta campaña envía mensajes de información, confirmación y recordatorio de citas a nuestros clientes una vez que han reservado una cita con nosotros en nuestra web y han optado por recibir SMS promocionales y de notificación de nuestra parte."
        }
      },
      "einModal": {
        "disableNoEINText": "Solo las empresas con dirección válida en EE. UU. y Canadá pueden registrar la marca A2P sin un número de identificación fiscal.",
        "hasEIN": "Sí, la empresa que estoy registrando tiene número de identificación fiscal (por ejemplo, EIN, CCN, etc.).",
        "infoText": "Puede encontrar su EIN de EE. UU. en el formulario CP 575.",
        "noEIN": "No, la empresa que estoy registrando no tiene número de identificación fiscal (por ejemplo, EIN, CCN, etc.).",
        "question": "¿La empresa que está registrando tiene número de identificación fiscal (por ejemplo, EIN, CCN, etc.)?*",
        "title": "Determinar las necesidades de la marca A2P"
      },
      "exampleModal": {
        "examples": "Ejemplos"
      },
      "otpError": {
        "message": "Ha habido algún problema al enviar el OTP.",
        "title": "Error al reenviar el OTP"
      },
      "otpSuccess": {
        "title": "El OTP se ha enviado correctamente."
      },
      "validation": {
        "cityRequired": "La ciudad es obligatoria.",
        "countryRequired": "El país es obligatorio.",
        "invalidMobileNumber": "Número de teléfono móvil no válido",
        "postalCodeRequired": "El código postal es obligatorio.",
        "stateRequired": "La región/provincia/estado es obligatorio.",
        "streetAddressRequired": "La dirección postal es obligatoria."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "afiliado-acerca-de-iframe",
      "agencyOwner": "Propietario de la agencia",
      "agencyOwnerAndAdmins": "Propietario de la agencia y administradores",
      "contactAgencyOwner": "Si necesita ayuda, comuníquese con el",
      "firstPromoterAccessMessage": "Este informe de FirstPromoter solo es accesible para el",
      "firstPromoterIframe": "primer-promotor-iframe",
      "noPartnerFound": "No se encontró ningún socio que coincida con sus filtros. Haga clic",
      "paymentDetailsAccessMessage": "Esta sección de detalles de pago solo es accesible y editable por el",
      "toApplyPartner": "para solicitar convertirse en socio."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Doc"
      },
      "loading": "Cargando",
      "legalBusinessNameHelper": "Introduzca el nombre exacto del negocio, tal como está registrado en el gobierno y como figura en sus documentos fiscales (CP 575). Por ejemplo, Leadconnector LLC en lugar de Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Haga clic en <span class='font-semibold'>Abrir HighLevel</span> para lanzar la aplicación de escritorio.<br>¿No funciona? También puede <a href=\"/\" class='!text-blue-700 hover:underline'>usar HighLevel en su navegador</a>",
        "launchingTitle": "Lanzamiento de HighLevel para escritorio",
        "launchButtonText": "Abrir HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Haga clic en <span class='font-semibold'>Abrir LeadConnector</span> para lanzar la aplicación de escritorio.<br>¿No funciona? También puede <a href=\"/\" class='!text-blue-700 hover:underline'>usar LeadConnector en su navegador</a>",
        "launchingTitle": "Lanzamiento de LeadConnector para escritorio",
        "launchButtonText": "Abrir LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Seleccionar una acción",
        "destination": "Destino",
        "removeFromAllCampaigns": "Esta acción eliminará los clientes potenciales de todas las campañas, excepto la campaña actual",
        "triggerLinks": "Enlaces de activación"
      },
      "importTemplate": {
        "errorImporting": "Error al importar la plantilla.",
        "importTemplate": "Importar plantilla",
        "importing": "Importando",
        "title": "Importar plantilla de {entityName}",
        "unnamedEntity": "Copia de {entityName} sin nombre"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "debajo",
          "confirmByTyping": "Por favor, confirme escribiendo",
          "confirmWord": "CONFIRMAR",
          "existingNotMoved": "Si su cliente ya tiene configurado Mailgun o SMTP no se les transferirá",
          "notNow": "Ahora no",
          "pricingInfo": "LC Email es más barato que Mailgun y le costará unos 0,68 dólares por 1000 correos electrónicos",
          "setAsDefault": "Establezca LC Email como proveedor predeterminado para su agencia y clientes que aún no dispongan de Mailgun o SMTP",
          "thisWill": "Esto será:",
          "title": "Está migrando a Lead Connector Email",
          "useLcEmail": "Utilizar LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Arrastre o suelte el contenido multimedia aquí",
        "editPost": "Editar publicación",
        "enterText": "Introduzca el texto aquí",
        "exampleComment": "¡Genial! ¡Qué ganas!",
        "exampleName": "Tecnología de prueba",
        "hashtag1": "#hashtag",
        "hashtag2": "#awesome",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "¿Necesita revisión?",
        "network": "Red",
        "photo": "foto",
        "previewPost": "Previsualizar publicación",
        "selectNetwork": "Seleccionar red social",
        "sizeExample": "245 kb",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Ha creado un grupo de números de {count} para hacer un seguimiento de los visitantes en su página web. <br />Sus llamadas serán redirigidas a",
          "createdSingle": "Ha creado {count} número para hacer un seguimiento de los visitantes en su página web. <br />Sus llamadas serán redirigidas a",
          "percentComplete": "100 % completado"
        },
        "create": {
          "correctErrors": "¡Corrija los errores!",
          "forwardHelp": "Indíquenos qué teléfono debe sonar cuando el cliente llame a su número de teléfono de seguimiento. Suele ser su número de teléfono principal de empresa. Ejemplo: 404-555-1212",
          "heading": "Grupos de números y desvío de llamadas",
          "nameHelp": "«{name}» es como nos referiremos a este número de seguimiento en su cuenta. Seleccione un nombre breve que pueda recordar.",
          "newTrackingNumbers": "nuevos números de seguimiento.",
          "nextTracking": "Siguiente: opciones de seguimiento",
          "percentComplete": "50 % completado",
          "pleaseConfirm": "Confirme:",
          "poolSize": "Tamaño del grupo",
          "poolSizeError": "Introduzca un tamaño de grupo de entre 4 y 30 números de seguimiento.",
          "poolSizeHelp": "El tamaño de su grupo de números determina cuántos visitantes simultáneos podemos seguir en su sitio web en cualquier momento. El tamaño de su grupo debe ser un cuarto del tráfico máximo por hora registrado en Google Analytics, con un mínimo de 4 números.",
          "swappingHelp": "Indíquenos qué número de teléfono debemos cambiar en el sitio web. Ejemplo: 404-555-1212",
          "swappingNumber": "Número de intercambio",
          "validationError": "No se ha podido validar el formulario"
        },
        "features": {
          "activateNumber": "Activar número",
          "address": "Dirección {type}",
          "addressHelp": "La compra en algunos países requiere una dirección específica. Si necesita ayuda, póngase en contacto con el servicio de asistencia para saber cómo añadir una dirección.",
          "heading": "Características del número",
          "leaveBlank": "Dejar en blanco para no dejar ningún mensaje",
          "recordingDescription": "Active la grabación de llamadas y reproduzca un mensaje corto para la persona que llama.",
          "recordingHelp": "Algunas jurisdicciones requieren que ambas partes consientan la grabación de cualquier conversación. Para ayudar en el cumplimiento de estas leyes, puede habilitar un saludo para informar a la persona que llama de que la llamada puede ser grabada.",
          "whisperDescription": "Un mensaje corto que se reproduce antes de la llamada. La persona que llama no oye este mensaje."
        },
        "tracking": {
          "heading": "Opciones de seguimiento",
          "nextCreatePool": "Siguiente: crear grupo",
          "percentComplete": "34 % completado",
          "searchLower": "buscar"
        },
        "whatToTrack": {
          "heading": "¿De qué desea hacer un seguimiento en su sitio web?",
          "trackCampaign": "Rastree una campaña de marketing",
          "trackCampaignDescription": "Cree un número de teléfono que haga un seguimiento de todos los que llaman a una única campaña de marketing.",
          "trackVisitor": "Haga un seguimiento de la actividad de los visitantes",
          "trackVisitorDescription": "Cree varios números que correlacionen las llamadas con los visitantes del sitio web, las palabras clave de PPC y mucho más."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "haga clic aquí para actualizar.",
      "issuesLoadingApp": "Si tiene problemas al cargar la aplicación",
      "loadingFreshData": "Cargando nuevos datos...",
      "loadingNewSubAccountData": "Cargando nuevos datos de subcuenta..."
    },
    "login": {
      "bySigningInYouAgree": "Al iniciar sesión, usted acepta nuestros <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>términos y condiciones</a>",
      "newPasswordSent": "Se le ha enviado una nueva contraseña a su correo electrónico."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Por:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Insignia de socio"
        },
        "checkout": {
          "cardInformation": "Información de la tarjeta",
          "cardNumberInvalid": "El número de su tarjeta no es válido.",
          "commitment": "compromiso",
          "consentOneTime": "Al confirmar, usted permite que LeadConnector cargue el importe de este pago a su tarjeta.",
          "consentSubscription": "Al confirmar su suscripción, permite que LeadConnector cargue a su tarjeta este pago y los pagos futuros de esta suscripción",
          "defaultIntervalCount": "1",
          "endingIn": "termina en",
          "errorImageAlt": "Ilustración de errores",
          "intervalSuffix": "(s)",
          "month": "mes",
          "pay": "Pagar",
          "payWithCard": "pagar con tarjeta",
          "paymentProcessing": "El pago se está procesando. No actualice la página ni pulse el botón Atrás",
          "proceedWithExistingCard": "Continuar con la tarjeta actual",
          "proceedWithNewCard": "Continuar con una nueva tarjeta",
          "prorationDetails": "Se le cobrará por {days} días ahora por el período hasta {billingEnd}, y comenzará a cobrarse la cantidad completa de ${amount}/mes a partir de {billingDate}.",
          "prorationMessage": "Los cargos iniciales se prorratean y la facturación regular comenzará a partir del {billingDate}",
          "purchase": "comprar",
          "subscribe": "Suscribirse",
          "subscribeTo": "Suscribirse a",
          "updateCardDetails": "Actualice los detalles de la tarjeta",
          "zip": "postal"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Paso {currentStep} de 8",
          "successDescription": "Su marca A2P y campaña ya se han enviado.",
          "successMessage": "Nota: Recibirá un mensaje con el OTP en el número móvil que facilitó para verificar desde TCR. Responda Sí en un plazo de 24 horas desde la recepción del SMS.",
          "successWaitDays": "7 días",
          "successWaitPrefix": "Podría tardar hasta ",
          "successWaitSuffix": " en aprobarse sus paneles de marca y otras 4-5 semanas en aprobarse la campaña."
        },
        "reminder": {
          "noReplyYet": "Aún nadie ha respondido",
          "patientConfirmed": "Paciente verificado"
        },
        "sendGrid": {
          "apiKeyRequired": "La clave API es obligatoria"
        },
        "update": {
          "brandNameHelper": "Utilice el nombre legal de la organización que envía los mensajes.",
          "businessVerticals": "Verticales empresariales*",
          "resendOTP": "Reenviar la OTP",
          "retryOTPTitle": "Reintentar verificación OTP"
        }
      },
      "addCustomEmailModal": {
        "title": "Añadir correo electrónico personalizado"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Añadir proveedor",
        "clickHereForInfo": "Haga clic aquí para obtener más detalles.",
        "clickHereToFindOut": "Haz clic aquí para descubrirlas.",
        "createProviderError": "Algo ha ido mal al crear el proveedor.",
        "gmailLimitations": "Gmail tiene algunas limitaciones.",
        "needHelp": "¿Necesita ayuda para encontrar el servidor SMTP y el número de puerto?",
        "port25NotSupported": "El puerto 25 no es compatible. Utilice el puerto 2525 en su lugar",
        "providerExists": "Ya existe un proveedor con este correo electrónico o nombre de usuario.",
        "providerName": "Nombre del proveedor",
        "selectProvider": "Seleccionar proveedor",
        "smtpPortNumber": "Número de puerto SMTP",
        "smtpProvider": "Proveedor de SMTP",
        "smtpServer": "Servidor SMTP",
        "username": "Nombre de usuario",
        "usernameOrEmailRequired": "Se requiere un nombre de usuario o un correo electrónico.",
        "verifySmtpAccount": "Verificar la cuenta SMTP"
      },
      "addTagModal": {
        "addTag": "Añadir etiqueta",
        "editTag": "Editar la etiqueta",
        "tagAlreadyExists": "La etiqueta {tag} ya existe"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Este informe de FirstPromoter solo es accesible para el <strong>propietario de la agencia y los administradores</strong>. Si necesita asistencia, contacte con el <strong>propietario de su agencia ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "Tablero de FirstPromoter",
        "noPartnersFound": "No se encontró ningún socio que coincida con sus filtros. Haga clic <a href='javascript:void(0);'>aquí</a> para solicitar convertirse en socio.",
        "paymentDetailsAccessMessage": "Esta sección de detalles de pago solo es accesible y editable por el <strong>propietario de la agencia</strong>. Si necesita asistencia, contacte con el <strong>propietario de su agencia ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Detalles de la cita"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Cargar instantánea:",
        "loadSnapshotWarning": "¿Desea cargar la instantánea asociada a este plan? <br /> <strong class='text-danger'>Los datos existentes pueden perderse</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Cambiar contraseña",
          "confirmPassword": "Confirmar la nueva contraseña",
          "expired": "Su enlace de restablecimiento de contraseña ha caducado.",
          "regenerateLink": "Volver a generar el enlace",
          "success": "Contraseña cambiada correctamente",
          "title": "Establecer una nueva contraseña",
          "passwordMismatch": "Las contraseñas no coinciden"
        },
        "forgotPassword": {
          "contactAgency": "póngase en contacto con su agencia.",
          "contactSupport": "póngase en contacto con la asistencia de HighLevel, disponible las 24 horas al día, 7 días a la semana, llamando al",
          "supportMessage": "Si no tiene acceso a ese buzón de correo electrónico,",
          "successMessage": "Se ha enviado un enlace para restablecer la contraseña a su dirección de correo electrónico.",
          "rateLimitError": "Demasiadas solicitudes de restablecimiento de contraseña. Inténtelo de nuevo más tarde."
        },
        "login": {
          "inactivityMsg": "Hemos notado que ha estado inactivo durante un tiempo, así que hemos cerrado su sesión para garantizar la seguridad.",
          "loginButton": "Iniciar sesión",
          "resetPasswordMsg": "Le enviaremos un enlace de restablecimiento de la contraseña a su correo electrónico.",
          "signInWithGoogle": "Iniciar sesión con Google",
          "contactHighLevelSupport": " póngase en contacto con la asistencia de HighLevel, disponible las 24 horas al día, 7 días a la semana, llamando al"
        },
        "logout": {
          "loggingOut": "Cerrando sesión..."
        },
        "otp": {
          "enterBackupCode": "Introduzca su código de respaldo",
          "resend": "Reenviar",
          "resendIn": "Reenviar en",
          "sendToPhone": "Enviar código al teléfono",
          "sending": "Enviando",
          "useAuthenticator": "Utilice la aplicación Authenticator",
          "useBackupCode": "Usar el código de respaldo",
          "verifyButton": "Verificar con el código de respaldo"
        },
        "sso": {
          "agreeTerms": "Al iniciar sesión, usted acepta nuestros <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Términos y condiciones</a>",
          "and": ", y",
          "loginDifferentMethod": "Inicie sesión con un método diferente",
          "loginSuccessRedirecting": "Inicio de sesión correcto, redirigiendo...",
          "processing": "Procesando su solicitud...",
          "redirecting": "Redirigiendo...",
          "redirectingToDashboard": "Redirigiendo al tablero...",
          "signedIn": "Sesión iniciada",
          "signingIn": "Iniciando sesión...",
          "testFailedRedirecting": "Prueba fallida, redirigiendo...",
          "testSuccessRedirecting": "Prueba satisfactoria, redirigiendo..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Dirección de empresa: {address}",
        "businessDetailsText": "Los siguientes detalles empresariales se enviarán al Google Local Services Ads para la reserva con la integración con Google. Compruebe y confirme o {link} para actualizar su perfil empresarial.",
        "businessInfoRequired": "La información empresarial mencionada arriba es necesaria para la integración, {link} para actualizar los datos comerciales faltantes o incorrectos.",
        "businessName": "Nombre de la empresa: {name}",
        "businessNiche": "Nicho de negocio: {niche}",
        "city": "Ciudad: {city}",
        "confirmDetails": "Por la presente confirmo que los detalles mencionados anteriormente son correctos",
        "country": "País: {country}",
        "mustConfirmDetails": "Debe confirmar los detalles mencionados anteriormente.",
        "phoneNumber": "Número de teléfono: {phone}",
        "state": "Estado: {state}",
        "zipCode": "Código postal: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Añadir Horas",
        "applyAll": "Aplicar a todos"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Responda a la llamada e introduzca este código de verificación:",
          "leadConnectorCalling": "El conector de clientes potenciales está llamando...",
          "title": "Añadir un identificador de llamada por voz",
          "waitingForVerification": "Esperando la verificación..."
        },
        "callerIdVerificationStatus": {
          "failed": "Error en la verificación del identificador de llamada. Inténtelo de nuevo.",
          "success": "Ha verificado correctamente <strong>{contact}</strong>"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Añadir número(s) actual(es)",
          "areaCode": "Prefijo de área:",
          "checkAvailability": "Comprobar disponibilidad",
          "checkingAvailability": "Comprobando disponibilidad del número.",
          "chooseAreaCode": "Seleccione un prefijo de área",
          "choosePhoneNumbers": "Seleccionar número(s) de teléfono",
          "goBack": "Volver",
          "localNumbers": "Local {type}",
          "nextNumberFeatures": "Siguiente: características del número",
          "noExistingNumbers": "No hay números para añadir",
          "noNumbersAvailable": "No hay números disponibles",
          "notEnoughNumbers": "No hay suficientes números disponibles",
          "numbersAvailable": "Números disponibles",
          "numbersDifferentArea": "Números en otro prefijo de área",
          "numbersLocalTo": "Números locales para <strong>{number}</strong>",
          "problemChecking": "Problemas para comprobar la disponibilidad del número de información, compruebe la conexión de red o póngase en contacto con el soporte.",
          "somethingWentWrong": "Algo ha ido mal. Compruebe las credenciales de tu cuenta de Twilio y póngase en contacto con el soporte si el problema sigue.",
          "tollFreeNumbers": "Números gratuitos (recargo de 2,00 $ por número al mes)",
          "percentageComplete": "67 % completado"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Entiendo las consecuencias, eliminar el grupo",
          "confirmText": "Escriba <b>{name}</b> para guardar",
          "title": "Eliminar grupo de números - <strong>{name}</strong>",
          "warning": "Esta acción no se puede deshacer. Esto borrará permanentemente el número o números de su cuenta de Twilio junto con el grupo de números de nuestra base de datos. Además, si va a eliminar el grupo de números porque tiene un problema, póngase en contacto con nuestro equipo de asistencia."
        },
        "editNumberFormatModal": {
          "description": "Puede actualizar el formato de los números de intercambio y de los números de grupo según le convenga. Asegúrese de que los números de intercambio aparezcan de la misma manera en el sitio web tal como están formateados.",
          "title": "Actualizar el formato del número - <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Añadir/editar id de grupo",
          "callConnectTooltip": "Esta función requiere que el destinatario presione una tecla para conectar la llamada, lo que resultará en una mayor precisión para el informe de llamadas.",
          "createGroupIdDescription": "Cree o añada un identificador de grupo único para utilizar varios grupos de números con un único fragmento JavaScript.",
          "enableCallConnect": "Habilitar la función de conexión de llamadas",
          "groupId": "Id. de grupo",
          "outboundCallTimeout": "Interrupción de llamada saliente",
          "passCallerID": "Hacer pasar el número llamado como identificador de llamada",
          "passCallerIDTooltip": "Por defecto, el sistema transmite el número de la persona que llama, pero si prefiere que el identificador de llamada sea el número marcado por la persona que llama, habilite esta función",
          "selectCallerID": "Seleccionar el identificador de llamada",
          "timeDuration": "Duración del tiempo en segundos",
          "titleNumber": "Número - <strong>{number}</strong>",
          "updateWhisperWarning": "Actualizar el mensaje susurrado, ya que esta función requiere que el receptor pulse una tecla para conectar la llamada.",
          "useVerifiedNumber": "Use su número verificado como identificador de llamada para las llamadas salientes",
          "useVerifiedNumberTooltip": "Solo aplicable a números de teléfono verificados. Puede verificar un número de teléfono en Configuración > Números de teléfono > Añadir identificador de llamada verificado"
        },
        "emailOTPModal": {
          "confirmCode": "Guardar código",
          "resendCode": "Si no ha recibido el código, haga clic aquí para reenviarlo",
          "unexpectedIssue": "Se ha producido un problema inesperado"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Información del Campo Personalizado",
          "customFieldTooltip": "Información sobre herramientas de campo personalizado: {options}",
          "field": "Campo de {companyName}",
          "trackingParameters": "Parámetros de seguimiento",
          "zipCode": "Código postal"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Añadir intercambio de números",
          "addingSnippets": "Añadir fragmentos de Javascript",
          "groupSnippet": "Fragmento del grupo «{id}»",
          "normalSnippet": "Fragmento normal",
          "noswapDescription": "Si no desea que intercambiemos el número en un lugar determinado, añada la clase «no intercambiar».",
          "notReplacing": "No se reemplaza en una ubicación determinada",
          "requiredSteps": "Pasos obligatorios",
          "snippetsDescription": "Copie el fragmento que aparece a continuación y añádalo justo encima de la etiqueta de cierre del cuerpo de cada página en la que desee sustituir los números.",
          "swappingDescription": "Utilice los números de abajo para habilitar el intercambio de números de teléfono. Seleccione un formato local, internacional o incluso ambos."
        },
        "newPhoneNumberModal": {
          "areaCode": "Código de área",
          "availableNumbers": "Números disponibles",
          "bundle": "Paquete",
          "chooseAddress": "Seleccionar dirección...",
          "chooseBundle": "Seleccionar paquete...",
          "createRegulatory": "Generar paquetes de regulación/direcciones aquí.",
          "monthlyFee": "Cargo mensual",
          "noNumbersFound": "No se han encontrado números, pruebe con otro prefijo de área.",
          "selectAddress": "Haga clic en «Dirección» para comprar un número.",
          "selectBundle": "Seleccione «Paquete» para comprar un número.",
          "title": "Añadir número de teléfono",
          "upgradeAccount": "Actualice su cuenta de Twilio, solo las cuentas actualizadas pueden comprar números de teléfono y hacer llamadas",
          "cardAuthenticationFailed": "¡Ha fallado la autentificación de la tarjeta!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Debe aceptar los términos y la política de privacidad.",
          "clickingProceed": "Hacer clic en Continuar abrirá la página de enlace de LSA en una nueva pestaña",
          "configureCalendar": "Configurar al menos un calendario para continuar con la integración de las reservas con Google",
          "configureCalendarBtn": "Configurar calendario",
          "linkOneAccount": "Asegúrese de vincular únicamente una cuenta. Contacte con asistencia técnica si no puede ver la página en la captura de pantalla anterior.",
          "readInstructions": "He leído las instrucciones mencionadas anteriormente"
        },
        "updateTrackingModal": {
          "title": "Actualizar opción de seguimiento"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Esto solo es visible para los administradores de la agencia)",
          "updatedEvery24Hours": "(actualizado cada 24 horas)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Calendario no seleccionado para la sincronización",
          "check": "Comprobar {email}",
          "checkForConflicts": "Comprobar si hay conflictos",
          "checkForConflictsTooltip": "Configure el calendario o los calendarios para comprobar si hay conflictos y evitar reservas dobles.",
          "contactCreationAllowed": "Creación de contactos permitida",
          "googleCalendar": "Logotipo de Google Calendar",
          "noGoogleAccounts": "Aún no se ha añadido ninguna cuenta de Google/Outlook en la configuración de integraciones",
          "noGoogleAccountsTeamMember": "No se han añadido cuentas de Google/Outlook para este miembro del equipo en la ubicación actual. Pídale al miembro de su equipo que inicie sesión a través de su cuenta y añada una conexión a Google desde su configuración de integraciones.",
          "outlookCalendar": "Outlook Calendario de usuario",
          "primaryCalendarTooltip": "Configure el calendario al que desea agregar nuevos eventos a medida que se programan.",
          "runTriggerAllowed": "Activador de ejecución permitido"
        },
        "warningModal": {
          "contactAgency": "Póngase en contacto con su agencia para cambiar la configuración del correo electrónico.",
          "title": "Advertencia"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Asistencia por chat ininterrumpida y más rápida",
            "faster247Ticket": "Asistencia de incidencias y tiempos de respuesta más rápidos, las 24 horas al día, los 7 días a la semana"
          },
          "highlight": {
            "description": "Lo entendemos, necesita ir más rápido. Cuando tiene una pregunta o duda, quiere que le respondan lo antes posible. Con la actualización a la asistencia prioritaria, puede saltarse la cola y acelerar automáticamente sus solicitudes para que sean las primeras.",
            "heading": "¿Todo listo para el tratamiento VIP?"
          },
          "name": "Asistencia prioritaria",
          "success": {
            "description": "Se ha habilitado la asistencia prioritaria en su cuenta. Se acabaron las esperas.",
            "heading": "¡Ahora es un cliente prioritario!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Clonar {entityName}",
        "cloning": "Clonando...",
        "cloningLimit": "La clonación está limitada a tres ubicaciones a la vez.",
        "error": "Error al clonar el embudo.",
        "locationsLabel": "Seleccionar ubicaciones",
        "nameLabel": "Nombre para el {entityName} clonado",
        "namePlaceholder": "Introduzca el nombre para el {entityName} clonado",
        "selectUpTo": "Seleccione hasta {maxSelectableLocations} ubicaciones",
        "title": "Clonar {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Con CNAM, el nombre de su empresa aparece en el identificador de llamadas, haciendo que sean instantáneamente reconocibles y aumentando la confianza. Deje que sus clientes sepan que es usted quien llama cada vez.",
          "title": "Haga que sus llamadas destaquen."
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Confirmar y registrarse",
          "description": "Muestre el nombre de su empresa a los destinatarios de las llamadas para aumentar la confianza y la frecuencia de respuesta a las llamadas.",
          "title": "Impulse la confianza en las llamadas con CNAM",
          "warning": "La visualización del nombre la empresa no está garantizada, especialmente en móvil."
        },
        "submitted": {
          "checkStatus": "Consultar el estado de CNAM",
          "description": "El nombre de su empresa debería mostrarse a los contactos correspondientes en unos 3-5 días.",
          "subtitle": "Su solicitud de CNAM ha sido enviada.",
          "title": "¡Enhorabuena!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Confirmar eliminación",
        "confirmation": "Confirmación"
      },
      "createAddress": {
        "successTitle": "Dirección enviada correctamente",
        "underReview": "La dirección enviada está en proceso de revisión"
      },
      "createEndUser": {
        "dateFormat": "El formato de la fecha debe ser AAAA-MM-DD.",
        "phoneExample": " Ejemplo: +14155552671",
        "title": "Información de la empresa:"
      },
      "customValueModal": {
        "changingNameWarning": "Cambiar el nombre no afectará a la clave del campo.",
        "editCustomValue": "Editar valor personalizado",
        "fieldKeyCreatedWarning": "La clave de campo se creará según el nombre y no podrá cambiarse posteriormente.",
        "nameRequired": "El campo «Nombre» es obligatorio",
        "nameValidation": "El nombre debe ser alfanumérico y contener al menos un carácter",
        "valueRequired": "El campo «Valor» es obligatorio"
      },
      "details": {
        "addressName": "Nombre de la dirección",
        "addressTitle": "Detalles de la dirección",
        "bundleName": "Nombre del paquete",
        "bundleTitle": "Información del paquete de regulación",
        "countryFlag": "Bandera de {country}",
        "id": "ID",
        "organisation": "Organización",
        "rejectionReason": "Motivo de rechazo",
        "status": {
          "approved": "Aprobado",
          "notValidated": "No validado",
          "rejected": "Rechazado",
          "validated": "Validado"
        },
        "typeOfNumber": "Tipo de número"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Seleccione la oficina",
        "whichOffice": "¿A qué oficina desea vincular esta cuenta?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Permitir la creación de contactos:",
        "allowTrigger": "Permitir activador:",
        "doNotSync": "No sincronice nuevos eventos con el calendario principal",
        "primaryCalendarTooltip": "Solo puede seleccionar un calendario con acceso de escritura que no haya seleccionado para comprobar conflictos.",
        "selectDefaultCalendar": "Seleccionar calendario predeterminado",
        "whichCalendar": "¿Qué calendario debemos usar para sincronizar (leer y escribir) eventos?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Compruebe estos lugares en busca de conflictos",
        "howToCheckConflicts": "¿Cómo debemos comprobar si hay conflictos?"
      },
      "ejectModal": {
        "agencyClosing": "La cuenta de la agencia Elite Marketing con HighLevel se cierra. Para conservar su cuenta, póngase en contacto con {userName} para migrar su cuenta directamente a HighLevel.",
        "cancelWarning": "Tenga en cuenta que su cuenta se cancelará oficialmente el 30 de junio de 2025 y no podremos recuperar sus datos después de esta fecha si no se completa la transferencia.",
        "contactEmail": "transferencias@gohighlevel.com",
        "contactUs": "Si tiene alguna pregunta, póngase en contacto con nosotros en",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "Para acompañarle durante esta transición gratuita, le aplicaremos {months} de acceso gratuito a su nueva suscripción.",
        "intro": "Debido a repetidas violaciones de los términos de servicio de HighLevel, Elite Marketing Authority (EMA) ha sido eliminada permanentemente de la plataforma HighLevel.",
        "platformCommitment": "Como plataforma que impulsa los servicios de EMA, HighLevel se compromete a mantener un entorno seguro, conforme y digno de confianza para todos los usuarios. Para evitar interrupciones en su cuenta, estamos a su disposición para ayudarle a efectuar la transición sin problemas, ya sea a otro proveedor de marca blanca o directamente a HighLevel.",
        "questions": "Si tiene alguna pregunta,",
        "retainAccess": "Para conservar el acceso a sus datos y herramientas existentes, haga clic en el botón de abajo y siga las instrucciones para iniciar la transferencia.",
        "speakWithTeam": "para hablar con nuestro equipo.",
        "startTransfer": "Inicie su transferencia gratuita",
        "title": "Atención a los clientes de Elite Marketing",
        "viewFaqs": "Ver las preguntas frecuentes aquí:",
        "whiteLabel": "Si prefiere acceder a HighLevel a través de otro proveedor de marca blanca, estaremos encantados de acomodar ese cambio a través de nuestro sistema de incidencias de asistencia una vez que haya transferido su cuenta directamente a HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Creado el",
        "updatedOn": "Actualizado el"
      },
      "error": {
        "title": "Error en el envío del paquete regulatorio"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Hay más de una página con esta URL, cambie la ruta de esta página para que funcione correctamente.",
          "urlNotFound": "Lo sentimos, no hemos podido encontrar la URL que buscaba"
        },
        "productRebilling": {
          "requestFailed": "Solicitud fallida"
        },
        "template": {
          "categoryNotFound": "Lo sentimos, no hemos encontrado la categoría que buscaba.",
          "internalError": "¡Se ha producido un error interno!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "La subcuenta que está intentando transferir está habilitada para HIPAA y no se puede transferir a una agencia que no cumpla con HIPAA."
          },
          "limitExceeded": {
            "message": "La agencia a la que intenta transferir la subcuenta ha agotado su límite de uso y no puede recibir más subcuentas.  Pídales que borren alguna subcuenta que no esté en uso o que pasen a un plan de agencia superior para poder recibir esta subcuenta."
          },
          "pendingRequest": {
            "heading": "Ya hay una solicitud de transferencia pendiente para esta subcuenta.",
            "message": "Cancele la solicitud de transferencia ya existente para esta subcuenta antes de crear una nueva."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "¿No encuentra la página que busca? Visite la configuración de Facebook y asegúrese de que todas las páginas están seleccionadas.",
        "instagramAvailable": "Instagram está disponible para esta cuenta.",
        "noPages": "No tiene ninguna página bajo esta cuenta.",
        "title": "Seleccione qué página de Facebook desea vincular a esta ubicación"
      },
      "googleLocationSelect": {
        "closeButton": "¡Cerrar!",
        "enableCallTracking": "Habilitar el seguimiento de llamadas GBP",
        "noBusinesses": "No tiene ningún negocio conectado con esta cuenta."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Más eficiente",
          "faster": "Más rápido",
          "itsText": "Es",
          "smoother": "Más fluido",
          "title": "¡Ya está aquí una nueva experiencia de importación!",
          "warningMessage": "Habilitar la nueva experiencia de importación activa Labs para esta subcuenta y activa la función beta."
        },
        "validateEmails": "¿Validar correos electrónicos?"
      },
      "initBundle": {
        "numberType": "Tipo de números que planeaba usar",
        "numberTypes": {
          "local": "Números locales",
          "mobile": "Móvil",
          "tollfree": "Gratuitos"
        },
        "selectCountry": "Seleccione su país",
        "selectUserType": "Seleccione el tipo de usuario",
        "userTypes": {
          "business": "Negocio",
          "individual": "Individual"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Crédito añadido por última vez el:",
        "currentBalance": "Saldo actual",
        "debitBalance": "- Saldo deudor",
        "depositComplimentaryCreditsOf": "Depósito de créditos gratuitos de",
        "manageBalance": "Gestionar saldo",
        "mustBeValidInteger": "Debe ser un número entero válido",
        "nextDate": "Siguiente fecha:",
        "perMonth": "por mes",
        "remainingWalletBalance": "Saldo restante del monedero de esta subcuenta",
        "rolloverCredits": "Transferir los créditos al mes siguiente",
        "toManageMonthlyCredits": "Para gestionar los créditos mensuales,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Añadir nueva suscripción"
      },
      "manualActions": {
        "confirmDelete": "¿Seguro que desea eliminar esta acción?",
        "confirmDeleteAll": "¿Seguro que desea eliminar todas las acciones manuales de esta página?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Generar una contraseña segura",
          "sendEmailNotification": "Además, enviar una notificación por correo electrónico."
        }
      },
      "modal": {
        "description": "Necesita completar unos sencillos pasos de cumplimiento para usar sistemas telefónicos",
        "submit": "Enviar",
        "title": "Servicio telefónico del conector de clientes potenciales"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Visitantes de la página de inicio",
          "launched": "Lanzado",
          "newNotification": "Nueva notificación",
          "startMessage": "Empiece a impulsar sus conversiones creando su primera notificación",
          "types": {
            "combination": "Combinación"
          }
        },
        "page": {
          "createTitle": "Crear nueva notificación",
          "steps": {
            "display": "Visualización",
            "track": "Seguimiento"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Información adicional",
          "calendarEvent": "Evento del calendario",
          "hideAssignedTo": "Ocultar «Asignado a»",
          "hideTags": "Ocultar etiquetas"
        },
        "filters": {
          "dateAddedAsc": "↑ Fecha de adición (asc.)",
          "dateAddedDesc": "↓ Fecha de adición (desc.)",
          "orderBy": "Ordenar por"
        },
        "getStarted": "¡Comience!",
        "noPipelines": "¡Vaya! Parece que no hay secuencias. Cree una nueva secuencia para"
      },
      "pages": {
        "pageMoved": {
          "title": "Los listados en línea se han movido"
        }
      },
      "recentlyVisited": {
        "prices": "{count} precios"
      },
      "reminders": {
        "appointmentReminders": "Recordatorios de citas",
        "apptTime": "Hora de la cita",
        "defaultDateRange": "Domingo, 1 de abril de 2018 - lunes, 30 de abril de 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "En espera",
        "rebillingOnHoldWarning": "Esta cuenta ya tiene las configuraciones de refacturación en espera. El plan SaaS solo se puede unir después de que el cliente haya añadido un método de pago.",
        "subscriptionId": "Id. de la suscripción:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Guardar y continuar",
        "documents": {
          "acceptedDocuments": "Documentos aceptados",
          "acceptedDocumentsLabel": "Documentos aceptados:",
          "additionalInfo": "Información adicional:",
          "createAddressLink": "Cree la dirección.",
          "createAddressPrompt": "Cree primero una dirección y luego proceda a la creación del paquete.",
          "documentInfo": "PNG, JPG, PDF de hasta 5 MB",
          "documentType": "Tipo de documento",
          "option": "Opción {number}",
          "selectAddress": "Seleccionar dirección:",
          "selectDocumentType": "Seleccionar tipo de documento:",
          "selectFile": "Seleccionar archivo",
          "title": "Documentos obligatorios:",
          "updateDocuments": "Actualizar documentos"
        },
        "everythingIn": "Todo lo que incluye <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "añada aquí la tarjeta de crédito",
          "message": "Pídale a su cliente que",
          "title": "La ubicación necesita añadir un método de pago primero."
        },
        "noSaasPlan": {
          "linkText": "cree aquí sus planes SaaS.",
          "message": "Por favor,",
          "title": "No tiene configurado ningún plan SaaS."
        },
        "saasModeSetupPendingWarning": "El plan SaaS se activará una vez que el cliente haya añadido un método de pago. Hasta entonces, el acceso a su cuenta estará restringido.",
        "skipForNow": "Saltar por ahora",
        "skipPlan": "Saltar plan",
        "success": {
          "title": "Paquete de regulación enviado correctamente",
          "underReview": "Paquete enviado en proceso de revisión"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Esta opción añadirá una nueva dirección a su cuenta",
          "label": "Paquete de dirección"
        },
        "regulatoryBundle": {
          "description": "Esta opción le ayudará a crear un nuevo paquete regulatorio",
          "label": "Paquete regulatorio"
        },
        "title": "Seleccione el paquete que desea añadir"
      },
      "settings": {
        "billing": "Facturación",
        "calendars": "Calendarios",
        "customEmails": "Correos electrónicos personalizados",
        "domains": "Dominios",
        "domainsAndUrlRedirects": "Dominios y redirecciones de URL",
        "facebookFormFieldsMapping": "Asignación de campos de formulario de Facebook",
        "groups": "Grupos",
        "integrations": "Integraciones",
        "labs": "Laboratorios",
        "media": "Contenido multimedia",
        "noShowSMS": "SMS de no asistido",
        "pipelines": "Secuencias",
        "profile": "Perfil",
        "smtpAndMailGunService": "Servicio SMTP y MailGun",
        "templates": "Plantillas",
        "urlRedirects": "Redireccionamientos de URL"
      },
      "shakenStir": {
        "confirmation": {
          "title": "¡Sus llamadas ahora están verificadas!"
        },
        "modal": {
          "andThe": " y el ",
          "certification": "Certifico que el perfil de empresa asociado es el origen de las llamadas telefónicas y certifico que participaré en los esfuerzos de rastreo, incluidos aquellos iniciados por el",
          "failedTitle": "Error en el envío",
          "friendlyNamePlaceholder": "Ej.: SHST 2022-11-24 a las 19:47:14",
          "linkInfo": {
            "description": "Todos los números disponibles actuales y futuros comprados se registrarán automáticamente en SHAKEN/STIR.",
            "title": "Todos los números se vincularán automáticamente"
          },
          "stiPa": "Administrador de políticas de identidad telefónica segura (STI-PA)",
          "subtitle": "Introduzca los detalles y la descripción",
          "successMessage": "Su solicitud de registro para SHAKEN/STIR ha sido enviada. Puede tardar hasta <b>3-4 días</b> en aprobarse. El estado se actualizará pronto.",
          "successTitle": "Llamadas fiables SHAKEN/STIR habilitadas.",
          "title": "Habilitar llamadas fiables SHAKEN/STIR",
          "tracebackGroup": "Grupo de rastreo de telecomunicaciones de EE. UU."
        },
        "withCnam": {
          "cnamPromo": "¿Quiere ir un paso más allá? Muestre el nombre de su empresa en las llamadas con CNAM.",
          "registerCnam": "Regístrese para CNAM",
          "title": "Gánese la confianza del cliente y aumente la tasa de respuesta de llamadas"
        },
        "successMessage": "Su solicitud de registro para SHAKEN/STIR ha sido enviada. Puede tardar hasta <b>3-4 días</b> en aprobarse. El estado se actualizará pronto."
      },
      "shopify": {
        "selectLocation": "Seleccione la ubicación que desea vincular a esta tienda shopify"
      },
      "signup": {
        "accountType": "Tipo de cuenta",
        "agencyProAccount": "Cuenta Pro de agencia (497 $/mes)",
        "agencyTestAccount": "Cuenta de prueba de agencia",
        "freeTrialMessage": "Consiga una prueba <strong>gratuita</strong> de 14 días registrándose ahora mismo.",
        "freelancerAccount": "Cuenta de trabajador autónomo (297 $/mes)",
        "getStartedForFree": "¡Comience gratis!",
        "pickPassword": "Seleccionar una contraseña",
        "signUp": "Registrarse",
        "starterAccount": "Cuenta inicial (97 $/mes)",
        "termsAndConditions": "Al registrarse, acepta nuestros <a href='https://www.gohighlevel.com/privacy' target='_blank'>términos y condiciones</a>",
        "yourCompanyName": "El nombre de su empresa",
        "yourFullName": "Su nombre completo"
      },
      "standardPlan": {
        "description": "Tenemos los siguientes planes para los registros de marca estándar.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN obligatorio para el registro",
            "moreThan1Phone": "Se permite más de un número de teléfono"
          },
          "highVolume": {
            "heading": "Estándar de alto volumen",
            "point3": "Hasta 600 000 segmentos por día",
            "infoText": "Se realizará un cargo único de 20,95 $ por el registro de marca y campaña. Se aplicará un cargo adicional de campaña de hasta 2,25 $ al mes conforme a las normas de TCR.",
            "point2": "Envíe hasta 3000 segmentos por día",
            "point1": "EIN obligatorio para el registro"
          },
          "lowVolume": {
            "heading": "Estándar de bajo volumen",
            "recommended": "Recomendado",
            "point3": "Hasta 6000 segmentos por día",
            "infoText": "Se realizará un cargo único de 20,95 $ por el registro de marca y campaña. Se aplicará un cargo adicional de campaña de hasta 2,25 $ al mes conforme a las normas de TCR.",
            "point2": "Envíe hasta 3000 segmentos por día",
            "point1": "EIN obligatorio para el registro"
          }
        },
        "title": "Seleccione su plan de marca estándar"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Detalles de la reserva",
          "form": "Formulario",
          "quiz": "Cuestionario",
          "submissionDetail": "Detalle del envío",
          "survey": "Encuesta"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Solo los administradores/usuarios de la agencia tienen acceso a esta subcuenta. Actualmente, usted y otros administradores/usuarios de la cuenta no tienen acceso a esta subcuenta.",
          "heading": "Esta subcuenta se ha pausado."
        },
        "temporarily": {
          "description": "Todos sus datos están seguros y todos los activadores, campañas, etc., reanudarán su funcionamiento después de la activación.",
          "heading": " Su cuenta ha sido suspendida temporalmente."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Aplicar solo a los contactos no asignados",
          "splitTraffic": "Dividir tráfico",
          "trafficWeightage": "Ponderación del tráfico",
          "userRequired": "Es necesario seleccionar al usuario",
          "weightage": "Ponderación"
        },
        "birthdayFilters": {
          "afterDays": "Después de un número de días",
          "beforeDays": "Antes de un número determinado de días",
          "dayIs": "El día es",
          "daysInNumber": "Número de días",
          "hasTag": "Tiene etiqueta",
          "monthIs": "El mes es",
          "selectDay": "Seleccionar día",
          "selectMonth": "Seleccionar mes"
        },
        "botConversation": {
          "enterTimeout": "Introduce un tiempo muerto (horas)",
          "selectEliza": "Seleccionar Eliza",
          "selectThankyouTemplate": "Seleccionar plantilla de agradecimiento",
          "selectWelcomeTemplate": "Seleccionar plantilla de bienvenida"
        },
        "contactField": {
          "addField": "Añadir campo",
          "defineFilters": "Definir filtros"
        },
        "copyModal": {
          "title": "Copiar activador"
        },
        "detailModal": {
          "actionsPerform": "¿Qué acciones deberíamos realizar?",
          "campaignNameRequired": "El campo «Nombre de la campaña» es obligatorio",
          "campaignsDeprecation": "Las campañas ya no se mantienen. Para asegurar una transición fluida, convierta sus campañas actuales en flujos de trabajo.",
          "folderName": "Nombre de la carpeta",
          "mustSelectFolder": "Debe seleccionar una carpeta.",
          "newFolderName": "Nuevo nombre de carpeta",
          "selectFolder": "Seleccionar carpeta",
          "triggerNameRequired": "El campo «Nombre del activador» es obligatorio",
          "triggersDeprecation": "Los activadores ya no se mantienen. Para garantizar una transición sin problemas, convierta sus activadores actuales en flujos de trabajo.",
          "triggerName": "Nombre del activador"
        },
        "dnd": {
          "disableAll": "Deshabilitar DND para todos los canales",
          "disableSpecific": "Deshabilitar DND para canales específicos",
          "enableAll": "Habilitar DND para todos los canales",
          "enableSpecific": "Habilitar DND para canales específicos",
          "selectAction": "Seleccionar acción"
        },
        "email": {
          "sendTestEmail": "Enviar correo de prueba",
          "smtpWarning": "Los proveedores de SMTP tienen algunas limitaciones. Haga clic aquí para obtener más información."
        },
        "facebook": {
          "avatarAlt": "Avatar de Facebook",
          "selectCustomAudience": "Seleccionar público personalizado de Facebook"
        },
        "googleAds": {
          "conversionName": "Nombre de la conversión",
          "conversionTooltip": "La fuente de conversión debe ser Importar desde clics y la categoría debe ser Cliente potencial importado o Cliente potencial",
          "noConversions": "No se han encontrado conversiones",
          "selectConversion": "Seleccionar conversión"
        },
        "googleAnalytics": {
          "eventAction": "Acción de evento",
          "eventActionRequired": "Se requiere acción del evento.",
          "eventCategory": "Categoría del evento",
          "eventCategoryRequired": "La categoría del evento es obligatoria.",
          "eventLabel": "Etiqueta de evento",
          "eventValue": "Valor del evento",
          "hitType": "Tipo de impacto",
          "hitTypeRequired": "El tipo de impacto es obligatorio.",
          "trackingId": "Id. de seguimiento",
          "trackingIdRequired": "El id. de seguimiento es obligatorio."
        },
        "membershipOffer": {
          "selectOffer": "Seleccionar oferta"
        },
        "notification": {
          "selectRedirectPage": "Seleccionar página de redirección",
          "selectUser": "Seleccionar usuario",
          "selectUserType": "Seleccionar tipo de Usuario"
        },
        "sms": {
          "sendTestSMS": "Enviar SMS de prueba"
        },
        "stripeCharge": {
          "customerId": "ID de cliente de Stripe",
          "enterAmount": "Introduzca el importe",
          "selectCurrency": "Seleccionar moneda"
        },
        "webhook": {
          "webhookUrl": "URL del Webhook"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Fecha de la actividad",
            "balance": "Saldo",
            "id": "id."
          }
        },
        "upgradeBanner": {
          "subtitle": "Las agencias con plan profesional ganan unos 363 $ al mes refacturando los costes del teléfono a sus clientes",
          "title": "¿Quiere refacturar esto a sus clientes?"
        }
      },
      "updateModals": {
        "error": {
          "title": "No se ha podido enviar su perfil."
        },
        "success": {
          "message": "Su marca A2P y campaña ya se han enviado.<br/><br/><b>Nota:</b> <b>Recibirá un mensaje con el OTP en el número móvil que facilitó para verificar</b> desde TCR. <b>Responda Sí en un plazo de 24 horas</b> desde la recepción del SMS."
        }
      },
      "usageLimit": {
        "contactLimit": "Límite de contactos",
        "maxContactsAllowed": "Máximo de contactos permitidos en la subcuenta",
        "maxUsersAllowed": "Máximo de usuarios permitidos en la subcuenta",
        "unlimited": "Ilimitado",
        "usageLimits": "Límites de uso",
        "userLimit": "Límite de usuarios",
        "userLimitHelpMessage": "Solo los usuarios a nivel de subcuenta cuentan para este límite. Aún puede añadir tantos usuarios de la agencia a las subcuentas como necesite"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Estoy de acuerdo en habilitar Listados para este cliente sin ventas adicionales y entiendo que se me cobrará",
          "deployDirectly": "Desplegar listados directamente",
          "deployDirectlyDesc": "Utilice esta opción si ofrece Listados como parte de su oferta o si desea facturar externamente a su cliente",
          "minimumCommitment": "con un período de compromiso mínimo de un mes.",
          "offerListings": "Listados de ofertas",
          "resellListings": "Listados de reventa",
          "subscribedInfo": "{withoutUpsell} Sin venta adicional, {withUpsell} con venta adicional y {withSaas} con el paquete Saas",
          "subscriptionCreated": "Suscripción creada correctamente. Espere...",
          "subscriptionCreating": "La suscripción se está creando.<br/>No actualice la página ni pulse el botón Atrás",
          "unableToCreate": "No se ha podido crear la suscripción. Póngase en contacto con el servicio de asistencia",
          "unavailabilityForAgencyAdmin": "Yext no está disponible en este país. Si cree que se trata de un error, solicítelo en nuestra hoja de ruta en",
          "yourResellOffer": "Su oferta de reventa"
        }
      },
      "selectCountry": "Seleccione su país",
      "documents": {
        "additionalInfo": "Información adicional",
        "createAddressLink": "Cree la dirección.",
        "createAddressPrompt": "Cree primero una dirección y luego proceda a la creación del paquete.",
        "selectAddress": "Seleccionar dirección:"
      }
    },
    "triggers": {
      "emptyTrigger": "Activador vacío"
    },
    "util": {
      "addFiles": "+ añadir archivos",
      "fillValues": "Rellenar valores",
      "image": "imagen",
      "ok": "Aceptar",
      "pleaseTypeOrCancel": "Escriba {consentString} arriba o cancele esta acción.",
      "pressEnterToAddCustomOption": "Pulse Intro para añadir una opción personalizada",
      "required": "* obligatorio",
      "unsaved": "Sin guardar"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Para activar el flujo de trabajo para una ubicación, vaya a la pestaña de Cuentas, haga clic en el icono de tres puntos a la derecha de una subcuenta y seleccione <strong>Activar generador de flujos de trabajo</strong>. Este proceso es temporal, ya que los flujos de trabajo se publicarán en todas las ubicaciones la próxima semana."
      },
      "faq": "Preguntas frecuentes",
      "gotIt": "Entendido",
      "workflowIsLive": "¡El flujo de trabajo está activo en su cuenta!"
    },
    "action": {
      "stats": {
        "bounced": "Rebotado",
        "clicked": "Clicado",
        "delivered": "Entregado",
        "opened": "Abierto",
        "replied": "Respondido",
        "unsubscribed": "Suscripción cancelada",
        "total": "Total",
        "failed": "Error"
      },
      "actions": {
        "edit": "Editar",
        "send": "Enviar",
        "remove": "Eliminar"
      },
      "timing": {
        "days": "Días",
        "immediately": "Inmediatamente",
        "before": "Antes",
        "after": "Después",
        "minutes": "Minutos",
        "hours": "Horas"
      },
      "labels": {
        "template": "Plantilla",
        "manual": "Manual"
      },
      "details": {
        "hideDetail": "Ocultar detalle",
        "showDetail": "Mostrar detalle"
      },
      "queue": {
        "people": "personas",
        "person": "persona",
        "queued": "en cola"
      },
      "tooltips": {
        "clickedHelp": "La precisión del seguimiento de clics puede variar según el cliente de correo electrónico y la configuración del usuario.",
        "statsAccuracy": "La precisión de las estadísticas puede variar según el cliente de correo electrónico y la configuración del usuario."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "¿Seguro que quiere eliminar esta solicitud masiva?",
        "startImmediately": "Comenzar inmediatamente"
      },
      "modal": {
        "contactTypes": {
          "all": "Todo",
          "leads": "Clientes potenciales",
          "customers": "Clientes"
        },
        "buttons": {
          "cancel": "Cancelar",
          "update": "Actualizar",
          "add": "Añadir"
        },
        "labels": {
          "name": "Nombre",
          "contactType": "Tipo de contacto",
          "campaign": "Campaña",
          "scheduledDate": "Fecha programada",
          "tag": "Etiqueta"
        },
        "placeholders": {
          "tags": "Etiquetas",
          "selectCampaign": "Seleccionar campaña",
          "pickType": "Seleccionar tipo"
        },
        "sections": {
          "bulkRequest": "Solicitud masiva",
          "whoShouldRun": "¿Para quién debería ejecutarse?"
        },
        "titleAdd": "Añadir solicitud masiva",
        "titleEdit": "Editar solicitud masiva",
        "validation": {
          "scheduledDateRequired": "Fecha de programación obligatoria"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Mostrar más"
    },
    "list": {
      "confirmDeleteFolder": "Confirmar eliminación de carpeta",
      "delete": "Eliminar",
      "confirmDelete": "¿Seguro que quiere eliminar esta campaña?",
      "moveToFolder": "Mover a carpeta",
      "pleaseRename": "cambie el nombre",
      "removeFromFolder": "Eliminar de la carpeta"
    },
    "copy": {
      "title": "Copiar campaña",
      "newCampaignName": "Nombre de la nueva campaña",
      "locations": "Ubicaciones"
    }
  },
  "compliance": {
    "findOutMore": "Descubra más",
    "gdprDescription": "Nos tomamos muy en serio la protección de sus datos personales y los de sus clientes y tratamos los datos personales de forma muy confidencial y de acuerdo con la normativa legal de protección de datos y esta declaración de protección de datos",
    "gdprTitle": "Conformidad con RGPD",
    "hipaaDescription": "Active las mejoras de seguridad para garantizar que los datos de su cuenta HighLevel estén seguros y cumplan con los requisitos de la HIPAA",
    "hipaaTitle": "Conformidad con HIPAA"
  },
  "customValues": {
    "key": "Clave",
    "selectedItemsCountSingular": "{count} fila seleccionada",
    "selectedItemsCountPlural": "{count} filas seleccionadas"
  },
  "facebookAdFields": {
    "checkIcon": "El formulario se ha asignado correctamente",
    "errorMessage": "La clave de acceso a la página ha caducado o no tiene suficientes permisos. Asegúrese de tener acceso de administrador a las páginas."
  },
  "fbLeadSync": {
    "confirmTitle": "¿Confirmar la sincronización de clientes potenciales de Facebook?",
    "impactMessage": "Comprenda el impacto de la sincronización de los clientes potenciales de Facebook antes de continuar:",
    "observations": "1. Esto sincronizará los clientes potenciales de Facebook y creará nuevos contactos para cada cliente potencial generado en los últimos {days} días que no exista en su lista de contactos. <br>2. Si ha importado manualmente clientes potenciales faltantes usando CSV exportado desde el Administrador de anuncios de Facebook, deshabilite la opción «Permitir contactos duplicados» para evitar que la sincronización cree contactos duplicados. <br>3. Si tiene flujos de trabajo que se activan al <b>crear contactos</b> o enviar <b>el formulario de captación de clientes potenciales de Facebook enviado</b>, se activarán por cada nuevo contacto creado. <br>4. Los contactos existentes creados a través de Clientes potenciales de Facebook no se verán afectados. <br>5. La hora de creación del contacto en el registro será la hora actual. <br>6. La sincronización puede tardar hasta una hora en completarse, dependiendo del número de clientes potenciales que aún no se hayan sincronizado. <br>",
    "proceedQuestion": "¿Desea continuar con la sincronización de clientes potenciales de Facebook?"
  },
  "integrationAI": {
    "accountDisconnected": "¡Cuenta desconectada!",
    "appNotFound": "No se ha encontrado el ajuste de la aplicación. Utilización de datos alternativos.",
    "checkingConnection": "Comprobando el estado de la conexión...",
    "connecting": "Conectando...",
    "disconnectApp": "Desconectar aplicación",
    "disconnecting": "Desconectando...",
    "loadingAppInfo": "Cargando detalles de la aplicación…",
    "refreshConnection": "Actualizar conexión",
    "refreshing": "Actualizando...",
    "svgNotAvailable": "SVG no disponible"
  },
  "phoneSystem": {
    "additionalSettings": "Configuraciones adicionales",
    "messaging": "Mensajes",
    "messagingAnalytics": "Analíticas de mensajería",
    "regulatoryBundles": "Paquetes regulatorios",
    "title": "Sistema telefónico",
    "trustCenter": "Centro de confianza",
    "voice": "Voz"
  },
  "demo": {
    "draggable": {
      "title": "Prueba de componentes arrastrables",
      "usingVue3": "Uso de arrastrables compatibles con Vue 3",
      "description": "Este componente utiliza ahora el componente arrastrable revisado compatible con Vue 3.",
      "buttons": {
        "resetAllLists": "Restablecer todas las fichas",
        "clearLog": "Borrar Registro",
        "stopLoading": "Detener la carga",
        "simulateLoading": "Simular la carga",
        "refreshData": "Actualizar datos"
      },
      "examples": {
        "basicDraggable": "Arrastrable básico",
        "draggableWithElement": "Arrastrable con elemento",
        "draggableWithTransitionGroup": "Arrastrable con el grupo de transición",
        "draggableWithMoveFunction": "Arrastrable con función de paso"
      },
      "eventLog": "Registro de Eventos",
      "handle": "Handle",
      "name": "Nombre",
      "cannotMove": "(no puede moverse)"
    },
    "tableDemo": {
      "title": "Demostración de Vue 3 UIBTable",
      "basicControls": "Controles básicos",
      "labels": {
        "filter": "Filtrar:",
        "sortBy": "Filtrar Vía:",
        "sortDirection": "Dirección de la ordenación:",
        "perPage": "Por página:",
        "tableStyling": "Estilo de tabla:"
      },
      "placeholders": {
        "typeToSearch": "Escribir para buscar..."
      },
      "checkboxLabels": {
        "striped": "A rayas",
        "bordered": "Con borde",
        "hover": "Pasar por encima",
        "small": "Pequeño",
        "responsive": "Adaptable"
      },
      "fields": {
        "id": "Id.",
        "name": "Nombre",
        "email": "Correo electrónico",
        "status": "Estado",
        "created": "Creado",
        "actions": "Acciones"
      },
      "statuses": {
        "active": "Activo",
        "inactive": "Adaptativo",
        "pending": "Pendiente",
        "banned": "Vetado"
      },
      "modal": {
        "title": "Detalles del artículo",
        "close": "Cerrar"
      },
      "messages": {
        "confirmDelete": "¿Seguro que desea eliminar {name}?",
        "editItem": "Editar el artículo {id}",
        "showingItems": "Mostrando {count} de {total} artículos"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Guardar y continuar",
      "everythingIn": "Todo en <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "añada aquí la tarjeta de crédito",
        "message": "Pídale a su cliente que",
        "title": "La ubicación precisa que se añada primero un método de pago."
      },
      "noSaasPlan": {
        "linkText": "cree aquí sus planes SaaS.",
        "message": "Por favor,",
        "title": "No tiene configurado ningún plan SaaS."
      },
      "saasModeSetupPendingWarning": "El plan SaaS se activará una vez que el cliente haya añadido un método de pago. Hasta entonces, el acceso a su cuenta estará restringido.",
      "skipForNow": "Saltar por ahora",
      "skipPlan": "Saltar plan"
    }
  },
  "isv": {
    "business_registration_id_type": "Tipo de ID de registro de la empresa",
    "business_registration_number": "Número de registro de la empresa",
    "business_website": "Sitio web de la empresa",
    "enter_your_business_registration_id_type": "Introduzca el tipo de ID de registro de su empresa",
    "name_of_other_registration_id_type": "Nombre de otro tipo de ID de registro",
    "pick_business_industry": "Seleccionar sector de la empresa",
    "pick_business_registration_id_type": "Seleccionar tipo de ID de registro de la empresa",
    "emailWithStar": "Correo electrónico*",
    "businessIndustry": "Sector empresarial*",
    "businessType": "Tipo de empresa*",
    "regionsOfOperations": "Regiones de operación de la empresa*",
    "registrationNumber": "Número de registro de la empresa*",
    "registrationNumberHelper": "El número utilizado para identificar su empresa. En el caso del EIN de EE. UU., debe ser un número de 9 dígitos, por ejemplo, 12-3456789.",
    "businessWebsiteWithStar": "Sitio web de la empresa*",
    "businessTypeWithStar": "Tipo de empresa",
    "businessWebsite": "Sitio web de la empresa"
  },
  "aiProductRebilling": {
    "enableRebilling": "Habilitar la refacturación",
    "ratesMayDiffer": "Las tarifas pueden diferir según la región. Los cálculos mostrados son por las tarifas para el Reino Unido,",
    "supportDoc": "documento justificante",
    "cancel": "Cancelar",
    "profit": "Beneficio",
    "chargedToCustomer": "Cobrado al cliente",
    "enabling": "Habilitando...",
    "forMore": "para obtener más información.",
    "rebillAmount": "Importe de la refacturación",
    "tenDollarsWillGive": "Con 10 dólares obtendrá unos",
    "yourCost": "Su coste",
    "clientBillingPage": "página de facturación de la empresa del cliente",
    "needStripeConnection": "Para activar la refacturación, debe conectar su cuenta de Stripe",
    "per1000Words": "por 1000 palabras",
    "perImage": "por imagen",
    "perReviewResponse": "por respuesta a reseña",
    "perFunnel": "por embudo",
    "minimumBetween": "El mínimo debe estar entre {min} y {max}",
    "images": "imágenes",
    "reviewResponse": "respuesta a reseña",
    "funnel": "embudo",
    "pleaseCheckSupport": "compruebe"
  },
  "a2p": {
    "otpSuccess": {
      "title": "Éxito de OTP",
      "message": "Mensaje de éxito de OTP"
    },
    "otpError": {
      "title": "Error de OTP",
      "message": "Mensaje de error de OTP"
    },
    "businessProfileError": {
      "title": "Error en el perfil de empresa",
      "message": "Mensaje de error del perfil de empresa"
    },
    "addressError": {
      "title": "Error de Dirección",
      "status": "Estado de error de dirección"
    },
    "profileError": {
      "title": "Error de perfil A2P",
      "message": "Mensaje de error del perfil A2P"
    },
    "address": {
      "country": "País",
      "state": "Región/provincia/estado",
      "chooseCountry": "Seleccione un país…",
      "statePlaceholder": "Introduzca la región/provincia/estado",
      "chooseState": "Seleccione una región/provincia/estado…",
      "city": "Ciudad*",
      "postalCode": "Código postal*",
      "streetAddress": "Dirección postal*",
      "streetAddressHelper": "Debe ser una dirección válida vinculada a su empresa.",
      "title": "Dirección de la empresa"
    },
    "validation": {
      "brandNameRequired": "El nombre de la marca es obligatorio.",
      "businessVerticalRequired": "El vertical empresarial es obligatorio.",
      "cityRequired": "La ciudad es obligatoria.",
      "countryRequired": "El país es obligatorio.",
      "invalidMobileNumber": "Número de teléfono móvil no válido.",
      "mobileNumberRequired": "El número de móvil es obligatorio.",
      "postalCodeRequired": "El código postal es obligatorio.",
      "stateRequired": "La región/provincia/estado es obligatorio.",
      "streetAddressRequired": "La dirección postal es obligatoria."
    },
    "authorizedRep": {
      "email": "Correo electrónico*",
      "firstName": "Nombre*",
      "jobPosition": "Puesto de trabajo*",
      "jobTitle": "Cargo*",
      "jobTitlePlaceholder": "Introduzca el cargo",
      "lastName": "Apellidos*",
      "phoneNumber": "Número de teléfono*",
      "phoneNumberPlaceholder": "Introducir número de teléfono",
      "pickJobPosition": "Seleccionar puesto de trabajo",
      "title": "Información del representante autorizado"
    },
    "registration": {
      "stepProgress": "Paso {currentStep} de 8",
      "successTitle": "Su marca A2P y campaña ya se han enviado.",
      "successWaitDays": "7 días",
      "successWaitPrefix": "Podría tardar hasta ",
      "successWaitSuffix": " en aprobarse sus paneles de marca y otras 4-5 semanas en aprobarse la campaña.",
      "otpNote": "Nota: Recibirá un mensaje con el OTP en el número móvil que facilitó para verificar desde TCR. Responda Sí en un plazo de 24 horas desde la recepción del SMS."
    },
    "update": {
      "brandDetailsTitle": "Actualizar detalles de marca",
      "brandName": "Nombre de la marca*",
      "brandNameHelper": "Utilice el nombre legal de la organización que envía los mensajes o su propio nombre si esta marca no es para una organización.",
      "businessVerticals": "Sector empresarial*",
      "chooseVertical": "Seleccionar vertical...",
      "mobileNumber": "Número de móvil para verificación OTP (con código de país)*",
      "mobileNumberHelper": "Facilite un número de móvil al que tenga acceso para confirmar la verificación OTP. Solo se aceptan números de EE. UU./Canadá. No puede utilizar un número de teléfono CPaaS, como los obtenidos de LeadConnector. No puede usar el mismo número móvil para registrar más de 3 marcas de propietario único. Este límite lo gestiona TCR.",
      "updateButton": "Actualización",
      "retryOTPTitle": "Reintentar OTP",
      "retryOTPMessage": "Haga clic en el botón de abajo para reenviar el mensaje de verificación de la OTP.",
      "sending": "Enviando...",
      "resendOTP": "Reenviar la OTP"
    },
    "einModal": {
      "title": "¿Tiene usted un EIN?",
      "question": "¿Tiene un Número de Identificación del Empleador (EIN)?",
      "hasEIN": "Sí, tengo un EIN",
      "noEIN": "No, no tengo un EIN",
      "disableNoEINText": "EIN obligatorio para ubicaciones fuera de EE. UU./CA",
      "infoText": "Se requiere un EIN para las empresas en Estados Unidos y Canadá."
    },
    "brandDetails": {
      "brandHeading": "Detalles de marca",
      "brandName": "Nombre de marca*",
      "brandNameHelper": "Utilice el nombre legal de la organización que envía los mensajes o su propio nombre si esta marca no es para una organización.",
      "businessIndustry": "Sector de la empresa*",
      "chooseVertical": "Seleccione vertical…",
      "mobileNumber": "Número de móvil para verificación OTP (con código de país)*",
      "mobileNumberHelper": "Facilite un número de móvil al que tenga acceso para confirmar la verificación OTP. Solo se aceptan números de de EE. UU./Canadá. No puede usar un número de teléfono CPaaS como el que se obtiene en LeadConnector. No puede usar el mismo número móvil para registrar más de 3 marcas de propietario único. Este límite lo gestiona TCR.",
      "solePropBrand": {
        "heading": "Marca de propietario único",
        "point1": "Solo se permite 1 número de teléfono",
        "point2": "No se requiere EIN/SSN/DUNS",
        "subheading": "Registro de marca de propietario único"
      },
      "solePropCampaign": {
        "heading": "Campaña de propietario único",
        "point1": "Solo se permite vincular 1 número a una campaña de propietario único",
        "point2": "Una vez aprobado, su número predeterminado se vinculará automáticamente",
        "infoText": "También puede actualizar el número después de la aprobación",
        "warningText": "Solo se permite vincular un número a una campaña de propietario único. Una vez aceptado, su número por defecto se vinculará automáticamente. También puede actualizar el número después de la aprobación.",
        "subheading": "Registro de campaña de propietario único"
      },
      "solePropSubtitle": "Detalles de marca y campaña de propietario único",
      "standardBrand": {
        "heading": "4,41 $ - Una vez",
        "point1": "Se requiere EIN/SSN/DUNS",
        "point2": "Se permite más de 1 número de teléfono",
        "subheading": "Registro estándar de marca"
      },
      "standardCampaign": {
        "heading": "16,54 $ - Una vez",
        "point1": "Se permite vincular más de 1 número a una campaña estándar",
        "point2": "EIN/SSN/DUNS obligatorio",
        "infoText": "Se aplicará un cargo adicional de campaña de hasta 12 $ al mes conforme a las normas de TCR.",
        "subheading": "Registro estándar de campaña"
      },
      "standardSubtitle": "Detalles de marca y campaña estándar",
      "title": "Detalles de marca y campaña"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Detalles del caso práctico de campaña",
        "subtitle": "Introduzca los detalles y la descripción de la campaña",
        "useCase": "Caso práctico de campaña*",
        "pickUseCase": "Seleccionar caso práctico de campaña",
        "useCaseDescription": "Descripción del Caso de Uso*",
        "explainInDetail": "Explíquelo en detalle",
        "useCaseDescriptionPlaceholder": "Ejemplo: Esta campaña envía mensajes de información, confirmación y recordatorio de citas a nuestros clientes una vez que han reservado una cita con nosotros en nuestra web y han optado por recibir SMS promocionales y de notificación de nuestra parte.",
        "useCaseDescriptionHelper": "Proporcione una descripción detallada de cómo va a utilizar esta campaña.",
        "solePropLabel": "Propietario único",
        "seeExamples": "Ver ejemplos",
        "closeExamples": "Cerrar ejemplos"
      }
    }
  },
  "opportunities": {
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "status": "Estado",
    "contactType": "Tipo de contacto",
    "bulkOperation": "Operación masiva",
    "contactName": "Nombre del contacto",
    "unassigned": "Sin asignar",
    "abandoned": "Abandonado",
    "addOpportunityName": "Añadir nombre de la oportunidad",
    "companyName": "Nombre de la empresa",
    "contactInfo": "Información de contacto",
    "enterValue": "Introduzca un valor",
    "lost": "Perdido",
    "open": "Abrir",
    "opportunityInfo": "Información del cliente potencial",
    "opportunityName": "Nombre del cliente potencial",
    "opportunitySource": "Fuente del cliente potencial",
    "owner": "Propietario",
    "pipeline": "Secuencia",
    "selectPipeline": "Seleccionar secuencia",
    "selectStage": "Seleccionar etapa",
    "stage": "Paso",
    "won": "Ganado",
    "createdOn": "Fecha de creación",
    "goToContactDetail": "Ir a la página de detalles de contacto",
    "leadValue": "Valor del cliente potencial",
    "removeOwner": "Eliminar propietario",
    "createdBy": "Creado por",
    "notAllowedToChange": "No tiene permitido cambiar este contacto",
    "opportunityAlreadyExists": "Ya existe una oportunidad para este contacto en la secuencia seleccionada",
    "filters": {
      "all": "Todo",
      "statuses": {
        "all": "Todo",
        "open": "Abrir",
        "won": "Ganado",
        "lost": "Perdido",
        "abandoned": "Abandonado"
      },
      "search": "Buscar",
      "status": "Estado",
      "campaign": "Campaña",
      "owner": "Propietario",
      "pipeline": "Secuencia",
      "dateAddedAsc": "↑ Fecha de adición (ASC)",
      "dateAddedDesc": "↓ Día de adición (desc.)",
      "orderBy": "Ordenar por"
    },
    "columns": {
      "note": "Nota",
      "task": "Tarea",
      "companyName": "Nombre de la compañía",
      "additionalInfo": "Información adicional",
      "calendarEvent": "Evento del calendario",
      "hideAssignedTo": "Ocultar Asignado a",
      "hideTags": "Ocultar etiquetas"
    },
    "buttons": {
      "new": "Nuevo"
    },
    "dragActions": {
      "abandoned": "Abandonado",
      "lost": "Perdido",
      "won": "Ganado"
    },
    "getStarted": "¡Comience!",
    "noPipelines": "¡Vaya! Parece que no hay secuencias. Generar una nueva secuencia para",
    "addTask": "Añadir tarea",
    "tasksCount": "{count} tareas"
  },
  "appointmentDetails": "Detalles de la cita",
  "cloneFunnel": {
    "cloneButton": "Clonar {entityName}",
    "cloning": "Clonando...",
    "cloningLimit": "La clonación está limitada a 3 ubicaciones veces.",
    "error": "¡Error al clonar el embudo!",
    "locationsLabel": "Seleccionar ubicaciones",
    "nameLabel": "Nombre para el {entityName} clonado",
    "namePlaceholder": "Introduzca el nombre para el {entityName} clonado",
    "selectUpTo": "Seleccione hasta {maxSelectableLocations} ubicaciones",
    "title": "Clonar {entityName}"
  },
  "errors": "Errores",
  "renderEmailAddress": "Mostrar dirección de correo electrónico",
  "noPaymentMethodWarning": "Advertencia de falta de método de pago",
  "pageDetail": "Detalles de la página",
  "activityHistory": "Historial de Actividad",
  "uiAlert": "Alerta de IU",
  "eventModals": {
    "wait": {
      "save": "Guardar",
      "days": "Días",
      "fri": "Vie.",
      "mon": "Lun.",
      "sat": "Sáb.",
      "sun": "Dom.",
      "thu": "Jue.",
      "tue": "Mar.",
      "wed": "Mié.",
      "wait": "Esperar",
      "minutes": "Minutos",
      "hours": "Horas",
      "title": "Editar evento de espera",
      "whichDaysResume": "¿Qué días deberíamos reanudar?",
      "pickDayError": "Por favor, elija al menos un día",
      "whatTimeResume": "¿A qué hora deberíamos reanudar nosotros?"
    },
    "sms": {
      "send": "Enviar",
      "name": "Nombre",
      "attachFile": "Adjuntar archivo",
      "learnMore": "Más información",
      "sendTest": "Enviar una prueba",
      "title": "Editar evento de {eventType}",
      "titleTemplate": "Editar la plantilla {eventType}",
      "nameRequired": "El nombre es obligatorio",
      "pickTemplate": "Seleccionar plantilla",
      "appCharacters": "Caracteres de la aplicación",
      "numSegments": "Número de segmentos",
      "approximateCost": "Coste aproximado",
      "costEstimateNote": "Nota de estimación de costes",
      "urlAttachmentAutocompleteToken": "Adjunto de URL",
      "addFileUrl": "Añadir URL del archivo",
      "urlImageAlt": "URL de la imagen",
      "fileImageAlt": "Imagen de archivo",
      "enterMessage": "Introduzca mensaje",
      "mobilePhonePlaceholder": "Teléfono móvil",
      "unsupportedContentType": "Tipo de contenido no compatible: {fileType}",
      "urlAttachmentWarning": "Error al cargar {count} archivo{plural} adjunto{plural} de URL. ¿Quiere continuar?",
      "provideMobileNumber": "Proporcione un número de teléfono"
    },
    "email": {
      "text": "Texto",
      "checkLinks": "Compruebe los enlaces donde tiene un valor personalizado. Hay un \"%20\" adicional entre {{ y custom_values.",
      "errorOccurred": "Se ha producido un error. Inténtelo de nuevo.",
      "insertToAddress": "Introduzca una dirección de destinatario."
    },
    "voicemail": {
      "save": "Guardar",
      "dropFile": "Suelte el archivo aquí o haga clic para subirlo",
      "faq": "Preguntas frecuentes",
      "title": "Editar evento de mensaje de voz",
      "voicemailFile": "Archivo de mensaje de voz",
      "warning": "Advertencia: Los archivos de correo de voz deben estar en formato MP3, WAV o GSM.",
      "unsupportedFormat": "Formato de archivo no compatible. Utilice MP3, WAV o GSM."
    },
    "call": {
      "title": "Editar evento de llamada",
      "save": "Guardar",
      "name": "Nombre",
      "nameRequired": "El nombre es obligatorio",
      "callWhisper": "Susurro de llamada",
      "whisperMessage": "Mensaje susurrado",
      "thisIsTheMessage": "Este es el mensaje que se reproducirá al agente antes de conectar la llamada.",
      "callTimeoutS": "Tiempo de espera de llamada (s)",
      "timeoutSeconds": "Tiempo de espera (segundos)",
      "disableVoicemailDetect": "Deshabilitar la detección de mensajes de voz",
      "callWillPatchInstantly": "La llamada se conectará al instante sin detectar el mensaje de voz."
    }
  },
  "emailTemplate": {
    "createdOn": "Creada el",
    "updatedOn": "Fecha de actualización"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM Más información",
      "description": "Descripción de CNAM"
    },
    "submitted": {
      "checkStatus": "Consultar el estado de CNAM",
      "description": "El nombre de su empresa debería aparecer a los contactos correspondientes en unos 3-5 días.",
      "subtitle": "Su solicitud de CNAM ha sido enviada.",
      "title": "¡Felicidades!"
    },
    "registration": {
      "confirm": "Confirmar",
      "learnMore": "Más información",
      "characterLimit": "{count}/15",
      "title": "Registro de CNAM",
      "description": "Introduzca el nombre de su empresa (máximo 15 caracteres)",
      "warning": "Advertencia: El nombre de su empresa se mostrará en el identificador de llamadas. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Error de actualización",
      "message": "Mensaje de error de actualización"
    },
    "success": {
      "message": "Su marca A2P y campaña ya se han enviado.<br/><br/><b>Nota:</b> <b>Recibirá un mensaje con el OTP en el número móvil que facilitó para verificar</b> desde TCR. <b>Responda Yes en un plazo de 24 horas</b> desde la recepción del SMS.",
      "title": "Su marca A2P y campaña ya se han enviado. Puede tardar hasta <b>7 días</b> en aprobarse sus paneles de marca y otras 4-5 semanas en aprobarse la campaña."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Error del paquete regulatorio",
      "status": "Estado de error del paquete regulatorio"
    },
    "createAddress": {
      "successMessage": "Su marca A2P y campaña ya se han enviado.",
      "successTitle": "Dirección enviada correctamente",
      "underReview": "La dirección enviada está en proceso de revisión"
    },
    "createEndUser": {
      "dateFormat": "El formato de la fecha debe ser AAAA-MM-DD.",
      "phoneExample": " Ejemplo: +14155552671",
      "title": "Información de la empresa:"
    },
    "success": {
      "title": "Paquete de regulación enviado correctamente",
      "underReview": "Paquete enviado en proceso de revisión",
      "message": "Su solicitud de registro para SHAKEN/STIR ha sido enviada. Puede tardar hasta <b>3-4 días</b> en aprobarse. El estado se actualizará pronto."
    },
    "documents": {
      "additionalInfo": "Información adicional",
      "createAddressLink": "Cree la dirección.",
      "createAddressPrompt": "Cree primero una dirección y luego proceda a la creación del paquete.",
      "selectAddress": "Seleccionar dirección:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Esta opción añadirá una nueva dirección a su cuenta",
        "label": "Paquete de dirección"
      },
      "regulatoryBundle": {
        "description": "Esta opción le ayudará a crear un nuevo paquete regulatorio",
        "label": "Paquete regulatorio"
      },
      "title": "Seleccione el paquete que quiere añadir"
    },
    "modal": {
      "back": "Atrás",
      "next": "Siguiente",
      "submit": "Enviar",
      "title": "Nuevo Paquete Regulatorio",
      "description": "Cree un nuevo paquete regulatorio para su ubicación"
    }
  },
  "reminder": {
    "phone": "Teléfono",
    "noReplyYet": "Aún nadie ha respondido"
  },
  "sendGrid": {
    "apiKey": "Clave API de SendGrid",
    "save": "Guardar SendGrid",
    "apiKeyRequired": "Se requiere la clave API de SendGrid"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Actualizar",
      "subtitle": "Las agencias con plan profesional ganan unos 363 $ al mes refacturando los costes del teléfono a sus clientes",
      "title": "¿Quiere volver a facturar esto a sus clientes?"
    }
  },
  "emailField": {
    "label": "Correo electrónico",
    "placeholder": "Correo electrónico",
    "tooltip": {
      "primary": "Principal",
      "emails": "Correos electrónicos"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Cargar instantánea:",
    "loadSnapshotWarning": "¿Desea cargar la instantánea asociada a esta programación? <br /> <strong class='text-danger'>Los datos existentes pueden perderse</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Solo los administradores o usuarios de la agencia tienen acceso a esta subcuenta. En este momento, ni usted ni otros administradores o usuarios de la cuenta tienen acceso a esta subcuenta.",
      "heading": "Esta subcuenta se ha pausado."
    },
    "temporarily": {
      "description": "Todos sus datos están seguros y todos los activadores, campañas, etc., reanudarán su funcionamiento después de la activación.",
      "heading": " Su cuenta ha sido suspendida temporalmente."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Nombre comercial claro",
    "title": "Actualizar identificador de llamada"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Seleccionar oficina",
    "whichOffice": "¿A qué oficina desea vincular esta cuenta?",
    "connect": "¡Conectar!"
  },
  "phoneField": {
    "label": "Teléfono",
    "placeholder": "Número de teléfono",
    "tooltip": {
      "invalidNumber": "Número de teléfono no válido",
      "notSmsCapable": "Este número {type} no es compatible con SMS."
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Detalles de la reserva",
      "form": "Formulario",
      "quiz": "Cuestionario",
      "submissionDetail": "Detalle de la presentación",
      "survey": "Encuesta"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Su solicitud de registro para SHAKEN/STIR ha sido enviada. Puede tardar hasta <b>3-4 días</b> en aprobarse. El estado se actualizará pronto.",
      "title": "Llamadas fiables SHAKEN/STIR habilitadas."
    },
    "modal": {
      "andThe": " y el ",
      "businessProfile": "Perfil de empresa",
      "certification": "Certifico que el perfil de empresa asociado es el origen de las llamadas telefónicas y certifico que participaré en los esfuerzos de rastreo, incluidos aquellos iniciados por el",
      "failedTitle": "El envío ha fallado",
      "friendlyName": "Nombre descriptivo",
      "friendlyNamePlaceholder": "Ejemplo: SHST 2022-11-24 a las 19:47:14",
      "linkInfo": {
        "description": "Todos los números disponibles actuales y futuros comprados se registrarán automáticamente en SHAKEN/STIR.",
        "title": "Todos los números se vincularán automáticamente"
      },
      "stiPa": "Administrador de políticas de identidad telefónica segura (STI-PA)",
      "subtitle": "Introduzca los detalles y la descripción",
      "successMessage": "Su solicitud de registro para SHAKEN/STIR ha sido enviada. Puede tardar hasta <b>3-4 días</b> en aprobarse. El estado se actualizará pronto.",
      "successTitle": "Llamadas fiables SHAKEN/STIR habilitadas.",
      "title": "Habilitar llamadas fiables SHAKEN/STIR",
      "tracebackGroup": "Grupo de rastreo de telecomunicaciones de EE. UU."
    },
    "withCnam": {
      "cnamPromo": "Regístrese en CNAM para mostrar el nombre de su empresa en el identificador de llamadas",
      "registerCnam": "Registrar CNAM"
    }
  },
  "task": {
    "2day": "2 días",
    "3day": "3 días",
    "4day": "4 días",
    "5day": "5 días",
    "addTask": "Añadir tarea",
    "countTasks": "{count} tareas"
  },
  "updatedProductsModal": {
    "title": "Productos Actualizados",
    "copyDirectSaleLink": "Copiar enlace de venta directa",
    "setupFeeInstruction": "La tarifa de configuración se puede configurar en el tablero de Stripe. ",
    "doNotDeleteWarning": "No elimine productos ni precios del tablero de Stripe. Esto hará que la integración deje de funcionar."
  },
  "termsOfService": {
    "privacyLink": "Política de privacidad",
    "accept": "Aceptar",
    "termsLink": "Términos de servicio",
    "updateMessage": "Hemos actualizado nuestras Condiciones de Servicio y Política de Privacidad. Por favor, revise y acepte para continuar.",
    "agreementPrefix": "Al continuar, usted acepta nuestros ",
    "agreementConjunction": " y "
  },
  "callerIdVerificationModal": {
    "answerCall": "Responda a la llamada e introduzca este código de verificación:",
    "leadConnectorCalling": "El conector de clientes potenciales está llamando...",
    "title": "Añadir un identificador de llamada por voz",
    "waitingForVerification": "Esperando la verificación..."
  },
  "emailOTPModal": {
    "confirmCode": "Confirmar código",
    "resendCode": "Si no ha recibido el código, haga clic aquí para reenviarlo"
  },
  "survey": {
    "copy": {
      "cancel": "Cancelar",
      "location": "Ubicación",
      "copy": "Copiar",
      "newSurveyName": "Nuevo nombre de la encuesta",
      "title": "Copiar encuesta",
      "locationRequired": "La ubicación es obligatoria"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Nombre del producto",
    "planDetails": "Detalles del plan",
    "title": "Descripción del producto",
    "planId": "ID de Plan",
    "copiedToClipboard": "Copiado en el portapapeles"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Más Eficiente",
      "faster": "Más rápido",
      "itsText": "Es",
      "smoother": "Más fluido",
      "title": "¡Ya está aquí una nueva experiencia de importación!",
      "warningMessage": "Habilitar la nueva experiencia de importación habilita Labs para esta subcuenta y activa la función Beta.",
      "tryNow": "Probar ahora"
    },
    "validateEmails": "¿Validar correos electrónicos?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "Precio de HighLevel",
      "howDoesItWork": "¿Cómo funciona?",
      "payNow": "Pagar ahora",
      "priceError": "El precio debe ser mayor o igual al precio de HighLevel",
      "saving": "Guardando",
      "yourPrice": "Su precio",
      "yourProfit": "Su beneficio",
      "subscriptionCreating": "La suscripción se está creando.<br/>No actualice la página ni pulse el botón «Atrás»",
      "subscriptionCreated": "Suscripción creada correctamente. Espere...",
      "unableToCreate": "No se ha podido crear la suscripción. Póngase en contacto con el servicio de asistencia",
      "perMonth": "por mes",
      "agreeToEnable": "Estoy de acuerdo en habilitar Listados para este cliente sin ventas adicionales y entiendo que se me cobrará",
      "deployDirectly": "Desplegar listados directamente",
      "deployDirectlyDesc": "Utilice esta opción si ofrece Listados como parte de su oferta o si desea facturar externamente a su cliente",
      "minimumCommitment": "con un periodo de compromiso mínimo de un mes.",
      "offerListings": "Listados de ofertas",
      "resellListings": "Listados de reventa",
      "subscribedInfo": "{withoutUpsell} Sin venta adicional, {withUpsell} Con venta adicional y {withSaas} Con el paquete Saas",
      "yourResellOffer": "Su oferta de reventa"
    }
  }
}
